import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { MdSearch } from "react-icons/md";
import { fetchAllFinancial } from "../../../../../store/slices/editFinanceSlice";
import { fetchLeads, fetchEmployeeAuthData, invalidateLeadsCache, updateLead, updateQuotedExpense } from "../../../../../store/slices/leadsSlice";
// import FinanceDash from "../../../../../components/features/finance/financel3/FinanceDash";
import { fetchGroups } from "../../../../../store/slices/groupSlice";
// import SalesFinance from "./SalesFinance";
// import SalesPiechart from "../PiechartSalesFinance/SalesPiechart";
// import SearchSalesGrossProfit from "../PiechartSalesFinance/SearchSalesGrossProfit";
// import SearchedSalesNetMargin from "../PiechartSalesFinance/SearchedSalesNetMargin";
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { fetchAllProjects } from "../../../../../store/slices/projectsSlice";
import { setOtheeExpensesData } from "../../../../../store/slices/filteredDataSlice";
import { fetchEmployees } from "../../../../../store/slices/employeeAdminSlice";
import { fetchWorkEntries } from "../../../../../store/slices/workentriesSlice";
import { fetchHardwareDescriptions } from "../../../../../store/slices/hardwareDescriptionSlice";
import { fetchDescriptionTasks } from "../../../../../store/slices/DescriptionTask";
import { fetchQuotations } from "../../../../../store/slices/hourlyRates";
import { fetchOtherExpenses } from "../../../../../store/slices/otherexpenses";
import { fetchSalesTaxes } from "../../../../../store/slices/salesTaxesSlice";
import { useSnackbar } from "notistack";
import { fetchCompanyProfiles } from "../../../../../store/slices/companyProfileSlice";
import AllServiceTable from "./AllServiceTable";
// import SliderValueLabel from "@mui/material/Slider/SliderValueLabel";
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import Quotation from "./Quotation";
import SalesFinanceEfforts from "./SalesFinanceEfforts";
import HardwareTypeServiceTable from "./HardwareTypeServiceTable";
import SoftwareTypeServiceTable from "./SoftwareTypeServiceTable";
import ActualFinaceTable from "./ActualFinaceTable";
import { useCurrencySymbol } from "../../../../../utils/currencyUtils";
import CommaConvert from "../../../../../utils/CommaConvert";
import { updateCostPerService } from "../../../../../store/slices/costPerServiceUpdateSlice";
import { fetchSalesHourlyRates } from "../../../../../store/slices/salesHourlyRateSlice";
import FinanceGraph from "./FinanceGraph";
import { hasViewOrFullAccess, getFeatureAccessLevel } from "../../../../../utils/featureAccessUtils";
import { isDirectWonLead, getLeadQuotedExpenseNum } from "../../../../../utils/isDirectWonLead";
import { getMyTrainings } from "../../../../../store/slices/MyTraining/myTrainings";
import axiosInstance from "../../../../../config/axiosConfig";
import config from "../../../../../config/api";
import {
  buildGroupedProjectsForProjectRequests,
  isLeadStillInProjectRequestsBucket,
} from "../../../../../utils/projectRequestsBucketUtils";
import { updateSalesMarginforprojectThunk } from "../../../../../store/slices/projectQuoteSlice";
import {
  getLoggedSalesUserId,
  getPerdiemAndAverageCostFromExpenses,
  scopeOtherExpensesForUser,
  scopeSalesHourlyRatesForUser,
} from "../../../../../utils/salespersonRatesScope";
import { ValidDate } from "../../../../../utils/DateUtils";
// import CloudTypeServiceTable from "./CloudTypeServiceTable";

/** Same normalization as AllServiceTable.jsx for SP hourly rate keys */
function normalizeDesignationForPL(name) {
  return (name ?? "")
    .toString()
    .toLowerCase()
    .replace(/\d+/g, "")
    .replace("manager", "project manager")
    .replace("employee", "operations")
    .trim();
}

function getRowIsProjectQuoted(row) {
  if (row == null) return false;
  if (typeof row.isProjectQuoted === "boolean") return row.isProjectQuoted;
  if (row.isProjectQuoted === 1) return true;
  if (String(row.isProjectQuoted || "").toLowerCase() === "true") return true;
  return false;
}

/** Lead schema uses quotedExpense; API may send alternate casings */
function getLeadQuotedExpenseValue(lead) {
  if (lead == null || typeof lead !== "object") return 0;
  const raw =
    lead.quotedExpense ??
    lead.QuotedExpense ??
    lead.quoted_expense;
  if (raw === undefined || raw === null || raw === "") return 0;
  const n = Number(raw);
  return Number.isFinite(n) ? n : 0;
}

function buildProjectPersonServiceMapFromQuotation(quotationScope) {
  const map = new Map();
  const quotationPersonProjectMap = new Map();
  const personTargetsMap = new Map();
  const personScopedTargetsMap = new Map();
  const normalize = (v) => String(v || "").trim().toLowerCase();

  Object.entries(quotationScope || {}).forEach(([filteredKey, serviceTypes]) => {
    const normalizedFilteredKey = normalize(filteredKey);
    Object.entries(serviceTypes || {}).forEach(([typeService, serviceRows]) => {
      (serviceRows || []).forEach((row) => {
        const projectId = String(row?.ProjectID || "").trim();
        if (!projectId) return;
        const quotationId = String(
          row?.quotationId ||
            row?.QuotationID ||
            row?.quotationid ||
            filteredKey ||
            ""
        ).trim();
        const normalizedQuotationId = normalize(quotationId || filteredKey);

        const addPersonService = (personIdRaw) => {
          const personId = String(personIdRaw || "").trim();
          if (!personId) return;
          const normalizedPersonId = normalize(personId);
          const key = `${projectId}::${personId}`;
          if (!map.has(key)) map.set(key, new Set());
          map.get(key).add(typeService);
          if (quotationId) {
            const qKey = `${quotationId}::${personId}`;
            if (!quotationPersonProjectMap.has(qKey)) {
              quotationPersonProjectMap.set(qKey, new Map());
            }
            const projectServiceMap = quotationPersonProjectMap.get(qKey);
            if (!projectServiceMap.has(projectId)) {
              projectServiceMap.set(projectId, new Set());
            }
            projectServiceMap.get(projectId).add(typeService);
          }
          if (normalizedPersonId) {
            if (!personTargetsMap.has(normalizedPersonId)) {
              personTargetsMap.set(normalizedPersonId, []);
            }
            personTargetsMap.get(normalizedPersonId).push({
              projectId,
              typeService,
              quotationKeys: [normalizedQuotationId, normalizedFilteredKey].filter(Boolean),
            });
            if (!personScopedTargetsMap.has(normalizedPersonId)) {
              personScopedTargetsMap.set(normalizedPersonId, []);
            }
            personScopedTargetsMap.get(normalizedPersonId).push({
              projectId,
              typeService,
            });
          }
        };

        (row?.WorkEntries || []).forEach((entry) => addPersonService(entry?.taskownerid));
        (row?.Assignedperson || []).forEach((person) =>
          addPersonService(person?.personid || person?._id)
        );
      });
    });
  });

  return {
    byProjectPerson: map,
    byQuotationPerson: quotationPersonProjectMap,
    byPerson: personTargetsMap,
    byPersonScoped: personScopedTargetsMap,
  };
}

const SalesFinaceFilter = () => {
  const dispatch = useDispatch();
  const currency = useCurrencySymbol();
  const { enqueueSnackbar } = useSnackbar();
  const USAComma = useMemo(() => CommaConvert(), []);

  const [financeTab,] = useState("table");
  const [showAllLeadTable, setShowAllLeadTable] = useState(true);
  const [calculationTable, setCalculationTable] = useState(false);
  const [l3Leads, setL3Leads] = useState([]);
  const [loggedUserData, setLoggedUserData] = useState([]);
  const [GroupNamesL3, setGroupNamesL3] = useState([]);
  const [isGroupOpen, setIsGroupOpen] = useState(false);
  const [showClientDropdown, setShowClientDropdown] = useState(false);
  const [selectedProjectName, setSelectedProjectName] = useState({});
  const [AssignedGroup, setAssignedGroup] = useState("All");

  // P&L table: quotationId is the mandatory primary key for project rows when present; ProjectName is secondary
  const getRowKey = useCallback((row) =>
    row?.quotationId != null && String(row.quotationId).trim() !== ""
      ? String(row.quotationId).trim()
      : row?.ProjectName ?? ""
  , []);

  // UI/state key must be stable across refreshes (quotationId can appear/disappear). Prefer backend id.
  const getStableLeadKey = useCallback((row) => {
    const id = row?.id ?? row?._id;
    if (id != null && String(id).trim() !== "") return String(id).trim();
    const qid =
      row?.quotationId != null && String(row.quotationId).trim() !== ""
        ? `qid:${String(row.quotationId).trim()}`
        : null;
    if (qid) return qid;
    return `pn:${String(row?.ProjectName ?? "").trim()}`;
  }, []);

  const [clientFilter, setClientFilter] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [yearData, setYearData] = useState([]);
  const [isYearOpen, setIsYearOpen] = useState(false);
  // const [expandedYear, setExpandedYear] = useState(null);
  const [selectedYears, setSelectedYears] = useState(["2026"]);
  const [searchedLeadReports, setSearchedLeadReports] = useState([]);
  const [searchedLeadReportswithoutyears, setSearchedLeadReportswithoutyears] = useState([]);
  const dropdownRefclient = useRef(null);

  // Map P&L rowKey (quotationId/ProjectName) -> stable lead id key for persisted UI state.
  const rowKeyToStableKey = useMemo(() => {
    const m = {};
    (searchedLeadReports || []).forEach((lead) => {
      const rk = getRowKey(lead);
      if (!rk) return;
      m[String(rk).trim()] = getStableLeadKey(lead);
    });
    return m;
  }, [searchedLeadReports, getRowKey, getStableLeadKey]);

  const rowKeyIsQuotedMap = useMemo(() => {
    const m = {};
    (searchedLeadReports || []).forEach((lead) => {
      const rk = getRowKey(lead);
      if (!rk) return;
      m[String(rk).trim()] = getRowIsProjectQuoted(lead);
    });
    return m;
  }, [searchedLeadReports, getRowKey]);

  const AssociatedRef = useRef(null);
  const [selectedServiceTypes, setSelectedServiceTypes] = useState([]);
  const [filteredQuotation, setFilteredQuotation] = useState(null);
  const [tableServiceTotals, setTableServiceTotals] = useState({});
  const [itemizedTotalsByProject, setItemizedTotalsByProject] = useState({});
  // const [isLoading, SetisLoading] = useState(false);

  const [GandATax, setGandATax] = useState(15);
  const [taxValue, setTaxValue] = useState(27);
  const { group } = useSelector((state) => state.group);
  const { leads, allLeads, empGroups: leadsEmpGroups } = useSelector((state) => state.leads);
  const { taxes } = useSelector((state) => state.salesTaxes);
  const { projects } = useSelector((state) => state.projects);
  const { profiles } = useSelector(state => state.companyProfile);
  const { entries } = useSelector((state) => state.workentries);
  const { items } = useSelector((state) => state.hardwareDescription);
  const { tasks } = useSelector((state) => state.descriptionTasks);
  const { mytrainings } = useSelector((state) => state.myTrainings);
  const { trainings: myTrainingsCreateList } = useSelector((state) => state.myTrainingsCreate || {});
  const { data: salesHourlyRateData, loading: salesHourlyRateLoading } = useSelector(
    (state) => state.salesHourlyRate
  );
  const { quotations: hourlyRateQuotations } = useSelector((state) => state.hourlyRateQuotation);
  const { activeSection } = useSelector((state) => state.scroll);
  const { session } = useSelector((state) => state.session);

  useEffect(() => {
    dispatch(fetchEmployees());
    dispatch(fetchWorkEntries());
    dispatch(fetchAllProjects());
    dispatch(fetchHardwareDescriptions());
    dispatch(fetchDescriptionTasks());
    dispatch(fetchQuotations());
    dispatch(fetchOtherExpenses());
    dispatch(fetchSalesTaxes());
    dispatch(fetchAllFinancial());
    dispatch(setOtheeExpensesData())
    dispatch(fetchCompanyProfiles());
    dispatch(fetchSalesHourlyRates());
    dispatch(getMyTrainings());
    fetchAllTrainingsForPl();
  }, [dispatch]);

  // When user clicks another sidebar option: close Itemized P&L and reset P&L state so next click on P&L gets fresh data
  useEffect(() => {
    if (activeSection != null && activeSection !== "Profit and Loss Tracker") {
      setSelectedProjectName({});
      setCalculationTable(false);
    }
  }, [activeSection]);

  // When user clicks "Profit and Loss Tracker" in sidebar: always refresh data
  useEffect(() => {
    if (activeSection === "Profit and Loss Tracker") {
      dispatch(invalidateLeadsCache());
      dispatch(fetchEmployeeAuthData()).then((result) => {
        if (fetchEmployeeAuthData.fulfilled.match(result)) {
          dispatch(fetchLeads());
          return;
        }
        const role = localStorage.getItem("userRole") || localStorage.getItem("auth");
        if (role && role !== "L3") {
          dispatch(fetchLeads());
        }
      });
      dispatch(fetchGroups());
      dispatch(fetchSalesHourlyRates());
      dispatch(getMyTrainings());
      fetchAllTrainingsForPl();
    }
  }, [activeSection, dispatch]);

  const { employees } = useSelector((state) => state.employees);
  const { items: otherExpenses } = useSelector((state) => state.otherExpenses);
  const loggedInUserId = useSelector((state) => state.leads.loggedInUserId);

  const pkgNormalized = String(profiles?.[0]?.subscriptionpackage || "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();
  const isErpPackage = pkgNormalized.includes("erp");
  const isCrmPackage =
    pkgNormalized === "crm" ||
    pkgNormalized.includes("crm") ||
    (pkgNormalized.length > 0 && !pkgNormalized.includes("erp")) ||
    (pkgNormalized.length === 0);
  const loggedEmail = typeof localStorage !== "undefined" ? localStorage.getItem("email") : "";
  const currentEmployeeForPL = employees?.find(
    (e) => (e.EmpEmail || "").trim().toLowerCase() === (loggedEmail || "").trim().toLowerCase()
  );

  // Same rule as canSeeActualTab (computed early for Quoted filtering).
  // When Actual is available, exclude direct-won leads from Quoted.
  // CRM subscription package never gets the Actual tab.
  const routeDirectWonToActualTab = useMemo(() => {
    const emp = currentEmployeeForPL;
    if (isCrmPackage) return false;
    if (!emp) return true;
    const hasFa =
      Array.isArray(emp?.featureAccess) && emp.featureAccess.length > 0;
    if (!hasFa) return true;
    if (emp?.EmpAuthLevel === "L1") return true;
    return hasViewOrFullAccess(emp, "PROFIT AND LOSS TRACKER ACTUAL");
  }, [currentEmployeeForPL, isCrmPackage]);

  const authLevelForPlData = String(
    currentEmployeeForPL?.EmpAuthLevel ??
      session?.auth ??
      (typeof localStorage !== "undefined" ? localStorage.getItem("auth") : "")
  )
    .trim()
    .toUpperCase();
  const isFinanceWithPL =
    authLevelForPlData === "L0" ||
    hasViewOrFullAccess(currentEmployeeForPL, "PROFIT AND LOSS");

  const loggedUserIdForRates = useMemo(
    () => getLoggedSalesUserId(loggedInUserId, employees, loggedEmail),
    [loggedInUserId, employees, loggedEmail]
  );
  const isL3SalesUser = authLevelForPlData === "L3";

  const spRateMap = useMemo(() => {
    const rates = scopeSalesHourlyRatesForUser(salesHourlyRateData, {
      loggedUserId: loggedUserIdForRates,
      isL3User: isL3SalesUser,
      onlyWhenL3: true,
    });
    const nextMap = {};
    rates.forEach((item) => {
      const key = (item?.designation ?? "").toString().toLowerCase().trim();
      if (!key) return;
      const salary =
        Number(item?.hourlySalary ?? item?.hourlysalaray ?? item?.hourly_salary ?? 0) || 0;
      const overhead =
        Number(item?.overhead ?? item?.overheadpercentage ?? item?.overhead_percentage ?? 0) || 0;
      nextMap[key] = salary + overhead;
    });
    return nextMap;
  }, [salesHourlyRateData, loggedUserIdForRates, isL3SalesUser]);

  /** Redux starts with loading=false before the first thunk runs; avoid treating empty SP data as "ready". */
  const salesHourlyFetchSeenRef = useRef(false);
  useEffect(() => {
    if (salesHourlyRateLoading) salesHourlyFetchSeenRef.current = true;
  }, [salesHourlyRateLoading]);

  const spRatesReadyForPrecompute =
    !salesHourlyRateLoading &&
    (salesHourlyFetchSeenRef.current ||
      (Array.isArray(salesHourlyRateData) && salesHourlyRateData.length > 0));

  const groupNameById = useMemo(() => {
    const map = new Map();
    const normalize = (v) => String(v ?? "").trim();
    (Array.isArray(group) ? group : []).forEach((groupItem) => {
      const id = normalize(groupItem?._id ?? groupItem?.id);
      if (!id) return;
      const name = normalize(
        groupItem?.name ??
        groupItem?.newGroupName ??
        groupItem?.groupName ??
        groupItem?.GroupName ??
        id
      );
      map.set(id, name || id);
    });
    return map;
  }, [group]);

  const groupIdByName = useMemo(() => {
    const map = new Map();
    groupNameById.forEach((name, id) => map.set(String(name).trim(), id));
    return map;
  }, [groupNameById]);

  const getLeadGroupId = useCallback(
    (lead) => {
      const normalize = (value) => String(value ?? "").trim();
      const fromObject = normalize(lead?.groupid?._id ?? lead?.groupid?.id);
      if (fromObject) return fromObject;
      const fromString = typeof lead?.groupid === "string" ? normalize(lead.groupid) : "";
      if (fromString && groupNameById.has(fromString)) return fromString;
      if (fromString && groupIdByName.has(fromString)) return groupIdByName.get(fromString);
      const fromAssigned = normalize(lead?.AssignedGroup);
      if (fromAssigned && groupIdByName.has(fromAssigned)) return groupIdByName.get(fromAssigned);
      return "";
    },
    [groupNameById, groupIdByName]
  );

  const getQuotedRowGroupId = useCallback(
    (row) => {
      const key = getRowKey(row);
      const proj = projects.find((p) => {
        if (p.quotationId != null && String(p.quotationId).trim() !== "") {
          return String(p.quotationId).trim() === String(key).trim();
        }
        return (
          (p.ProjectName || "").trim().toLowerCase() ===
          (row.ProjectName || "").trim().toLowerCase()
        );
      });
      if (proj) {
        const g = proj.groupid;
        const id = g?._id ?? g?.id ?? (typeof g === "string" ? g : "");
        const normalized = String(id || "").trim();
        if (normalized) return normalized;
      }
      return getLeadGroupId(row);
    },
    [projects, getRowKey, getLeadGroupId]
  );

  // const { otherExpenses } = useSelector((state) => state.filteredData);
  const [quotedValues, setQuotedValues] = useState({}); // Changed to object to store values by project
  const [quotedExpenses, setQuotedExpenses] = useState({}); // Changed to object to store values by project
  // CRM Gross Profit: snapshot maps so P&L YEAR/GROUP/CLIENT filters can't indirectly clear/reshape GP inputs.
  const [crmGpQuotedExpensesSnapshot, setCrmGpQuotedExpensesSnapshot] = useState({});
  const [crmGpQuotedExpenseInputsSnapshot, setCrmGpQuotedExpenseInputsSnapshot] = useState({});
  const [selectedProject, setSelectedProject] = useState();
  const handleItemizedTotalsChange = useCallback((projectKey, totals) => {
    if (!projectKey || !totals) return;
    // Normalize Tax / Net Revenue from EBIT so parent table never keeps a bad tax (e.g. raw EBIT).
    const gp = Number(totals.grossProfit) || 0;
    const ga = Number(totals.gaExpenses) || 0;
    const ebit = gp - ga;
    const taxRate = Number(taxValue) / 100;
    const tax = ebit * taxRate;
    const netRevenue = ebit - tax;
    const quoted = Number(quotedValues?.[projectKey] ?? 0) || 0;
    setItemizedTotalsByProject((prev) => ({
      ...prev,
      [projectKey]: {
        ...totals,
        tax,
        netRevenue,
        netRevenuePct: quoted ? (netRevenue / quoted) * 100 : (Number(totals.netRevenuePct) || 0),
      },
    }));
  }, [taxValue, quotedValues]);
  // Single source of truth for Quoted Expenses (non-quoted projects): Itemized P&L Total Cost Per Service total
  const handleTotalCostPerServiceTotalChange = useCallback((projectKey, totalCostPerService) => {
    if (!projectKey) return;
    // locked projects keep backend values
    const lead = searchedLeadReports?.find((l) => getRowKey(l) === projectKey);
    const isQuotedFlag =
      lead?.isProjectQuoted === true ||
      lead?.isProjectQuoted === 1 ||
      String(lead?.isProjectQuoted || "").toLowerCase() === "true";
    const leadQe = getLeadQuotedExpenseValue(lead);
    // CRM P&L: keep persisted lead.quotedExpense when set; itemized totals must not overwrite it.
    if (isQuotedFlag || (selectedServiceTypes === "CRM" && leadQe > 0)) return;

    const total = Math.round(Number(totalCostPerService) || 0);

    console.log("P&L Total Cost Per Service:", total);
    console.log("Quoted Expenses Value:", total);

    const stableKey = rowKeyToStableKey?.[String(projectKey).trim()] ?? String(projectKey).trim();

    setQuotedExpenses((prev) => {
      const prevVal = Number(prev?.[stableKey]) || 0;
      if (prevVal === total) return prev;
      // Replacing stale backend values with Itemized P&L is expected for non-quoted leads; do not treat as an error.
      return { ...prev, [stableKey]: total };
    });
    setQuotedExpenseInputs((prev) => {
      const prevVal = Number(prev?.[stableKey]) || 0;
      if (prevVal === total) return prev;
      return { ...prev, [stableKey]: total };
    });
  }, [searchedLeadReports, getRowKey, rowKeyToStableKey, selectedServiceTypes]);
  const [showQuoteModal, setShowQuoteModal] = useState(false);
  // const [InstallationAssociatedCostTable, setInstallationAssociatedCostTable] = useState(false);
  // const [HardwareAssociatedCostTable, setHardwareAssociatedCostTable] = useState(false);
  // const [SoftwareAssociatedCostTable, setSoftwareAssociatedCostTable] = useState(false);
  // const [CloudAssociatedCostTable, setCloudAssociatedCostTable] = useState(false);

  // const [currentPerson, setCurrentPerson] = useState([]);
  const [perdiem, setperdiem] = useState(0);
  const [averagecost, setaveragecost] = useState(0);
  const AllServiceTableRef = useRef(null);
  const AllServiceTableScrollRef = useRef(null); // DOM ref for scrollIntoView (component ref is for collapseItemized)
  const debounceTimeoutRef = useRef(null); // Add this ref for debounce
  const closeItemizedPL = useCallback(() => {
    AllServiceTableRef.current?.collapseItemized?.();
    setSelectedProjectName({});
    setSelectedProject(undefined);
  }, []);

  // When P&L filters (YEAR, GROUP, CLIENT, Quoted/Actual) change, close Itemized P&L block so only the main P&L table shows
  useEffect(() => {
    closeItemizedPL();
  }, [selectedYears, AssignedGroup, clientFilter, selectedServiceTypes, closeItemizedPL]);

  // Drop cached itemized tax/NR when tax rates change so rows cannot keep a stale Tax (e.g. EBIT)
  useEffect(() => {
    setItemizedTotalsByProject({});
  }, [GandATax, taxValue]);

  const [selectedTab, setSelectedTab] = useState(""); // default to first tab
  const [financeDataProject, setfinanceDataProject] = useState([]);
  const [comments, setComments] = useState({});

  const [installtionPersons, setinstallationPersons] = useState([]);
  const [SoftwarePersons, setSoftwarePersons] = useState([]);
  const [CloudPersons, setCloudPersons] = useState([]);
  const [HardwarePersons, setHardwarePersons] = useState([]);
  const [button, setbutton] = useState("QuotedExpense");
  const [showTable, setshowTable] = useState("QuotedExpense");
  const [leadData, setLeadData] = useState([]);
  const [newproject, setnewproject] = useState({});
  const [currentEmployee, setcurrentEmployee] = useState();
  const email = localStorage.getItem("email")
  const [filteredTableData, setFilteredTableData] = useState([]);
  const [actualPlCardTotals, setActualPlCardTotals] = useState(null);
  const [actualPlExpenseByRowKey, setActualPlExpenseByRowKey] = useState({});
  const [actualPlQuotedValueByRowKey, setActualPlQuotedValueByRowKey] = useState({});
  const handleActualDataReady = useCallback((rows, costSum, valueSum) => {
    const v = Number(valueSum) || 0;
    const c = Number(costSum) || 0;
    const rowCount = Array.isArray(rows) ? rows.length : 0;
    setActualPlCardTotals({
      valueSum: v,
      costSum: c,
      grossProfitSum: v - c,
      rowCount,
    });
  }, []);
  const handleActualExpenseByRowKeyReady = useCallback((payload) => {
    const expenses =
      payload && typeof payload === "object" && payload.expenses
        ? payload.expenses
        : payload && typeof payload === "object" && !payload.expenses
          ? payload
          : {};
    const quotedValuesMap =
      payload && typeof payload === "object" && payload.quotedValues
        ? payload.quotedValues
        : {};
    setActualPlExpenseByRowKey((prev) => {
      const merged = { ...(prev || {}) };
      Object.entries(expenses).forEach(([k, v]) => {
        const num = Number(v) || 0;
        // Partial P&L re-sync must not zero-out costs already computed for other rows.
        if (
          num === 0 &&
          merged[k] != null &&
          Number.isFinite(Number(merged[k])) &&
          Number(merged[k]) !== 0
        ) {
          return;
        }
        merged[k] = num;
      });
      if (JSON.stringify(prev) === JSON.stringify(merged)) return prev;
      return merged;
    });
    setActualPlQuotedValueByRowKey((prev) => {
      const merged = { ...(prev || {}), ...quotedValuesMap };
      if (JSON.stringify(prev) === JSON.stringify(merged)) return prev;
      return merged;
    });
  }, []);

  /** ERP Actual GP: live Quoted Price per row (same as Actual P&L table). */
  const erpPlShowActualQuotedValueForRow = useCallback(
    (rowKey) => {
      const k = String(rowKey ?? "").trim();
      if (!k) return 0;
      const fromLive = actualPlQuotedValueByRowKey[k];
      if (
        fromLive !== undefined &&
        fromLive !== null &&
        Number.isFinite(Number(fromLive))
      ) {
        return Number(fromLive);
      }
      return 0;
    },
    [actualPlQuotedValueByRowKey]
  );

  /** ERP Actual GP: whether live Actual Expenses map has an entry for this row key. */
  const erpPlHasActualExpenseForRow = useCallback(
    (rowKey) => {
      const k = String(rowKey ?? "").trim();
      if (!k) return false;
      return Object.prototype.hasOwnProperty.call(actualPlExpenseByRowKey, k);
    },
    [actualPlExpenseByRowKey]
  );

  /** ERP Actual GP: live Actual Expenses column per row (synced from ActualFinaceTable.showExpensesop). */
  const erpPlShowActualExpenseForRow = useCallback(
    (rowKey) => {
      const k = String(rowKey ?? "").trim();
      if (!k) return 0;
      const fromLive = actualPlExpenseByRowKey[k];
      if (
        fromLive !== undefined &&
        fromLive !== null &&
        Number.isFinite(Number(fromLive))
      ) {
        return Number(fromLive);
      }
      return 0;
    },
    [actualPlExpenseByRowKey]
  );

  const [hourlyRateData, setHourlyRateData] = useState([]);
  const [quotedproject, setquotedproject] = useState([]);

  useEffect(() => {
    const employee = employees.find((emp) => emp.EmpEmail === email);
    setcurrentEmployee(employee)
  }, [email, employees]);

  const isL0Admin = useMemo(
    () =>
      String(
        currentEmployee?.EmpAuthLevel ??
          currentEmployeeForPL?.EmpAuthLevel ??
          session?.auth ??
          (typeof localStorage !== "undefined" ? localStorage.getItem("auth") : "")
      )
        .trim()
        .toUpperCase() === "L0",
    [currentEmployee?.EmpAuthLevel, currentEmployeeForPL?.EmpAuthLevel, session?.auth]
  );

  // L3: P&L table must only show leads whose AssignedGroup is in EmpGroups (never use unscoped allLeads).
  const profitAndLossLeadsSource = useMemo(() => {
    const isL3 = authLevelForPlData === "L3";
    const useAllLeads = (isCrmPackage || isFinanceWithPL) && !isL3;
    let result = useAllLeads
      ? (allLeads || [])
      : ((!leads || leads.length === 0) ? (allLeads || []) : (leads || []));

    if (isL3) {
      const empList =
        Array.isArray(leadsEmpGroups) && leadsEmpGroups.length > 0
          ? leadsEmpGroups
          : Array.isArray(currentEmployee?.EmpGroups) && currentEmployee?.EmpGroups.length > 0
            ? currentEmployee.EmpGroups
            : Array.isArray(currentEmployeeForPL?.EmpGroups)
              ? currentEmployeeForPL.EmpGroups
              : [];

      if (!empList.length) {
        result =
          Array.isArray(leads) && leads.length > 0 ? [...leads] : [];
      } else {
        // Match EmpGroups to AssignedGroup OR to resolved group id (groupid). ERP/RFP leads often
        // only populate groupid while AssignedGroup stays empty — comparing AssignedGroup alone hid valid rows.
        result = (result || []).filter((lead) => {
          const assignedNorm = String(lead.AssignedGroup ?? "").trim().toLowerCase();
          const groupIdNorm = String(getLeadGroupId(lead) ?? "").trim().toLowerCase();
          return empList.some((g) => {
            const gNorm = String(g ?? "").trim().toLowerCase();
            if (!gNorm) return false;
            return gNorm === assignedNorm || (groupIdNorm && gNorm === groupIdNorm);
          });
        });
      }
    }

    // ERP P&L: hide only leads that still appear in Project requests (same rules as SalesProjects.jsx).
    // IMPORTANT: use isErpPackage (not !isCrmPackage) because some subscription strings contain both "crm" and "erp".
    if (isErpPackage && Array.isArray(result) && result.length > 0) {
      const groupedForPR = buildGroupedProjectsForProjectRequests(
        projects,
        employees
      );
      result = result.filter(
        (lead) =>
          !isLeadStillInProjectRequestsBucket(lead, groupedForPR, projects)
      );

      // ERP P&L: do not show "Response Received" leads until Salesperson ACCEPTS.
      // Once accepted, the lead remains visible through later project baskets (approved/assigned/ongoing/completed).
      const norm = (v) => String(v ?? "").trim().toLowerCase();
      const findProjectsForLead = (lead) => {
        const leadQuotationId = lead?.quotationId != null && String(lead.quotationId).trim() !== ""
          ? String(lead.quotationId).trim()
          : null;
        const leadProjectName = lead?.ProjectName != null && String(lead.ProjectName).trim() !== ""
          ? String(lead.ProjectName).trim().toLowerCase()
          : null;

        if (!Array.isArray(projects) || projects.length === 0) return undefined;

        // Match the same way the rest of this file does: quotationId first (mandatory when present), else ProjectName.
        // IMPORTANT: a lead can have multiple project docs (one per service/manager). We must evaluate ALL of them.
        if (leadQuotationId) {
          return projects.filter(
            (p) => p?.quotationId != null && String(p.quotationId).trim() === leadQuotationId
          );
        }
        if (leadProjectName) {
          return projects.filter((p) => norm(p?.ProjectName) === leadProjectName);
        }
        return [];
      };

      result = result.filter((lead) => {
        const leadProjects = findProjectsForLead(lead);
        // HARD RULE (ERP): if we can't map the lead to project doc(s), do not show it in P&L.
        if (!Array.isArray(leadProjects) || leadProjects.length === 0) return false;

        // Keep lead in P&L throughout buckets:
        // - In "Response Received": require ALL managers/services accepted (matches ResponseReceived.jsx "Accepted" pill).
        // - After it moves to later buckets (approved/assigned/ongoing/complete): keep it visible even if QA stops
        //   sending salespersonaction="accept" (status itself indicates it progressed past response received).
        const progressedStatuses = new Set([
          "project approved",
          "project assigned",
          "project ongoing",
          "project complete",
        ]);

        const hasProgressed = leadProjects.some((proj) => {
          const assigned = Array.isArray(proj?.Assignedperson) ? proj.Assignedperson : [];
          return assigned.some((p) => progressedStatuses.has(norm(p?.salespersonstatus)));
        });
        if (hasProgressed) return true;

        // Not progressed yet → still in Response Received flow, require ALL accepted.
        return leadProjects.every((proj) => {
          const assigned = Array.isArray(proj?.Assignedperson) ? proj.Assignedperson : [];
          if (assigned.length === 0) return false;
          return assigned.every((person) => norm(person?.salespersonaction) === "accept");
        });
      });
    }

    return result || [];
  }, [
    authLevelForPlData,
    isCrmPackage,
    isErpPackage,
    isFinanceWithPL,
    leads,
    allLeads,
    leadsEmpGroups,
    currentEmployee?.EmpGroups,
    currentEmployeeForPL?.EmpGroups,
    projects,
    employees,
    getLeadGroupId,
  ]);

  // CRM Gross Profit: stable rowKey -> stableKey mapping must NOT depend on P&L-filtered `searchedLeadReports`,
  // otherwise GP Cost lookups break / drift when P&L YEAR changes.
  const gpRowKeyToStableKeyCrm = useMemo(() => {
    if (!isCrmPackage) return {};
    const m = {};
    const rows = Array.isArray(profitAndLossLeadsSource) ? profitAndLossLeadsSource : [];
    rows.forEach((lead) => {
      const rk = getRowKey(lead);
      if (!rk) return;
      m[String(rk).trim()] = getStableLeadKey(lead);
    });
    return m;
  }, [isCrmPackage, profitAndLossLeadsSource, getRowKey, getStableLeadKey]);

  useEffect(() => {
    const pkg = profiles?.[0]?.subscriptionpackage;
    if (pkg == null || pkg === "") return;
    const norm = String(pkg).replace(/\s+/g, " ").trim().toLowerCase();
    if (norm === "crm" || (norm.includes("crm") && !norm.includes("erp"))) {
      setSelectedServiceTypes("CRM");
    } else if (norm === "erp" || norm.includes("erp")) {
      setSelectedServiceTypes("QuotedExpense");
    } else {
      setSelectedServiceTypes(String(pkg).trim());
    }
  }, [profiles]);

  const getPlRowGroupId = useCallback(
    (row) => (selectedServiceTypes === "CRM" ? getLeadGroupId(row) : getQuotedRowGroupId(row)),
    [selectedServiceTypes, getLeadGroupId, getQuotedRowGroupId]
  );

  const getPlDisplayGroupName = useCallback(
    (row) => {
      const gid = getPlRowGroupId(row);
      if (gid && groupNameById.has(gid)) return groupNameById.get(gid);
      if (gid) return "";
      return row?.AssignedGroup || "";
    },
    [getPlRowGroupId, groupNameById]
  );

  useEffect(() => {
      // P&L table: only projects with isProjectQuoted === true are "quoted" (use quotationId for row key elsewhere; do not treat mere quotationId as quoted)
      const finalproject = projects.filter(
        (proj) =>
          proj.isProjecttracking === false && proj.isProjectQuoted === true
      );
      setquotedproject(finalproject)

  }, [projects, selectedProjectName]);

  useEffect(() => {
    // P&L must match designation rows for all projects (finance / multi-sales). Per-user filter left wrong or empty quotationDetails for many leads.
    const list = Array.isArray(hourlyRateQuotations) ? hourlyRateQuotations : [];
    setHourlyRateData(list);
  }, [hourlyRateQuotations]);

  useEffect(() => {
    setSelectedProjectName(newproject)
  }, [newproject]);

  // CRM or finance person (PROFIT AND LOSS): P&L table uses allLeads so they see all leads. L3 is always scoped to EmpGroups.
  useEffect(() => {
    setLeadData(profitAndLossLeadsSource);
  }, [profitAndLossLeadsSource]);

  useEffect(() => {
    const filteredProject = projects.filter(
      (proj) => proj.isProjecttracking === false
    );

    const qualifiedGroups = filteredProject.filter((project) => {
      // Must have at least one assigned person
      if (!project?.Assignedperson?.length) return false;

      // At least ONE assigned person must meet criteria
      return project.Assignedperson.some((person) =>
        (
          person.salespersonaction === "accept" ||
          person.salespersonaction === "project not-assigned" ||
          person.salespersonaction === "project not-assigned"

        )
        &&
        (
          person.salespersonstatus === "response received" ||
          person.salespersonstatus === "project approved" ||
          person.salespersonstatus === "project not-approved" ||
          person.salespersonstatus === "project not-assigned"
        )
      );
    });
    setfinanceDataProject(qualifiedGroups)
  }, [projects]);

  const refsMap = {
    AllServiceTable: AllServiceTableScrollRef, // use DOM ref for scroll; AllServiceTableRef is component ref for collapseItemized
  };
  const handleTabClick = (tabKey) => {
    setSelectedTab(tabKey);
    setTimeout(() => {
      const node = refsMap[tabKey]?.current;
      if (node && typeof node.scrollIntoView === "function") {
        node.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100); // slight delay so component mounts first
  };

  const refsAccociatedMap = {
    AllServiceAssociatedTable: AssociatedRef,

  };
  const handleAccociatedTabClick = (tabKey) => {
    setTimeout(() => {
      const node = refsAccociatedMap[tabKey]?.current;
      if (node && typeof node.scrollIntoView === "function") {
        node.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100); // slight delay so component mounts first
  };

  const handlerefresh = async (projectnameOrQuotationId) => {
    try {
      await dispatch(fetchAllFinancial());
      await dispatch(fetchSalesTaxes());
      await dispatch(fetchAllProjects());
      await dispatch(setOtheeExpensesData());
      await dispatch(fetchCompanyProfiles());
      await dispatch(fetchOtherExpenses());

      const updatedLeads = await dispatch(fetchLeads()).unwrap();

      dispatch(fetchEmployees());
      dispatch(fetchWorkEntries());
      dispatch(fetchHardwareDescriptions());
      dispatch(fetchDescriptionTasks());
      dispatch(fetchQuotations());
      dispatch(fetchSalesHourlyRates());
      dispatch(getMyTrainings());
      await fetchAllTrainingsForPl();

      const matchedLead = updatedLeads.find((lead) =>
        lead.quotationId != null && String(lead.quotationId).trim() !== ""
          ? String(lead.quotationId) === String(projectnameOrQuotationId)
          : lead.ProjectName === projectnameOrQuotationId
      );
      if (matchedLead) {
        setnewproject(matchedLead);
        setCalculationTable(true);
      } else {
        setnewproject({});
        setCalculationTable(false);
      }
    } catch (error) {
      console.error("Error refreshing data:", error);
      enqueueSnackbar("Error refreshing data", { variant: "error" });
    }
  };

  const [quotedExpenseInputs, setQuotedExpenseInputs] = useState({});
  const [matchedProjects, setMatchedProjects] = useState([]); // always an array
  const [, setMatchedEntries] = useState([]); // used by selected-lead side panels
  const [allTrainingsForPl, setAllTrainingsForPl] = useState([]);

  async function fetchAllTrainingsForPl() {
    try {
      const urls = [
        `${config.backendUrl}/my-training/getll?limit=1000&_ts=${Date.now()}`,
        `${config.backendUrl}/my-training/getll?_ts=${Date.now()}`,
      ];
      let payload = null;
      for (const url of urls) {
        try {
          const res = await axiosInstance.get(url, {
            headers: {
              "Cache-Control": "no-cache, no-store, max-age=0",
              Pragma: "no-cache",
              Expires: "0",
            },
          });
          payload = res?.data;
          if (payload) break;
        } catch (_) {
          // try next URL variant
        }
      }
      const fetched = Array.isArray(payload?.trainings)
        ? payload.trainings
        : Array.isArray(payload)
          ? payload
          : [];
      setAllTrainingsForPl(fetched);
      console.log("[TrainingCostDebug] allTrainingsForPlFetched", { count: fetched.length });
    } catch (error) {
      console.warn("[TrainingCostDebug] fetchAllTrainingsForPl error", error);
      setAllTrainingsForPl([]);
    }
  }

  const projectPersonServiceMap = useMemo(
    () => buildProjectPersonServiceMapFromQuotation(filteredQuotation),
    [filteredQuotation]
  );

  const buildTasksForQuotationScope = useCallback(
    (quotationScope, personServiceMap) => {
    const baseTasks = Array.isArray(tasks) ? tasks : [];
    const allFetchedTrainings = Array.isArray(allTrainingsForPl) ? allTrainingsForPl : [];
    const fetchedTrainings = Array.isArray(mytrainings?.trainings)
      ? mytrainings.trainings
      : Array.isArray(mytrainings)
        ? mytrainings
        : [];
    const createdTrainings = Array.isArray(myTrainingsCreateList) ? myTrainingsCreateList : [];
    const trainings = [...allFetchedTrainings, ...fetchedTrainings, ...createdTrainings];
    if (!trainings.length) return baseTasks;
    if (!quotationScope || !Object.keys(quotationScope).length) return baseTasks;

    // Scope training rows to the Itemized P&L project context.
    const normalize = (v) => String(v || "").trim().toLowerCase();
    const scopedProjectIds = new Set();
    const scopedQuotationIds = new Set();
    const scopedProjectNames = new Set();
    Object.entries(quotationScope || {}).forEach(([filteredKey, serviceTypes]) => {
      if (filteredKey) scopedQuotationIds.add(normalize(filteredKey));
      Object.entries(serviceTypes || {}).forEach(([, serviceRows]) => {
        (serviceRows || []).forEach((row) => {
          const pid = String(row?.ProjectID || "").trim();
          if (pid) scopedProjectIds.add(pid);
          const qid = normalize(
            row?.quotationId || row?.QuotationID || row?.quotationid || filteredKey || ""
          );
          if (qid) scopedQuotationIds.add(qid);
          const pname = normalize(row?.projectName || row?.ProjectName || "");
          if (pname) scopedProjectNames.add(pname);
        });
      });
    });

    const syntheticTrainingTasks = [];
    const seenSyntheticTaskIds = new Set();

    const seenTrainingRecords = new Set();
    const scopedTrainings = trainings.filter((training) => {
      const tProjectId = String(training?.projectid || training?.projectId || "").trim();
      const tQuotationId = normalize(
        training?.quotationId || training?.quotationID || training?.quotationid || ""
      );
      const tProjectName = normalize(training?.projectname || training?.projectName || "");

      if (tProjectId && scopedProjectIds.has(tProjectId)) return true;
      if (tQuotationId && scopedQuotationIds.has(tQuotationId)) return true;
      if (tProjectName && scopedProjectNames.has(tProjectName)) return true;
      return false;
    });

    scopedTrainings.forEach((training) => {
      const dedupeTrainingKey = String(training?._id || "").trim() || JSON.stringify(training || {});
      if (seenTrainingRecords.has(dedupeTrainingKey)) return;
      seenTrainingRecords.add(dedupeTrainingKey);

      const isTrainingQuoted =
        training?.isTrainingQuoted === true ||
        String(training?.isTrainingQuoted || "").toLowerCase() === "true";
      if (!isTrainingQuoted) return;

      const projectId = String(training?.projectid || training?.projectId || "").trim();
      const quotationId = String(
        training?.quotationId || training?.quotationID || training?.quotationid || ""
      ).trim();
      const assignedTo = String(training?.assignedto || training?.assignedTo || "").trim();
      const normalizedAssignedTo = assignedTo.toLowerCase();
      const normalizedTrainingQuotationId = String(
        training?.quotationId || training?.quotationID || training?.quotationid || ""
      )
        .trim()
        .toLowerCase();
      const trainingId = String(training?._id || "").trim();
      const trainingCost = Number(training?.trainingcost ?? training?.trainingCost ?? 0) || 0;
      if (!assignedTo || !trainingCost) return;

      const projectServiceTargets = [];
      if (projectId) {
        const serviceTypes = Array.from(
          personServiceMap.byProjectPerson.get(`${projectId}::${assignedTo}`) || []
        );
        projectServiceTargets.push({
          projectId,
          serviceTypes: serviceTypes.length ? serviceTypes : [""],
        });
      }
      if (quotationId) {
        const byQuotation = personServiceMap.byQuotationPerson.get(
          `${quotationId}::${assignedTo}`
        );
        if (byQuotation?.size) {
          byQuotation.forEach((serviceSet, projId) => {
            projectServiceTargets.push({
              projectId: projId,
              serviceTypes: Array.from(serviceSet || []),
            });
          });
        }
      }
      if (!projectServiceTargets.length && normalizedAssignedTo) {
        const personTargets = personServiceMap.byPerson.get(normalizedAssignedTo) || [];
        personTargets.forEach((target) => {
          const quoteMatchOk =
            !normalizedTrainingQuotationId ||
            (target.quotationKeys || []).includes(normalizedTrainingQuotationId);
          if (!quoteMatchOk) return;
          projectServiceTargets.push({
            projectId: target.projectId,
            serviceTypes: [target.typeService || ""],
          });
        });
      }
      // For the currently opened Itemized project table, person-level fallback is safe and deterministic.
      // This ensures quoted training appears when IDs differ but assigned user row is present.
      if (!projectServiceTargets.length && normalizedAssignedTo) {
        const scopedTargets = personServiceMap.byPersonScoped.get(normalizedAssignedTo) || [];
        scopedTargets.forEach((target) => {
          projectServiceTargets.push({
            projectId: target.projectId,
            serviceTypes: [target.typeService || ""],
          });
        });
      }
      if (!projectServiceTargets.length && projectId) {
        projectServiceTargets.push({ projectId, serviceTypes: [""] });
      }

      console.log("[TrainingCostDebug] candidate", {
        trainingId,
        rawProjectid: training?.projectid,
        rawProjectId: training?.projectId,
        rawAssignedto: training?.assignedto,
        rawAssignedTo: training?.assignedTo,
        rawTrainingCost: training?.trainingcost ?? training?.trainingCost,
        projectName: training?.projectname,
        projectId,
        quotationId,
        assignedTo,
        trainingCost,
        resolvedTargets: projectServiceTargets,
      });

      projectServiceTargets.forEach(({ projectId: targetProjectId, serviceTypes }) => {
        (serviceTypes.length ? serviceTypes : [""]).forEach((typeService, idx) => {
          const syntheticKey = `${trainingId || `${projectId || quotationId}-${assignedTo}`}-${targetProjectId}-${typeService || "all"}-${idx}`;
          if (seenSyntheticTaskIds.has(syntheticKey)) return;
          seenSyntheticTaskIds.add(syntheticKey);

          syntheticTrainingTasks.push({
            _id: `training-cost-${syntheticKey}`,
            projectid: targetProjectId,
            quotationId: quotationId || undefined,
            taskownerid: assignedTo,
            description: "Training cost",
            value: trainingCost,
            tripduration: 0,
            ...(typeService ? { typeservice: typeService } : {}),
            isSyntheticTrainingCost: true,
          });
          console.log("[TrainingCostDebug] injected", {
            trainingId,
            projectName: training?.projectname,
            targetProjectId,
            typeService: typeService || "(all)",
            taskownerid: assignedTo,
            amount: trainingCost,
          });
        });
      });
    });

    if (!syntheticTrainingTasks.length) {
      console.log("[TrainingCostDebug] noScopedInjection", {
        scopedProjectIds: Array.from(scopedProjectIds),
        scopedQuotationIds: Array.from(scopedQuotationIds),
        scopedProjectNames: Array.from(scopedProjectNames),
        allFetchedCount: allFetchedTrainings.length,
        fetchedCount: fetchedTrainings.length,
        createdCount: createdTrainings.length,
        scopedCount: scopedTrainings.length,
      });
      return baseTasks;
    }
    console.log("[TrainingCostDebug] sourceSummary", {
      allFetchedCount: allFetchedTrainings.length,
      fetchedCount: fetchedTrainings.length,
      createdCount: createdTrainings.length,
      mergedCount: trainings.length,
      scopedCount: scopedTrainings.length,
      sample: scopedTrainings.slice(0, 10).map((t) => ({
        id: t?._id,
        projectname: t?.projectname,
        projectid: t?.projectid ?? t?.projectId,
        quotationId: t?.quotationId ?? t?.quotationID ?? t?.quotationid,
        assignedto: t?.assignedto ?? t?.assignedTo,
        trainingcost: t?.trainingcost ?? t?.trainingCost,
        isTrainingQuoted: t?.isTrainingQuoted,
      })),
    });
    console.log("[TrainingCostDebug] injectedCount", syntheticTrainingTasks.length);
    return [...baseTasks, ...syntheticTrainingTasks];
    },
    [tasks, mytrainings, myTrainingsCreateList, allTrainingsForPl]
  );

  const tasksForPlTables = useMemo(
    () => buildTasksForQuotationScope(filteredQuotation, projectPersonServiceMap),
    [buildTasksForQuotationScope, filteredQuotation, projectPersonServiceMap]
  );

  useEffect(() => {
    if (!isCrmPackage) return;
    setCrmGpQuotedExpensesSnapshot((prev) => {
      const incoming = quotedExpenses || {};
      const incomingKeys = Object.keys(incoming);
      // P&L filtering/refetch can briefly produce an empty object; do NOT wipe GP background totals.
      if (incomingKeys.length === 0) return prev || {};
      return { ...(prev || {}), ...incoming };
    });
  }, [isCrmPackage, quotedExpenses]);

  useEffect(() => {
    if (!isCrmPackage) return;
    setCrmGpQuotedExpenseInputsSnapshot((prev) => {
      const incoming = quotedExpenseInputs || {};
      const incomingKeys = Object.keys(incoming);
      if (incomingKeys.length === 0) return prev || {};
      return { ...(prev || {}), ...incoming };
    });
  }, [isCrmPackage, quotedExpenseInputs]);

  // When a P&L row is selected: quotationId is mandatory first; match only by quotationId when present. ProjectName is secondary.
  useEffect(() => {
    if ((selectedProjectName?.ProjectName || selectedProjectName?.quotationId) && financeDataProject?.length) {
      const hasQuotationId = selectedProjectName.quotationId != null && String(selectedProjectName.quotationId).trim() !== "";
      const matches = financeDataProject.filter((proj) => {
        if (hasQuotationId) {
          return proj.quotationId != null && String(proj.quotationId).trim() === String(selectedProjectName.quotationId).trim();
        }
        return (
          proj.ProjectName?.toLowerCase() ===
          selectedProjectName.ProjectName?.toLowerCase()
        );
      });

      setMatchedProjects(matches);
    } else {
      setMatchedProjects([]);
    }
  }, [selectedProjectName, financeDataProject]);

  useEffect(() => {
    if (matchedProjects.length && entries.length) {
      const matchedIds = matchedProjects.map((proj) => proj._id);
      const filteredEntries = entries.filter((entry) =>
        matchedIds.includes(entry.projectid)
      );

      const matchedPersons = matchedProjects.flatMap((project) =>
        (project.Assignedperson || [])
          // .filter(
          //   (person) =>
          //     ((person.salespersonaction === "          " || person.salespersonaction === "project not-assigned") && person.salespersonstatus === "response received") ||
          //     ((person.salespersonaction === "accept" || person.salespersonaction === "project not-assigned") && person.salespersonstatus === "project approved")
          //     || ((person.salespersonaction === "accept" || person.salespersonaction === "project not-assigned") && person.salespersonstatus === "project assigned")
          //     || ((person.salespersonaction === "accept" || person.salespersonaction === "project not-assigned") && person.salespersonstatus === "project ongoing")
          //     || ((person.salespersonaction === "accept" || person.salespersonaction === "project not-assigned") && person.salespersonstatus === "project complete")

          // )
          .map((person) => ({
            ...person,
            projectid: project._id,
            ProjectName: project.ProjectName, // optional
          }))
      );

      const matchedEmployees = employees.filter((employee) =>
        matchedPersons.some(
          (person) =>
            person.email?.trim().toLowerCase() ===
            employee.EmpEmail?.trim().toLowerCase()
        )
      );

      const matchedPeopleEntries = filteredEntries.filter((entry) =>
        matchedEmployees.some(
          (employee) => employee._id?.trim() === entry.taskownerid?.trim()
        )
      );

      setMatchedEntries(matchedPeopleEntries);
    } else {
      setMatchedEntries([]);
    }
  }, [matchedProjects, entries, employees]);

  const [matchedHardwareEntries, setMatchedHardwareEntries] = useState([]); // ✅ will store matched entries

  useEffect(() => {
    if (matchedProjects.length && items.length) {
      const matchedIds = matchedProjects.map((proj) => proj._id);
      const filteredEntries = items.filter((entry) =>
        matchedIds.includes(entry.projectid)
      );

      const matchedPersons = matchedProjects.flatMap((project) =>
        (project.Assignedperson || [])
          // .filter(
          //   (person) =>
          //     ((person.salespersonaction === "accept" || person.salespersonaction === "project not-assigned") && person.salespersonstatus === "response received") ||
          //     ((person.salespersonaction === "accept" || person.salespersonaction === "project not-assigned") && person.salespersonstatus === "project approved") ||
          //     ((person.salespersonaction === "accept" || person.salespersonaction === "project not-assigned") && person.salespersonstatus === "project assigned") ||
          //     ((person.salespersonaction === "accept" || person.salespersonaction === "project not-assigned") && person.salespersonstatus === "project ongoing") ||
          //     ((person.salespersonaction === "accept" || person.salespersonaction === "project not-assigned") && person.salespersonstatus === "project complete")
          // )
          .map((person) => ({
            ...person,
            projectid: project._id,
            ProjectName: project.ProjectName, // optional
          }))
      );

      const matchedEmployees = employees.filter((employee) =>
        matchedPersons.some(
          (person) =>
            person.email?.trim().toLowerCase() ===
            employee.EmpEmail?.trim().toLowerCase()
        )
      );

      const matchedPeopleEntries = filteredEntries.filter((entry) =>
        matchedEmployees.some(
          (employee) => employee._id?.trim() === entry.taskownerid?.trim()
        )
      );

      setMatchedHardwareEntries(matchedPeopleEntries);
    } else {
      setMatchedHardwareEntries([]);
    }
  }, [matchedProjects, items, employees]);

  useEffect(() => {
    if (matchedHardwareEntries.length) {
      setMatchedEntries(prevEntries => [...prevEntries, ...matchedHardwareEntries]);
    }

  }, [matchedHardwareEntries]);

  const [groupedProj, setGroupedProj] = useState({});
  const [finalMappedEntries, setFinalMappedEntries] = useState([]);

  // useEffect(() => {
  //   if (matchedEntries.length && employees.length) {
  //     const mapped = matchedEntries.map((entry) => {
  //       const matchedEmp = employees.find(
  //         (emp) => emp._id === entry.taskownerid
  //       ); // Or use entry.taskownerid if that's the right link
  //       const matchedServiceEmp = employees.find(
  //         (emp) => emp._id === entry.taskownerid
  //       );

  //       return {
  //         createdBy: {
  //           email: matchedEmp?.EmpEmail || "",
  //           name: `${matchedEmp?.EmpFirstName || ""} ${matchedEmp?.EmpLastName || ""
  //             }`,
  //           role: matchedEmp?.customRoles || [],
  //         },
  //         task: entry.task,
  //         hoursassigned: entry.hoursassigned,
  //         taskStatus: entry.taskStatus,
  //         notes: entry.notes,
  //         _id: entry._id,
  //         taskownerid: entry.taskownerid,
  //         TypeService: matchedServiceEmp?.servicetype,
  //         projectid: entry.projectid,

  //       };
  //     });

  //     setFinalMappedEntries(mapped);
  //   } else {
  //     setFinalMappedEntries([]);
  //   }
  // }, [matchedEntries, employees]);

  // Build work + hardware entries for ALL projects (not only clicked lead) so refresh can compute correct totals without requiring a click.
  useEffect(() => {
    if (!employees?.length) {
      setFinalMappedEntries([]);
      return;
    }

    const work = Array.isArray(entries) ? entries : [];
    const hardware = Array.isArray(items) ? items : [];
    const combined = [...work, ...hardware];

    const mapped = combined.map((entry) => {
      const matchedEmp = employees.find((emp) => emp._id === entry.taskownerid);

      const isHardwareEntry =
        Object.prototype.hasOwnProperty.call(entry, "assemblepartdescription") ||
        Object.prototype.hasOwnProperty.call(entry, "partno") ||
        Object.prototype.hasOwnProperty.call(entry, "quantity");

      if (isHardwareEntry) {
        return {
          createdBy: {
            email: matchedEmp?.EmpEmail || "",
            name: `${matchedEmp?.EmpFirstName || ""} ${matchedEmp?.EmpLastName || ""}`,
            role: matchedEmp?.customRoles || [],
          },
          assemblepartdescription: entry.assemblepartdescription,
          partno: entry.partno,
          quantity: entry.quantity,
          unitprice: entry.unitprice,
          totalprice: entry.totalprice,
          permonth: entry.permonth,
          taskstatus: entry.taskstatus,
          _id: entry._id,
          taskownerid: entry.taskownerid,
          TypeService: entry.typeservice || "Hardware",
          projectid: entry.projectid,
        };
      }

      return {
        createdBy: {
          email: matchedEmp?.EmpEmail || "",
          name: `${matchedEmp?.EmpFirstName || ""} ${matchedEmp?.EmpLastName || ""}`,
          role: matchedEmp?.customRoles || [],
        },
        task: entry.task,
        hoursassigned: entry.hoursassigned,
        taskStatus: entry.taskStatus,
        notes: entry.notes,
        _id: entry._id,
        taskownerid: entry.taskownerid,
        TypeService: entry.typeservice || matchedEmp?.servicetype,
        projectid: entry.projectid,
      };
    });

    setFinalMappedEntries(mapped);
  }, [entries, items, employees]);

  useEffect(() => {
    if (!projects || projects.length === 0 || !employees) return;

    const grouped = {};
    projects.forEach((proj) => {
      const projectKey =
        (proj?.quotationId != null && String(proj.quotationId).trim() !== "")
          ? String(proj.quotationId).trim()
          : String(proj?.ProjectName ?? "").trim();
      const typeService = proj.TypeService;
      const projectId = proj._id;

      const matchedEntries = finalMappedEntries.filter(
        (entry) =>
          String(entry.TypeService ?? "").trim().toLowerCase() ===
            String(typeService ?? "").trim().toLowerCase() &&
          entry.projectid === projectId
      );

      // Include projects even before work/hardware entries load (or when none yet) so Itemized + precompute keys exist for every lead row.
      const salesperson = employees.find(
        (emp) => emp.EmpEmail === proj.SalesPersonEmail
      );
      const filteredProject = {
        TypeService: proj.TypeService,
        ResourceType: proj.ResourceType,
        ProjectName: proj.ProjectName,
        quotationId: proj?.quotationId,
        QuotedValue: proj.ServiceValue,
        ProjectMargin: proj.Salesmargin,
        isMarginupdated: proj.isMarginupdated ?? proj.isMarginUpdated ?? false,
        WorkEntries: matchedEntries,
        AssignedGroup: proj.AssignedGroup,
        AssignedManagerEmail: proj.AssignedManagerEmail,
        Assignedperson: proj.Assignedperson,
        ProjectID: proj._id,
        ProjectNotes: proj?.ProjectFinanceNotes,
        SalesPersonId: salesperson ? salesperson._id : null
      };

      if (!grouped[projectKey]) {
        grouped[projectKey] = {};
      }

      if (!grouped[projectKey][typeService]) {
        grouped[projectKey][typeService] = [];
      }

      grouped[projectKey][typeService].push(filteredProject);
    });

    setGroupedProj(grouped);
  }, [projects, employees, finalMappedEntries]);

  const [matchedQuotations, setMatchedQuotations] = useState({});


  useEffect(() => {
    if (!groupedProj || typeof groupedProj !== "object") return;
    const rateList = Array.isArray(hourlyRateData) ? hourlyRateData : [];
    const updatedGroupedProj = {};
    // Loop through each project
    Object.entries(groupedProj).forEach(([projectName, serviceTypes]) => {
      updatedGroupedProj[projectName] = {};

      // Loop through each TypeService within that project
      Object.entries(serviceTypes).forEach(([typeService, serviceArray]) => {
        // Keep the original service array
        const updatedServiceArray = serviceArray.map((entry) => {
          // Match quotations where designation includes TypeService
          const matchedQuotations = rateList.filter((q) =>
            q.designation?.toLowerCase().includes(typeService.toLowerCase())
            //  &&
            //   q.createdBy === entry.SalesPersonId
          );
          return {
            ...entry,
            quotationDetails: matchedQuotations, // add new key with matched quotations
          };
        });

        updatedGroupedProj[projectName][typeService] = updatedServiceArray;
      });
    });

    setMatchedQuotations(updatedGroupedProj);
  }, [hourlyRateData, groupedProj]);

  useEffect(() => {
    const rowKey = getRowKey(selectedProjectName);
    if (!rowKey || !matchedQuotations) return;

    const normalizedRowKey = String(rowKey ?? "").trim();
    const normalizedProjectName = String(selectedProjectName?.ProjectName ?? "").trim();
    const selectedQuotationId =
      selectedProjectName?.quotationId != null && String(selectedProjectName.quotationId).trim() !== ""
        ? String(selectedProjectName.quotationId).trim()
        : null;

    const matchByRowKey = matchedQuotations[normalizedRowKey];
    let match = matchByRowKey;

    // Safe fallback: only use ProjectName key when it refers to the SAME quotation (prevents pulling another project's data)
    if (!match && normalizedProjectName) {
      const candidate = matchedQuotations[normalizedProjectName];
      if (candidate && selectedQuotationId) {
        const hasSameQuotation = Object.values(candidate).some((items) =>
          (items || []).some((it) => String(it?.quotationId ?? "").trim() === selectedQuotationId)
        );
        if (hasSameQuotation) match = candidate;
      } else if (candidate && !selectedQuotationId) {
        match = candidate;
      }
    }

    if (match) {
      setFilteredQuotation({ [normalizedRowKey]: match });
    } else {
      setFilteredQuotation(null); // or {} if you prefer
    }
  }, [selectedProjectName, matchedQuotations, getRowKey]);

  useEffect(() => {
    setL3Leads(profitAndLossLeadsSource);
    if (group) {
      setGroupNamesL3(group);
    }
  }, [profitAndLossLeadsSource, group]);

  useEffect(() => {
    if (l3Leads) {
      setLoggedUserData([...l3Leads].reverse());
    }
  }, [l3Leads, taxes]);

  const dropdownRefGroup = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefGroup.current &&
        !dropdownRefGroup.current.contains(event.target)
      ) {
        setIsGroupOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const dropdownRefYear = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefYear.current &&
        !dropdownRefYear.current.contains(event.target)
      ) {
        setIsYearOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefclient.current &&
        !dropdownRefclient.current.contains(event.target)
      ) {
        setShowClientDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // NOTE: this effect is declared here (before precomputedItemizedTotals) to avoid use-before-define lint.
  // It intentionally DOES NOT depend on precomputedItemizedTotals; precomputed backfill is handled by a later effect.
  useEffect(() => {
    if (!searchedLeadReports?.length) return;
    // IMPORTANT: never overwrite row-level edits / computed totals when leads refetch.
    // Only backfill missing keys (null/undefined).
    setQuotedExpenseInputs((prev) => {
      const next = { ...(prev || {}) };
      searchedLeadReports.forEach((lead) => {
        const rowKey = getRowKey(lead);
        if (!rowKey) return;
        const stableKey = getStableLeadKey(lead);
        if (next[stableKey] !== undefined && next[stableKey] !== null) return;

        const isQuotedFlag = getRowIsProjectQuoted(lead);
        const qe = getLeadQuotedExpenseValue(lead);
        if (isQuotedFlag || (selectedServiceTypes === "CRM" && qe > 0)) {
          next[stableKey] = qe;
        }
      });
      return next;
    });
  }, [searchedLeadReports, getRowKey, getStableLeadKey, selectedServiceTypes]);

  // Inside your component
  const uniqueClients = [
    ...new Map(
      leadData
        .filter((lead) =>
          AssignedGroup === "All"
            ? true                          // ✅ show all clients
            : getPlRowGroupId(lead) === AssignedGroup
        )
        .map((lead) => [
          lead.ClientName?.trim().toLowerCase(), // key for uniqueness
          lead.ClientName?.trim(),               // display value
        ])
    ).values(),
  ].sort((a, b) => a.localeCompare(b, "en", { sensitivity: "base" }));
  // sort alphabetically, ignore case

  const itemsPerPage = 10;
  const startIdx = (currentPage - 1) * itemsPerPage;
  const endIdx = startIdx + itemsPerPage;
  const currentItems = filteredTableData?.slice(startIdx, endIdx); // Changed from searchedLeadReports to filteredTableData
  const totalItems = filteredTableData?.length; // Changed from searchedLeadReports.length to filteredTableData?.length
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const sortAlphabetically = (targetToSort, order) => {
    const key = `${targetToSort}-${order}`;
    const sortedReports = [...filteredTableData];

    switch (key) {
      case "projectname-az":
        sortedReports.sort((a, b) =>
          a.ProjectName?.trim()
            .toLowerCase()
            .localeCompare(b.ProjectName?.trim().toLowerCase())
        );
        break;

      case "projectname-za":
        sortedReports.sort((a, b) =>
          b.ProjectName?.trim()
            .toLowerCase()
            .localeCompare(a.ProjectName?.trim().toLowerCase())
        );
        break;

      case "groupname-az":
        sortedReports.sort((a, b) =>
          String(getPlDisplayGroupName(a) || "")
            .toLowerCase()
            .localeCompare(String(getPlDisplayGroupName(b) || "").toLowerCase())
        );
        break;

      case "groupname-za":
        sortedReports.sort((a, b) =>
          String(getPlDisplayGroupName(b) || "")
            .toLowerCase()
            .localeCompare(String(getPlDisplayGroupName(a) || "").toLowerCase())
        );
        break;

      case "clientname-az":
        sortedReports.sort((a, b) =>
          a.ClientName?.trim()
            .toLowerCase()
            .localeCompare(b.ClientName?.trim().toLowerCase())
        );
        break;

      case "clientname-za":
        sortedReports.sort((a, b) =>
          b.ClientName?.trim()
            .toLowerCase()
            .localeCompare(a.ClientName?.trim().toLowerCase())
        );
        break;

      default:
        console.error("Invalid Order");
    }

    setFilteredTableData(sortedReports);
  };

  const numericSort = (order) => {
    const sortedReports = [...filteredTableData];

    order === "az"
      ? sortedReports.sort(
        (a, b) => Number(a.QuotedValue) - Number(b.QuotedValue)
      )
      : sortedReports.sort(
        (a, b) => Number(b.QuotedValue) - Number(a.QuotedValue)
      );

    setFilteredTableData(sortedReports); // Update the state
  };

  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchInputChange = (e) => {
    const query = e.target.value; // Remove leading/trailing spaces
    // const lowerQuery = query.replace(/,/g, '').toLowerCase();
    // const lowerCaseQuery = lowerQuery.toLowerCase().trim();

    setSearchQuery(query);
    filterLeadReports(query);
    setCurrentPage(1); // ✅ Reset to first page when searching
  };

  const filterLeadReports = (query) => {
    const lowerCaseQuery = query
      .toLowerCase()
      .trim()
      .replace(/,/g, ""); // ✅ remove commas for search only

    // Apply same group, client, and year filters as the useEffect so search respects dropdowns
    let filteredData = [...loggedUserData];
    if (AssignedGroup && AssignedGroup !== "All") {
      filteredData = filteredData.filter(
        (lead) => getPlRowGroupId(lead) === AssignedGroup
      );
    }
    if (clientFilter && clientFilter !== "All") {
      filteredData = filteredData.filter((lead) => lead.ClientName === clientFilter);
    }
    const quarterMapping = {
      "Jan - Mar": ["Jan", "Feb", "Mar"],
      "Apr - Jun": ["Apr", "May", "Jun"],
      "Jul - Sep": ["Jul", "Aug", "Sep"],
      "Oct - Dec": ["Oct", "Nov", "Dec"],
      "Apr - Jul": ["Apr", "May", "Jun", "Jul"],
      "Aug - Nov": ["Aug", "Sep", "Oct", "Nov"],
      "Dec - Mar": ["Dec", "Jan", "Feb", "Mar"],
    };
    if (selectedYears?.length > 0) {
      filteredData = filteredData.filter((lead) => {
        const dateRaw = lead.LeadDate ?? lead.leadDate;
        const leadDate = new Date(dateRaw);
        if (!dateRaw || isNaN(leadDate.getTime())) return false; // Exclude leads with missing/invalid dates when year filter is applied
        const leadYear = leadDate.getFullYear().toString();
        const leadMonth = leadDate.toLocaleString("default", {
          month: "short",
        });
        return selectedYears?.some((entry) => {
          const entryStr = String(entry).trim();
          const [entryYear, ...rest] = entryStr.split(" ");
          const joinedRest = rest
            .join(" ")
            .replace(/\s*-\s*/g, " - ")
            .trim();
          const normalizedMonth = leadMonth.trim();
          const normalizedJoined = joinedRest;
          if (entryStr === leadYear) return true;
          if (
            entryYear === leadYear &&
            normalizedJoined.toLowerCase() === normalizedMonth.toLowerCase()
          )
            return true;
          if (
            entryYear === leadYear &&
            quarterMapping[normalizedJoined]?.includes(normalizedMonth)
          )
            return true;
          return false;
        });
      });
    }

    // Now apply search text filter on the year/group/client-filtered data
    const filtered = filteredData.filter((leadReport) => {
      const projectName = leadReport.ProjectName?.toLowerCase() || "";
      const quotedValue = String(leadReport.QuotedValue || "").toLowerCase();
      const ClientName = String(leadReport.ClientName || "").toLowerCase();
      const leadGroupLabel = String(getPlDisplayGroupName(leadReport) || "").toLowerCase();

      const quotedExpenses = String(leadReport.quotedExpense || "").toLowerCase();
      const calculatedExpenses = showExpensesop(getRowKey(leadReport)).toLowerCase().replace(/[$,]/g, "");

      return (
        projectName.includes(lowerCaseQuery) ||
        quotedValue.includes(lowerCaseQuery) ||
        quotedExpenses.includes(lowerCaseQuery) ||
        calculatedExpenses.includes(lowerCaseQuery) ||
        ClientName.includes(lowerCaseQuery) ||
        leadGroupLabel.includes(lowerCaseQuery)
      );
    });
    setSearchedLeadReports(filtered);
    setSearchedLeadReportswithoutyears(filtered);
  };


  // Invalidate cache and fetch auth before leads so L3 empGroups are set; then fetch leads for P&L table.
  useEffect(() => {
    dispatch(invalidateLeadsCache());
    dispatch(fetchEmployeeAuthData()).then((result) => {
      if (fetchEmployeeAuthData.fulfilled.match(result)) {
        dispatch(fetchLeads());
        return;
      }
      const role = localStorage.getItem("userRole") || localStorage.getItem("auth");
      if (role && role !== "L3") {
        dispatch(fetchLeads());
      }
    });
    dispatch(fetchGroups());
  }, [dispatch]);

  const handleClientChange = (clientValue) => {
    setClientFilter(clientValue);
    setShowClientDropdown(false);
  };

  useEffect(() => {
    let filteredData = [...loggedUserData];
    // Apply group filter (group id)
    if (AssignedGroup && AssignedGroup !== "All") {
      filteredData = filteredData.filter(
        (lead) => getPlRowGroupId(lead) === AssignedGroup
      );
    }

    // Apply client filter
    if (clientFilter && clientFilter !== "All") {
      filteredData = filteredData.filter((lead) => lead.ClientName === clientFilter);
    }

    // Actual P&L / graphs: universe without year filter (name kept for downstream consumers)
    setSearchedLeadReportswithoutyears([...filteredData]);

    // Define quarter ranges
    const quarterMapping = {
      "Jan - Mar": ["Jan", "Feb", "Mar"],
      "Apr - Jun": ["Apr", "May", "Jun"],
      "Jul - Sep": ["Jul", "Aug", "Sep"],
      "Oct - Dec": ["Oct", "Nov", "Dec"],
      "Apr - Jul": ["Apr", "May", "Jun", "Jul"],
      "Aug - Nov": ["Aug", "Sep", "Oct", "Nov"],
      "Dec - Mar": ["Dec", "Jan", "Feb", "Mar"],
    };

    // Filter by selected years (only if years are selected)
    if (selectedYears?.length > 0) {
      filteredData = filteredData.filter((lead) => {
        const dateRaw = lead.LeadDate ?? lead.leadDate;
        const leadDate = new Date(dateRaw);
        if (!dateRaw || isNaN(leadDate.getTime())) return false; // Exclude leads with missing/invalid dates when year filter is applied
        const leadYear = leadDate.getFullYear().toString();
        const leadMonth = leadDate.toLocaleString("default", {
          month: "short",
        });

        return selectedYears?.some((entry) => {
          const entryStr = String(entry).trim();
          const [entryYear, ...rest] = entryStr.split(" ");
          const joinedRest = rest
            .join(" ")
            .replace(/\s*-\s*/g, " - ")
            .trim();

          const normalizedMonth = leadMonth.trim();
          const normalizedJoined = joinedRest;

          // ✅ Match year only (e.g. "2025")
          if (entryStr === leadYear) return true;

          // ✅ Match month (e.g. "2025 Feb")
          if (
            entryYear === leadYear &&
            normalizedJoined.toLowerCase() === normalizedMonth.toLowerCase()
          )
            return true;

          // ✅ Match quarter (e.g. "2025 Apr - Jun")
          if (
            entryYear === leadYear &&
            quarterMapping[normalizedJoined]?.includes(normalizedMonth)
          )
            return true;

          return false;
        });
      });
    }

    // If user has a search query, apply search filter on top of year/group/client so dropdown changes don't clear search
    const searchTrimmed = searchQuery?.trim().replace(/,/g, "") || "";
    if (searchTrimmed) {
      const lowerCaseQuery = searchTrimmed.toLowerCase();
      filteredData = filteredData.filter((leadReport) => {
        const projectName = leadReport.ProjectName?.toLowerCase() || "";
        const quotedValue = String(leadReport.QuotedValue || "").toLowerCase();
        const ClientName = String(leadReport.ClientName || "").toLowerCase();
        const leadGroupLabel = String(getPlDisplayGroupName(leadReport) || "").toLowerCase();
        const quotedExpenses = String(leadReport.quotedExpense || "").toLowerCase();
        const calculatedExpenses = showExpensesop(getRowKey(leadReport)).toLowerCase().replace(/[$,]/g, "");
        return (
          projectName.includes(lowerCaseQuery) ||
          quotedValue.includes(lowerCaseQuery) ||
          quotedExpenses.includes(lowerCaseQuery) ||
          calculatedExpenses.includes(lowerCaseQuery) ||
          ClientName.includes(lowerCaseQuery) ||
          leadGroupLabel.includes(lowerCaseQuery)
        );
      });
    }
    setSearchedLeadReports(filteredData);
    // showExpensesop is defined later; used in search filter via closure (stable useCallback).
    // eslint-disable-next-line react-hooks/exhaustive-deps -- showExpensesop declared below this hook (cannot list in deps)
  }, [
    loggedUserData,
    selectedYears,
    AssignedGroup,
    clientFilter,
    searchQuery,
    getPlRowGroupId,
    getPlDisplayGroupName,
    getRowKey,
  ]);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const allMonths = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const quarters = ["Jan - Mar", "Apr - Jun", "Jul - Sep", "Oct - Dec"];

    const data = Array.from({ length: 5 }, (_, i) => {
      const year = currentYear - i;
      return {
        Year: year,
        months: allMonths,
        quarter: quarters,
      };
    });

    setYearData(data);
  }, []);

  const handleYearSelection = (value) => {
    setSelectedYears((prev) => {
      if (prev.includes(value)) {
        // Remove value if already selected
        return prev.filter((item) => item !== value);
      } else {
        // Add value if not already selected
        return [value];
      }
    });
  };

  useEffect(() => {
    const userEmail = localStorage.getItem("email");
    const currentEmployee = employees.find((emp) => emp.EmpEmail === userEmail);
    const filteredTaxes = taxes.filter(tax => tax.createdBy === currentEmployee?._id);
    filteredTaxes?.forEach((data) => {
      if (data.taxName === "G&A Expenses") {
        setGandATax(data.taxPercentage);
      } else if (data.taxName === "Tax") {
        setTaxValue(data.taxPercentage);
      }
    });
  }, [taxes, employees]);
  // const [perdiem, setperdiem] = useState(14);
  // const [averagecost, setaveragecost] = useState(17);

  const [searchedCalcProjects, setSearchedCalcProjects] = useState([]);

  useEffect(() => {
    if (!searchedLeadReports || !financeDataProject) return;

    const matchedProjects = financeDataProject.filter((row) =>
      searchedLeadReports.some((proj) =>
        row.quotationId != null && proj.quotationId != null
          ? String(row.quotationId).trim() === String(proj.quotationId).trim()
          : row.ProjectName === proj.ProjectName
      )
    );

    setSearchedCalcProjects(matchedProjects);
  }, [searchedLeadReports, financeDataProject]);

  const [mergedProjects, setMergedProjects] = useState([]);

  useEffect(() => {
    if (!searchedCalcProjects || !tasks || !entries) return;

    const newData = searchedCalcProjects.map((proj) => {
      const matchedEntries = entries.filter(
        (entry) => entry.projectid === proj._id
      );

      const matchedDescriptions = tasks.filter(
        (task) => task.projectid === proj._id
      );
      const matchedHardware = items.filter(
        (task) => task.projectid === proj._id
      );

      return {
        ProjectName: proj.ProjectName,
        quotationId: proj.quotationId ?? null,
        TaskList: matchedEntries,
        Description: matchedDescriptions,
        TypeService: proj.TypeService,
        HardwareList: matchedHardware,
        Assignedperson: proj.Assignedperson,
        AssignedManagerEmail: proj.AssignedManagerEmail[0],
        SalesPersonEmail: proj.SalesPersonEmail,
      };
    });

    // const grouped = Object.values(
    //   newData.reduce((acc, project) => {
    //     if (!acc[project.ProjectName]) {
    //       acc[project.ProjectName] = {
    //         ProjectName: project.ProjectName,
    //         projects: [], // hold all occurrences
    //       };
    //     }
    //     acc[project.ProjectName].projects.push(project);
    //     return acc;
    //   }, {})
    // );

    setMergedProjects(newData);
  }, [searchedCalcProjects, tasks, entries, items]);

  const [combinedProjects, setCombinedProjects] = useState([]);

  useEffect(() => {
    if (!mergedProjects || mergedProjects.length === 0) return;

    const projectGroupKey = (project) =>
      project.quotationId != null && String(project.quotationId).trim() !== ""
        ? String(project.quotationId).trim()
        : project.ProjectName;

    const grouped = Object.values(
      mergedProjects.reduce((acc, project) => {
        const key = projectGroupKey(project);
        if (!acc[key]) {
          acc[key] = {
            ProjectName: project.ProjectName,
            quotationId: project.quotationId ?? null,
            salespersonEmail: project.SalesPersonEmail,
            TaskList: [],
            Description: [],
            HardwareList: [],
          };
        }

        acc[key].TaskList.push(...(project.TaskList || []));
        acc[key].Description.push(...(project.Description || []));
        acc[key].HardwareList.push(...(project.HardwareList || []));

        return acc;
      }, {})
    );

    setCombinedProjects(grouped);
  }, [mergedProjects]);

  const [groupedProjects, setGroupedProjects] = useState([]);


  // useEffect(() => {
  //   if (!combinedProjects || !employees) return;

  //   const updatedProjects = combinedProjects.map((project) => {
  //     // helper to map arrays
  //     const enrichWithDesignation = (arr) =>
  //       arr.map((item) => {
  //         const emp = employees.find(
  //           (e) => e._id === item.taskownerid || e._id === item.createdBy
  //         );
  //         if (emp) {
  //           return {
  //             ...item,
  //             designation: `${emp.servicetype || ""} ${emp.customRoles?.[0] || ""
  //               }`.trim(),
  //           };
  //         }
  //         return item;
  //       });

  //     return {
  //       ...project,
  //       Description: project.Description
  //         ? enrichWithDesignation(project.Description)
  //         : [],
  //       TaskList: project.TaskList
  //         ? enrichWithDesignation(project.TaskList)
  //         : [],
  //       HardwareList: project.HardwareList
  //         ? enrichWithDesignation(project.HardwareList)
  //         : [],
  //     };
  //   });

  //   setGroupedProjects(updatedProjects);
  // }, [combinedProjects, employees]);



  useEffect(() => {
    if (!combinedProjects?.length || !employees?.length) return;

    const updatedProjects = combinedProjects.map((project) => {
      const enrichWithDesignation = (arr = []) =>
        arr.map((item) => {
          // Prefer taskownerid first
          const emp =
            employees.find((e) => e._id === item.taskownerid) ||
            employees.find((e) => e._id === item.createdBy);

          if (emp) {
            // Only include designation if servicetype or customRoles exist
            const designationParts = [];
            if (emp.servicetype) designationParts.push(emp.servicetype);
            if (emp.customRoles?.length) designationParts.push(emp.customRoles[0]);

            return {
              ...item,
              designation: designationParts.join(" ").trim() || null,
            };
          }

          return { ...item, designation: null };
        });

      return {
        ...project,
        Description: enrichWithDesignation(project.Description),
        TaskList: enrichWithDesignation(project.TaskList),
        HardwareList: enrichWithDesignation(project.HardwareList),
      };
    });

    setGroupedProjects(updatedProjects);
  }, [combinedProjects, employees]);

  const [quotationProjects, setquotationProjects] = useState([]);
  useEffect(() => {
    if (quotationProjects?.length) {
      dispatch(setOtheeExpensesData(quotationProjects))
    }
  }, [dispatch, quotationProjects]);

  // useEffect(() => {
  //   if (!groupedProjects || !quotations) return;

  //   const updatedProjects = groupedProjects.map((project) => {
  //     // helper to map arrays and add hourlysalaray
  //     const enrichWithQuotation = (arr) =>
  //       arr.map((item) => {
  //         if (!item.designation) return item;
  //         const matchedQuote = quotations.find(
  //           (q) => q.designation === item.designation
  //         );
  //         if (matchedQuote) {
  //           return {
  //             ...item,
  //             hourlysalaray: matchedQuote.hourlysalaray + matchedQuote.overheadpercentage || 0, // add salary
  //           };
  //         }
  //         return item;
  //       });

  //     return {
  //       ...project,
  //       TaskList: project.TaskList ? enrichWithQuotation(project.TaskList) : [],
  //       Description: project.Description
  //         ? enrichWithQuotation(project.Description)
  //         : [],
  //       HardwareList: project.HardwareList
  //         ? enrichWithQuotation(project.HardwareList)
  //         : [],
  //     };
  //   });

  //   setquotationProjects(updatedProjects);
  // }, [groupedProjects, quotations]);


  useEffect(() => {
    if (!groupedProjects || !hourlyRateData || !employees) return;

    const updatedProjects = groupedProjects.map((project) => {
      // Find the employee based on AssignedManagerEmail
      const assignedEmployee = employees.find(
        (emp) => emp.EmpEmail === project.salespersonEmail
      );

      // If no employee found, return project as is
      if (!assignedEmployee) return project;

      // helper to map arrays and add hourlysalary with filtered quotations
      const enrichWithQuotation = (arr) =>
        arr.map((item) => {
          if (!item.designation) return {
            ...item,
            // ensure defaults exist even when designation missing
            hourlysalaray: item.hourlysalaray || 0,
            overheadpercentage: item.overheadpercentage || 0,
          };

          // Find quotation that matches both designation AND createdBy matches employee _id
          const matchedQuote = hourlyRateData?.find(
            (q) => q.designation === item.designation
            // &&
            //   q.createdBy === assignedEmployee._id
          );

          const hourlysalaray = (item.hourlysalaray ?? (matchedQuote?.hourlysalaray ?? 0)) || 0;
          const overheadpercentage = (item.overheadpercentage ?? (matchedQuote?.overheadpercentage ?? 0)) || 0;

          return {
            ...item,
            hourlysalaray,
            overheadpercentage,
          };
        });

      return {
        ...project,
        TaskList: project.TaskList ? enrichWithQuotation(project.TaskList) : [],
        Description: project.Description
          ? enrichWithQuotation(project.Description)
          : [],
        HardwareList: project.HardwareList
          ? enrichWithQuotation(project.HardwareList)
          : [],
      };
    });

    setquotationProjects(updatedProjects);
  }, [groupedProjects, hourlyRateData, employees]);

  const [, setInstallationDescriptions] = useState([]);

  useEffect(() => {
    if (!quotationProjects || quotationProjects.length === 0) return;

    const filteredProjects = quotationProjects
      .map((proj) => {
        const matchedDescriptions = (proj.Description || []).filter(
          (desc) =>
            desc.typeservice &&
            desc.typeservice.toLowerCase().includes("installation") &&
            desc.designation &&
            desc.designation.toLowerCase().includes("operations")
        );

        if (matchedDescriptions.length > 0) {
          return {
            ProjectName: proj.ProjectName,
            Description: matchedDescriptions,
          };
        }
        return null;
      })
      .filter(Boolean); // remove nulls

    setInstallationDescriptions(filteredProjects);
  }, [quotationProjects]);

  const [calculatedProjects, setCalculatedProjects] = useState([]);

  // useEffect(() => {
  //   if (!quotationProjects || quotationProjects.length === 0) return;

  //   const newData = quotationProjects.map((proj) => {
  //     let taskValue = 0;
  //     let descriptionValue = 0;
  //     let hardwareValue = 0;
  //     // ✅ TaskList calculation
  //     if (proj.TaskList?.length > 0) {
  //       // Create a map to store total hours per taskownerid
  //       const hoursByOwner = {};

  //       proj.TaskList.forEach((task) => {
  //         if (task.taskownerid && task.hoursassigned) {
  //           if (!hoursByOwner[task.taskownerid]) {
  //             hoursByOwner[task.taskownerid] = {
  //               totalHours: 0,
  //               hourlyRate: task.hourlysalaray || 0
  //             };
  //           }
  //           hoursByOwner[task.taskownerid].totalHours += task.hoursassigned;
  //         }
  //       });

  //       // Calculate total task value by summing (totalHours * hourlyRate) for each owner
  //       Object.values(hoursByOwner).forEach((ownerData) => {
  //         taskValue += ownerData.totalHours * ownerData.hourlyRate;
  //       });
  //     }

  //     // ✅ Description calculation
  //     // if (proj.Description?.length > 0) {
  //     //   proj.Description.forEach((desc) => {
  //     //     if (desc.value && desc.hourlysalaray) {
  //     //       descriptionValue += desc.value * desc.hourlysalaray;
  //     //     }
  //     //   });
  //     // }
  //     if (proj.Description?.length > 0) {
  //       proj.Description.forEach((desc) => {
  //         // Skip this entry if designation includes "hardware" (case-insensitive)
  //         if (desc.designation && desc.designation.toLowerCase().includes('hardware')) {
  //           return; // skip this iteration
  //         }

  //         if (desc.value) {
  //           descriptionValue += desc.value;
  //         }
  //       });
  //     }

  //     // ✅ HardwareList calculation
  //     if (proj.HardwareList?.length > 0) {
  //       proj.HardwareList.forEach((hw) => {
  //         if (hw.totalprice) {
  //           hardwareValue += hw.totalprice;
  //         }
  //       });
  //     }

  //     return {
  //       ProjectName: proj.ProjectName,
  //       TaskListValue: taskValue,
  //       DescriptionValue: descriptionValue,
  //       HardwareListValue: hardwareValue,
  //     };
  //   });

  //   setCalculatedProjects(newData);
  // }, [quotationProjects]);

  useEffect(() => {
    const expensesForUser = scopeOtherExpensesForUser(otherExpenses, {
      loggedUserId: loggedUserIdForRates,
    });
    const { perdiem: p, averagecost: a } =
      getPerdiemAndAverageCostFromExpenses(expensesForUser);
    setperdiem(p);
    setaveragecost(a);
  }, [otherExpenses, loggedUserIdForRates]);

  useEffect(() => {
    if (!quotationProjects || quotationProjects.length === 0) return;

    const newData = quotationProjects.map((proj) => {
      let taskValue = 0;
      let descriptionValue = 0;
      let hardwareValue = 0;

      // ✅ TaskList calculation
      if (proj.TaskList?.length > 0) {
        const hoursByOwner = {};

        proj.TaskList.forEach((task) => {
          if (task.taskownerid && task.hoursassigned) {
            if (!hoursByOwner[task.taskownerid]) {
              hoursByOwner[task.taskownerid] = {
                totalHours: 0,
                hourlyRate: task.hourlysalaray || 0
              };
            }
            hoursByOwner[task.taskownerid].totalHours += task.hoursassigned;
          }
        });

        Object.values(hoursByOwner).forEach((ownerData) => {
          taskValue += ownerData.totalHours * ownerData.hourlyRate;
        });
      }

      // ✅ Description calculation with Installation service condition
      if (proj.Description?.length > 0) {
        // Create a map to track trip duration per taskownerid for Installation services
        const installationTripByOwner = {};

        proj.Description.forEach((desc) => {
          // Skip hardware designations
          // if (desc.designation && desc.designation.toLowerCase().includes('hardware')) {
          //   return;
          // }

          // For Installation services, track trip duration per owner
          if (desc.typeservice && desc.typeservice.toLowerCase().includes('installation') &&
            desc.taskownerid && desc.tripduration) {
            if (!installationTripByOwner[desc.taskownerid]) {
              installationTripByOwner[desc.taskownerid] = desc.tripduration;
            } else {
              // Use the maximum trip duration for each owner
              installationTripByOwner[desc.taskownerid] =
                Math.max(installationTripByOwner[desc.taskownerid], desc.tripduration);
            }
          }

          // Add the normal value calculation
          if (desc.value) {
            descriptionValue += desc.value;
          }
        });

        // Add Installation trip duration calculations (per diem + other expenses)
        Object.values(installationTripByOwner).forEach((tripDuration) => {
          // Assuming you have state variables called perdiem and otherExpense
          descriptionValue += (tripDuration * perdiem) + (tripDuration * averagecost);
        });
      }

      // ✅ HardwareList calculation
      if (proj.HardwareList?.length > 0) {
        proj.HardwareList.forEach((hw) => {
          if (hw.totalprice) {
            hardwareValue += hw.totalprice;
          }
        });
      }

      return {
        ProjectName: proj.ProjectName,
        quotationId: proj.quotationId ?? null,
        TaskListValue: taskValue,
        DescriptionValue: descriptionValue,
        HardwareListValue: hardwareValue,
      };
    });

    setCalculatedProjects(newData);
  }, [quotationProjects, perdiem, averagecost]);

  // const showExpensesop = useCallback((projectName) => {

    
  //   const matchedProjectfinal = quotationProjects.find(
  //     (proj) => proj.ProjectName === projectName
  //   );
  //   if (!matchedProjectfinal) {
  //     return "0";
  //   }

  //   const totalTaskValue = matchedProjectfinal?.TaskList.reduce((total, task) => {
  //     const hoursSpent = Number(task.hoursassigned) || 0;
  //     const hourlySalary = Number(task.hourlysalaray) || 0;
  //     const overhead = Number(task.overheadpercentage) || 0;

  //     // ✅ Overhead is a direct addition, not a percentage
  //     const effectiveHourlySalary = hourlySalary + overhead;

  //     const taskValue = hoursSpent * effectiveHourlySalary;

  //     return total + taskValue;
  //   }, 0);

  //   let descriptionValue = 0;

  //   if (matchedProjectfinal.Description?.length > 0) {
  //     // Create a map to track trip duration per taskownerid for Installation services
  //     const installationTripByOwner = {};

  //     matchedProjectfinal.Description.forEach((desc) => {


  //       // For Installation services, track trip duration per owner
  //       if (desc.typeservice && desc.typeservice.toLowerCase().includes('installation') &&
  //         desc.taskownerid && desc.tripduration) {
  //         if (!installationTripByOwner[desc.taskownerid]) {
  //           installationTripByOwner[desc.taskownerid] = desc.tripduration;
  //         } else {
  //           // Use the maximum trip duration for each owner
  //           installationTripByOwner[desc.taskownerid] =
  //             Math.max(installationTripByOwner[desc.taskownerid], desc.tripduration);
  //         }
  //       }

  //       // Add the normal value calculation
  //       if (desc.value) {
  //         descriptionValue += desc.value;
  //       }
  //     });

  //     // Add Installation trip duration calculations (per diem + other expenses)
  //     Object.values(installationTripByOwner).forEach((tripDuration) => {
  //       // Assuming you have state variables called perdiem and otherExpense
  //       descriptionValue += (tripDuration * perdiem) + (tripDuration * averagecost);
  //     });
  //   }
  //   let hardwareValue = 0;


  //   if (matchedProjectfinal.HardwareList?.length > 0) {
  //     const hardwareByDescription = {};

  //     // Group hardware by assemblepartdescription and keep only the one with highest totalprice
  //     matchedProjectfinal.HardwareList.forEach((hw) => {
  //       const description = hw.assemblepartdescription;

  //       if (!hardwareByDescription[description]) {
  //         hardwareByDescription[description] = hw;
  //       } else {
  //         // If we already have this description, keep the one with higher totalprice
  //         if (hw.totalprice > hardwareByDescription[description].totalprice) {
  //           hardwareByDescription[description] = hw;
  //         }
  //       }
  //     });

  //     // Calculate total hardware value using only the highest totalprice items
  //     Object.values(hardwareByDescription).forEach((hw) => {
  //       if (hw.totalprice) {
  //         hardwareValue += hw.totalprice;
  //       }
  //     });
  //   }
  //   const grandTotals = totalTaskValue + descriptionValue + hardwareValue;
  //   return `${USAComma(grandTotals)}`;

  // }, [quotationProjects, perdiem, averagecost, USAComma]);

  // Add these useEffects after the searchedLeadReports useEffect
  
  
  // projectKey must be from getRowKey(row) so quotationId is used first when present (mandatory for P&L table)
  const showExpensesop = useCallback((projectKey) => {
    const normalizedKey = String(projectKey ?? "").trim();
    const matchedProjectfinal = quotationProjects.find(
      (proj) =>
        (proj?.quotationId != null && String(proj.quotationId).trim() === normalizedKey) ||
        String(proj?.ProjectName ?? "").trim() === normalizedKey
    );

    if (!matchedProjectfinal) {
      return "0";
    }

    // Use quotationId first: only treat as "quoted" when match is by quotationId, else by ProjectName only if qp has no quotationId (avoid same name, different quotationId)
    const projectExistsInQuoted = quotedproject?.some(qp =>
      (qp?.quotationId != null && String(qp.quotationId).trim() !== "" && String(qp.quotationId).trim() === normalizedKey) ||
      (String(qp?.ProjectName ?? "").trim() === normalizedKey && (qp?.quotationId == null || String(qp.quotationId).trim() === ""))
    );

    const totalTaskValue = matchedProjectfinal?.TaskList.reduce((total, task) => {
      const hoursSpent = Number(task.hoursassigned) || 0;

      let hourlyRate = 0;

      // Only use quotedprject logic if project exists in quotedprject
      if (projectExistsInQuoted) {
        // Find the specific quoted project for this task
        const taskQuotedProject = quotedproject?.find(qp =>
          qp._id === task.projectid
        );

        if (taskQuotedProject) {
          const isManager = task.designation?.toLowerCase().includes('manager');
          const isOperations = task.designation?.toLowerCase().includes('operations');

          if (isManager) {
            hourlyRate = taskQuotedProject.managerHourlyRate || 0;
          } else if (isOperations) {
            hourlyRate = taskQuotedProject.operationHourlyRate || 0;
          }

          // If still no rate found, fall back to old logic
          if (hourlyRate === 0) {
            const hourlySalary = Number(task.hourlysalaray) || 0;
            const overhead = Number(task.overheadpercentage) || 0;
            hourlyRate = hourlySalary + overhead;
          }
        } else {
          // If quoted project not found for this specific task, use old logic
          const hourlySalary = Number(task.hourlysalaray) || 0;
          const overhead = Number(task.overheadpercentage) || 0;
          hourlyRate = hourlySalary + overhead;
        }
      } else {
        // Project not in quotedprject, use old logic
        const hourlySalary = Number(task.hourlysalaray) || 0;
        const overhead = Number(task.overheadpercentage) || 0;
        hourlyRate = hourlySalary + overhead;
      }

      const taskValue = hoursSpent * hourlyRate;
      return total + taskValue;
    }, 0);

    let descriptionValue = 0;

    if (matchedProjectfinal.Description?.length > 0) {
      // Create a map to track trip duration per taskownerid for Installation services
      const installationTripByOwner = {};

      matchedProjectfinal.Description.forEach((desc) => {
        // For Installation services, track trip duration per owner
        if (desc.typeservice && desc.typeservice.toLowerCase().includes('installation') &&
          desc.taskownerid && desc.tripduration) {
          if (!installationTripByOwner[desc.taskownerid]) {
            installationTripByOwner[desc.taskownerid] = {
              tripDuration: desc.tripduration,
              projectid: desc.projectid,
            };
          } else {
            installationTripByOwner[desc.taskownerid].tripDuration = Math.max(
              installationTripByOwner[desc.taskownerid].tripDuration,
              desc.tripduration
            );
            if (desc.projectid) {
              installationTripByOwner[desc.taskownerid].projectid = desc.projectid;
            }
          }
        }

        // Add the normal value calculation
        if (desc.value) {
          descriptionValue += desc.value;
        }
      });

      // Add Installation trip duration calculations (per diem + other expenses)
      Object.values(installationTripByOwner).forEach(({ tripDuration, projectid }) => {
        let instPerdiem = perdiem;
        let instAvgcost = averagecost;
        if (projectExistsInQuoted && projectid) {
          const instQuotedProject = quotedproject?.find(
            (qp) => String(qp._id) === String(projectid)
          );
          if (instQuotedProject) {
            instPerdiem = Number(instQuotedProject.perdiem) || 0;
            instAvgcost =
              Number(instQuotedProject.avgcost ?? instQuotedProject.averagecost) || 0;
          }
        }
        descriptionValue += tripDuration * instPerdiem + tripDuration * instAvgcost;
      });
    }

    let hardwareValue = 0;

    if (matchedProjectfinal.HardwareList?.length > 0) {
      const hardwareByDescription = {};

      // Group hardware by assemblepartdescription and keep only the one with highest totalprice
      matchedProjectfinal.HardwareList.forEach((hw) => {
        const description = hw.assemblepartdescription;

        if (!hardwareByDescription[description]) {
          hardwareByDescription[description] = hw;
        } else {
          // If we already have this description, keep the one with higher totalprice
          if (hw.totalprice > hardwareByDescription[description].totalprice) {
            hardwareByDescription[description] = hw;
          }
        }
      });

      // Calculate total hardware value using only the highest totalprice items
      Object.values(hardwareByDescription).forEach((hw) => {
        if (hw.totalprice) {
          hardwareValue += hw.totalprice;
        }
      });
    }

    const grandTotals = totalTaskValue + descriptionValue + hardwareValue;
    return `${USAComma(grandTotals)}`;
  }, [quotationProjects, quotedproject, perdiem, averagecost, USAComma]);

  // Returns numeric cost for a project - used by Gross Profit panel to match P&L table totals
  const getProjectCost = useCallback((projectKey) => {
    const costStr = showExpensesop(projectKey);
    return parseFloat(String(costStr || "0").replace(/[,$]/g, "")) || 0;
  }, [showExpensesop]);

  useEffect(() => {
    // Quoted: hide only directly-won leads when Actual tab is available.
    // Gross Profit Quoted uses the same exclusion (see plLeadsUniverse below).
    if (searchedLeadReports && searchedLeadReports.length > 0 && selectedServiceTypes === "QuotedExpense") {
      const nextRows = searchedLeadReports.filter((lead) => {
        if (!routeDirectWonToActualTab) return true;
        const key = getRowKey(lead);
        const parsedDisplayed = parseFloat(
          String(showExpensesop(key) ?? "0").replace(/[,$]/g, "")
        );
        // Do not use `|| getLeadQuotedExpenseNum` — a real 0 expense is falsy and would
        // incorrectly fall back to a stored lead field, keeping direct-won rows on Quoted.
        const displayedExpense = Number.isFinite(parsedDisplayed)
          ? parsedDisplayed
          : getLeadQuotedExpenseNum(lead);
        return !isDirectWonLead(lead, projects, { quotedExpenseNum: displayedExpense });
      });
      setFilteredTableData(nextRows);
    } else if (searchedLeadReports && searchedLeadReports.length > 0 && selectedServiceTypes === "CRM") {
      setFilteredTableData(searchedLeadReports)
    }
    else {
      setFilteredTableData([]);
    }
  }, [searchedLeadReports, showExpensesop, selectedServiceTypes, getRowKey, routeDirectWonToActualTab, projects]);

  // Add another useEffect to update when financeDataProject changes
  useEffect(() => {
    if (searchedLeadReports && searchedLeadReports.length > 0 && selectedServiceTypes === "QuotedExpense") {
      const nextRows = searchedLeadReports.filter((lead) => {
        if (!routeDirectWonToActualTab) return true;
        const key = getRowKey(lead);
        const parsedDisplayed = parseFloat(
          String(showExpensesop(key) ?? "0").replace(/[,$]/g, "")
        );
        const displayedExpense = Number.isFinite(parsedDisplayed)
          ? parsedDisplayed
          : getLeadQuotedExpenseNum(lead);
        return !isDirectWonLead(lead, projects, { quotedExpenseNum: displayedExpense });
      });
      setFilteredTableData(nextRows);

    } else if (searchedLeadReports && searchedLeadReports.length > 0 && selectedServiceTypes === "CRM") {
      setFilteredTableData(searchedLeadReports)
    }
  }, [financeDataProject, showExpensesop, searchedLeadReports, selectedServiceTypes, getRowKey, routeDirectWonToActualTab, projects]);

  useEffect(() => {
    if (searchedLeadReports.length > 0) {
      // IMPORTANT: do NOT overwrite `quotedValues` on every filter change (YEAR/GROUP/CLIENT).
      // Overwriting makes the map dependent on the P&L filters and breaks Gross Profit year isolation.
      // Instead, merge: only initialize keys that aren't already present.
      setQuotedValues((prev) => {
        const next = { ...(prev || {}) };
        searchedLeadReports.forEach((lead) => {
          const key = getRowKey(lead);
          if (!key) return;
          if (isCrmPackage) {
            // CRM: prefer quotedPrice — lead.QuotedValue can be an API aggregate and inflates Tax/Net/G&A.
            const price = Number(lead?.quotedPrice ?? lead?.quoted_price ?? lead?.QuotedPrice);
            const aggregate = Number(lead?.QuotedValue);
            const hasPrice = Number.isFinite(price) && price !== 0;
            const desired = hasPrice
              ? price
              : Number.isFinite(aggregate)
                ? aggregate
                : 0;
            const current = next[key];
            if (current === undefined || current === null) {
              next[key] = desired;
            } else if (
              hasPrice &&
              Number.isFinite(Number(current)) &&
              Number(current) === aggregate &&
              aggregate !== price
            ) {
              // Repair keys stuck on inflated QuotedValue aggregate.
              next[key] = price;
            }
            return;
          }
          if (next[key] !== undefined && next[key] !== null) return;
          next[key] = lead?.QuotedValue ?? lead?.quotedPrice ?? lead?.quoted_price ?? 0;
        });
        return next;
      });

      setComments((prev) => {
        const next = { ...(prev || {}) };
        searchedLeadReports.forEach((lead) => {
          const key = getRowKey(lead);
          if (!key) return;
          if (next[key] !== undefined && next[key] !== null) return;
          next[key] = lead?.projectnotes || "";
        });
        return next;
      });
    }
  }, [searchedLeadReports, getRowKey, isCrmPackage]);

  // CRM: Gross Profit section year filter must be fully independent from P&L year filter.
  // That requires Quoted Price / Quoted Expenses maps to be built from the full P&L lead universe,
  // not from the currently filtered P&L rows (`searchedLeadReports`).
  useEffect(() => {
    if (!isCrmPackage) return;
    if (selectedServiceTypes !== "CRM") return;
    const rows = Array.isArray(profitAndLossLeadsSource) ? profitAndLossLeadsSource : [];
    if (rows.length === 0) return;

    setQuotedValues((prev) => {
      const next = { ...(prev || {}) };
      rows.forEach((lead) => {
        const key = getRowKey(lead);
        if (!key) return;
        // CRM: prefer quotedPrice over inflated QuotedValue aggregate.
        const price = Number(lead?.quotedPrice ?? lead?.quoted_price ?? lead?.QuotedPrice);
        const aggregate = Number(lead?.QuotedValue);
        const hasPrice = Number.isFinite(price) && price !== 0;
        const desired = hasPrice
          ? price
          : Number.isFinite(aggregate)
            ? aggregate
            : 0;
        const current = next[key];
        if (current === undefined || current === null) {
          next[key] = desired;
        } else if (
          hasPrice &&
          Number.isFinite(Number(current)) &&
          Number(current) === aggregate &&
          aggregate !== price
        ) {
          next[key] = price;
        }
      });
      return next;
    });

    setQuotedExpenses((prev) => {
      const next = { ...(prev || {}) };
      rows.forEach((lead) => {
        const stableKey = getStableLeadKey(lead);
        if (!stableKey) return;
        if (next[stableKey] !== undefined && next[stableKey] !== null) return;

        const isQuotedFlag = getRowIsProjectQuoted(lead);
        const qe = getLeadQuotedExpenseValue(lead);
        const keepLeadExpense = isQuotedFlag || qe > 0;
        if (!keepLeadExpense) return;
        next[stableKey] = qe;
      });
      return next;
    });

    setQuotedExpenseInputs((prev) => {
      const next = { ...(prev || {}) };
      rows.forEach((lead) => {
        const stableKey = getStableLeadKey(lead);
        if (!stableKey) return;
        if (next[stableKey] !== undefined && next[stableKey] !== null) return;
        const isQuotedFlag = getRowIsProjectQuoted(lead);
        const qe = getLeadQuotedExpenseValue(lead);
        const keepLeadExpense = isQuotedFlag || qe > 0;
        if (!keepLeadExpense) return;
        next[stableKey] = qe;
      });
      return next;
    });
  }, [
    isCrmPackage,
    selectedServiceTypes,
    profitAndLossLeadsSource,
    getRowKey,
    getStableLeadKey,
  ]);


  const handleQuotedValueChange = (row, value) => {
    if (isViewOnlyPL) return;
    const numericValue = value === "" ? 0 : parseFloat(value) || 0;
    setQuotedValues(prev => ({
      ...prev,
      [getRowKey(row)]: numericValue
    }));
    return numericValue;
  };

  const handleQuotedValueInputChange = (row, value) => {
    if (isViewOnlyPL) return;
    const numericValue = value === "" ? 0 : parseFloat(value) || 0;
    setQuotedValues(prev => ({
      ...prev,
      [getRowKey(row)]: numericValue
    }));
    return numericValue;
  };




  useEffect(() => {
    if (searchedLeadReports.length > 0) {
      // CRM: do not prune quoted-expense maps based on P&L year filters.
      // These maps must contain values for all years so the Gross Profit section stays isolated.
      if (selectedServiceTypes === "CRM") return;
      setQuotedExpenses((prev) => {
        const next = { ...prev };
        searchedLeadReports.forEach((lead) => {
          const stableKey = getStableLeadKey(lead);
          const isQuotedFlag = getRowIsProjectQuoted(lead);
          const qe = getLeadQuotedExpenseValue(lead);
          const keepLeadExpense = isQuotedFlag || (selectedServiceTypes === "CRM" && qe > 0);
          if (!keepLeadExpense) {
            if (next[stableKey] !== undefined) delete next[stableKey];
          } else if (next[stableKey] === undefined || next[stableKey] === null) {
            next[stableKey] = qe;
          }
        });
        return next;
      });
    }
  }, [searchedLeadReports, getStableLeadKey, selectedServiceTypes]);

  const handleQuotedExpensesChange = (row, value) => {
    setQuotedExpenseInputs(prev => ({
      ...prev,
      [getStableLeadKey(row)]: value
    }));
  };




  const Submit = async (selectedProject, newValue) => {
    if (isViewOnlyPL) return;
    try {
      const updatedLeadData = {
        QuotedValue: newValue, // Use the passed value instead of state
        ProjectName: selectedProject?.ProjectName,
        quotationId: selectedProject?.quotationId,
      };

      await dispatch(
        updateLead({ id: selectedProject.id, updatedData: updatedLeadData })
      ).unwrap();

      const rowKey = getRowKey(selectedProject);
      const patchLeadQuotedValue = (lead) => {
        if (!lead) return lead;
        const sameId =
          selectedProject?.id != null &&
          lead?.id != null &&
          String(lead.id) === String(selectedProject.id);
        const sameKey = getRowKey(lead) === rowKey;
        if (!sameId && !sameKey) return lead;
        return { ...lead, QuotedValue: newValue };
      };
      setSearchedLeadReports((prev) => (prev || []).map(patchLeadQuotedValue));
      setSearchedLeadReportswithoutyears((prev) =>
        (prev || []).map(patchLeadQuotedValue)
      );
      setLoggedUserData((prev) => (prev || []).map(patchLeadQuotedValue));
      setQuotedValues((prev) => ({
        ...prev,
        [rowKey]: newValue,
      }));

      dispatch(fetchLeads());
      enqueueSnackbar("Quoted Value Updated Successfully", {
        variant: "success",
      });

    } catch (error) {
      console.error("Error:", error);
      enqueueSnackbar(error?.error || error?.message || "Failed to update Quoted Value", { variant: "error" });
    } finally {
      handlerefresh()
    }
  };

  const SubmitQuotedExpenses = async (selectedProject, newValue) => {
    if (isViewOnlyPL) return;
    try {
      await dispatch(updateQuotedExpense({ id: selectedProject.id, quotedExpense: newValue })).unwrap();
      dispatch(fetchLeads());
      enqueueSnackbar("Quoted Expenses Updated Successfully", {
        variant: "success",
      });
    } catch (error) {
      console.error("Error:", error);
      enqueueSnackbar(error?.error || error?.message || "Failed to update Quoted Expenses", { variant: "error" });
    }
  };



  // Gross Profit = Value - Cost — use same cost as Quoted Expenses column (showExpensesop)
  const calculateGrossProfit = useCallback(
    (projectKey) => {
      const quotedValue = quotedValues[projectKey] ?? 0;
      const cost = getProjectCost(projectKey);
      return quotedValue - cost;
    },
    [quotedValues, getProjectCost]
  );

  // Pre-compute Itemized P&L totals for all projects so main table matches without requiring click
  // Project-level P&L totals so detail view total row matches the P&L table row (same formula: one gross profit, then G&A, Tax, Net Revenue)
  // Always use quotationId for project row identification when present (same as getRowKey)
  const projectLevelTotals = useMemo(() => {
    const projectKey = getRowKey(selectedProjectName);
    if (selectedServiceTypes !== "QuotedExpense" || !projectKey) return null;
    const quotedValue = quotedValues[projectKey] ?? selectedProjectName?.QuotedValue ?? 0;
    if (!quotedValue) return null;
    const cost = getProjectCost(projectKey);
    const grossProfit = quotedValue - cost;
    const gaExpenses = Math.round(grossProfit * (GandATax / 100));
    // Tax on EBIT (Gross Profit − G&A), not on Gross Profit
    const tax = (grossProfit - gaExpenses) * (taxValue / 100);
    const netRevenue = grossProfit - gaExpenses - tax;
    const netRevenuePct = quotedValue ? (netRevenue / quotedValue) * 100 : 0;
    return { grossProfit, gaExpenses, tax, netRevenue, netRevenuePct };
  }, [selectedServiceTypes, selectedProjectName, quotedValues, getProjectCost, GandATax, taxValue, getRowKey]);

  // eslint-disable-next-line no-unused-vars
  const _legacyCalc = (projectKey) => {
    const quotedValue = quotedValues[projectKey] || 0;

    const matchedProjectfinal = quotationProjects.find(
      (proj) =>
        (proj.quotationId != null && String(proj.quotationId) === String(projectKey)) ||
        proj.ProjectName === projectKey
    );
    if (!matchedProjectfinal) {
      return quotedValue;
    }
    const totalTaskValue = matchedProjectfinal?.TaskList.reduce((total, task) => {
      const hoursSpent = Number(task.hoursassigned) || 0;
      const hourlySalary = Number(task.hourlysalaray) || 0;
      const overhead = Number(task.overheadpercentage) || 0;

      // ✅ Overhead is a direct addition, not a percentage
      const effectiveHourlySalary = hourlySalary + overhead;

      const taskValue = hoursSpent * effectiveHourlySalary;

      return total + taskValue;
    }, 0);

    let descriptionValue = 0;

    if (matchedProjectfinal.Description?.length > 0) {
      // Create a map to track trip duration per taskownerid for Installation services
      const installationTripByOwner = {};

      matchedProjectfinal.Description.forEach((desc) => {


        // For Installation services, track trip duration per owner
        if (desc.typeservice && desc.typeservice.toLowerCase().includes('installation') &&
          desc.taskownerid && desc.tripduration) {
          if (!installationTripByOwner[desc.taskownerid]) {
            installationTripByOwner[desc.taskownerid] = desc.tripduration;
          } else {
            // Use the maximum trip duration for each owner
            installationTripByOwner[desc.taskownerid] =
              Math.max(installationTripByOwner[desc.taskownerid], desc.tripduration);
          }
        }

        // Add the normal value calculation
        if (desc.value) {
          descriptionValue += desc.value;
        }
      });

      // Add Installation trip duration calculations (per diem + other expenses)
      Object.values(installationTripByOwner).forEach((tripDuration) => {
        // Assuming you have state variables called perdiem and otherExpense
        descriptionValue += (tripDuration * perdiem) + (tripDuration * averagecost);
      });
    }
    let hardwareValue = 0;

    if (matchedProjectfinal.HardwareList?.length > 0) {
      const hardwareByDescription = {};

      // Group hardware by assemblepartdescription and keep only the one with highest totalprice
      matchedProjectfinal.HardwareList.forEach((hw) => {
        const description = hw.assemblepartdescription;

        if (!hardwareByDescription[description]) {
          hardwareByDescription[description] = hw;
        } else {
          // If we already have this description, keep the one with higher totalprice
          if (hw.totalprice > hardwareByDescription[description].totalprice) {
            hardwareByDescription[description] = hw;
          }
        }
      });

      // Calculate total hardware value using only the highest totalprice items
      Object.values(hardwareByDescription).forEach((hw) => {
        if (hw.totalprice) {
          hardwareValue += hw.totalprice;
        }
      });
    }
    const grandTotals = totalTaskValue + descriptionValue + hardwareValue;

    const grossProfit = quotedValue - grandTotals;
    return grossProfit;
    // }
  };

  /** Same quoted figure as the P&L "Quoted Price" cell when `quotedValues` has no entry yet. */
  const quotedValueFallbackByRowKey = useMemo(() => {
    const m = {};
    (loggedUserData || []).forEach((lead) => {
      const k = getRowKey(lead);
      if (k == null || String(k).trim() === "") return;
      if (isCrmPackage) {
        // CRM: prefer quotedPrice — lead.QuotedValue can be an API aggregate.
        const price = Number(lead?.quotedPrice ?? lead?.quoted_price ?? lead?.QuotedPrice);
        if (Number.isFinite(price) && price !== 0) {
          m[String(k).trim()] = price;
          return;
        }
      }
      m[String(k).trim()] = lead.QuotedValue;
    });
    return m;
  }, [loggedUserData, getRowKey, isCrmPackage]);

  const handleCommentsChange = (row, value, event) => {
    if (isViewOnlyPL) return;
    setComments(prev => ({
      ...prev,
      [getRowKey(row)]: value
    }));

    // Check if this was triggered by Enter key
    if (event && event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();

      // Clear previous timeout if it exists
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }

      // Call API immediately
      updateComments(row, value);
    }
  };
  const updateComments = async (selectedProject, newComment) => {
    try {
      const updatedLeadData = {
        projectnotes: newComment,
        ProjectName: selectedProject.ProjectName,
        quotationId: selectedProject?.quotationId,
      };

      await dispatch(
        updateLead({ id: selectedProject.id, updatedData: updatedLeadData })
      ).unwrap();

      dispatch(fetchLeads());
      enqueueSnackbar("Notes Updated Successfully", {
        variant: "success",
      });

    } catch (error) {
      console.error("Error updating Notes:", error);
      enqueueSnackbar("Error updating Notes", {
        variant: "error",
      });
    }
  };


  const handlebuttons = async (tables) => {
    setshowTable(tables)

  };


  const QuotationRef = useRef(null);
  const ActualRef = useRef(null);

  const refsMaps = {
    Quotation: QuotationRef,
    Actual: ActualRef,
  };

  const handleTabClickbuttons = (tabKey) => {
    setSelectedTab(tabKey);
    setTimeout(() => {
      const node = refsMaps[tabKey]?.current;
      if (node && typeof node.scrollIntoView === "function") {
        node.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100);
  };

  const getDescriptionValues = useCallback(
    (projectID, personID, typeService, tasksOverride) => {
      const taskSource = tasksOverride ?? tasks;
      if (!taskSource) return [];
      return taskSource.filter(
        (desc) =>
          String(desc.projectid) === String(projectID) &&
          String(desc.taskownerid) === String(personID)
      );
    },
    [tasks]
  );


  const getTotalDescriptionValue = useCallback(
    (projectID, personID, typeService, tasksOverride) => {
      const descriptions = getDescriptionValues(projectID, personID, typeService, tasksOverride);

      let totalValue = descriptions.reduce((sum, desc) => sum + (desc.value || 0), 0);

      // Check if this is an Installation service
      if (typeService && typeService.toLowerCase().includes('installation')) {
        // Find the maximum trip duration for this person (to avoid duplicate counting)
        let maxTripDuration = 0;
        const uniqueTripDurations = new Set();

        descriptions.forEach(desc => {
          if (desc.tripduration) {
            uniqueTripDurations.add(desc.tripduration);
            maxTripDuration = Math.max(maxTripDuration, desc.tripduration);
          }
        });

        if (maxTripDuration > 0) {
          const quotedInstallProject = quotedproject?.find(
            (qp) => String(qp._id) === String(projectID)
          );
          const instPerdiem = quotedInstallProject
            ? Number(quotedInstallProject.perdiem) || 0
            : perdiem;
          const instAvgcost = quotedInstallProject
            ? Number(quotedInstallProject.avgcost ?? quotedInstallProject.averagecost) || 0
            : averagecost;
          totalValue += maxTripDuration * instPerdiem + maxTripDuration * instAvgcost;
        }
      }

      return totalValue;
    },
    [getDescriptionValues, perdiem, averagecost, quotedproject]
  );

  const getHardwareValues = useCallback(
    (projectID, typeService) => {
      if (!items) return [];
      return items.filter(
        (desc) =>
          desc.projectid === projectID &&
          // desc.taskownerid === personID &&
          desc.typeservice === typeService
      );
    },
    [items]
  );

  const getTotalHardwareCostValue = useCallback(
    (projectID, personID, typeService) => {
      let hardwareValue = 0;
      const hardwareCost = getHardwareValues(projectID, typeService);
      const hardwareByDescription = {};

      // Group hardware by assemblepartdescription and keep only the one with highest totalprice
      hardwareCost.forEach((hw) => {
        const description = hw.assemblepartdescription;

        if (!hardwareByDescription[description]) {
          hardwareByDescription[description] = hw;
        } else {
          // If we already have this description, keep the one with higher totalprice
          if (hw.totalprice > hardwareByDescription[description].totalprice) {
            hardwareByDescription[description] = hw;
          }
        }
      });

      // Calculate total hardware value using only the highest totalprice items
      Object.values(hardwareByDescription).forEach((hw) => {
        if (hw.totalprice) {
          hardwareValue += hw.totalprice;
        }
      });
      return hardwareValue
      // return hardwareCost.reduce((sum, desc) => sum + (desc.totalprice || 0), 0);
    },
    [getHardwareValues]
  );

  // const transformFilteredQuotation = useCallback((filteredQuotation, employees) => {
  //   const result = [];

  //   Object.entries(filteredQuotation || {}).forEach(([projectName, typeServices]) => {
  //     Object.entries(typeServices).forEach(([typeService, items]) => {
  //       items.forEach((item) => {
  //         if (!item?.WorkEntries?.length) return;

  //         // Group work entries by person
  //         const groupedByPerson = {};
  //         const personRoleMap = {};

  //         item.WorkEntries.forEach((entry) => {
  //           const personName = entry?.createdBy?.name;
  //           const personRoles = entry?.createdBy?.role || [];
  //           const personId = entry?.taskownerid;

  //           if (!groupedByPerson[personName]) {
  //             groupedByPerson[personName] = { totalHours: 0, personId };
  //           }
  //           groupedByPerson[personName].totalHours += entry.hoursassigned || 0;

  //           if (!personRoleMap[personName]) {
  //             personRoleMap[personName] = { roles: personRoles, personId };
  //           }
  //         });

  //         // Convert grouped persons into array with costs
  //         Object.entries(groupedByPerson).forEach(([name, personData]) => {
  //           const totalHours = personData.totalHours;
  //           const personId = personData.personId;
  //           // const roles = personRoleMap[name]?.roles || [];
  //           const ProjectID = item?.ProjectID;
  //           const ProjectNotes = item?.ProjectNotes;
  //           const ServiceQuotedValue = item?.QuotedValue;
  //           const servicewiseMargin = item?.ProjectMargin;

  //           // CRITICAL FIX: Match quotation by personid and taskownerid
  //           const matchedQuotation = item?.quotationDetails?.find((q) =>
  //             q.personid === personId
  //           );

  //           const currentEmployee = employees.find((emp) => {
  //             const fullName = `${emp.EmpFirstName} ${emp.EmpLastName}`.trim().toLowerCase();
  //             return fullName === name.trim().toLowerCase();
  //           });

  //           const capitalizedRoles =
  //             currentEmployee?.customRoles?.map(
  //               (role) =>
  //                 role.charAt(0).toUpperCase() + role.slice(1).toLowerCase()
  //             ) || [];

  //           const hourlyRate =
  //             (matchedQuotation?.hourlysalaray || 0) +
  //             (matchedQuotation?.overheadpercentage || 0);

  //           const totalCost = totalHours * hourlyRate;

  //           // External helpers
  //           const descriptionTotal = getTotalDescriptionValue(
  //             item.ProjectID,
  //             personId,
  //             item.TypeService
  //           );

  //           const hardwareTotal = getTotalHardwareCostValue(
  //             item.ProjectID,
  //             personId,
  //             item.TypeService
  //           );

  //           const hasProjectManagerRole = capitalizedRoles.includes("Project manager");
  //           result.push({
  //             servicewiseMargin,
  //             ServiceQuotedValue,
  //             projectName,
  //             typeService: item.TypeService,
  //             resourceType: item.ResourceType,
  //             personId,
  //             ProjectID,
  //             ProjectNotes,
  //             personName: name,
  //             roles: capitalizedRoles,
  //             totalHours,
  //             hourlyRate,
  //             totalCost,
  //             descriptionTotal,
  //             hardwareTotal,
  //             // grandTotal:
  //             //   item?.TypeService?.toLowerCase().includes("hardware")
  //             //     ? hardwareTotal + descriptionTotal
  //             //     : descriptionTotal + totalCost,
  //             grandTotal:
  //               item?.TypeService?.toLowerCase().includes("hardware")
  //                 ? (hasProjectManagerRole ? hardwareTotal : 0) + descriptionTotal
  //                 : descriptionTotal + totalCost,
  //           });
  //         });
  //       });
  //     });
  //   });

  //   return result;
  // }, [getTotalDescriptionValue, getTotalHardwareCostValue]);

  const transformFilteredQuotation = useCallback(
    (filteredQuotation, employees, transformOptions) => {
      const isProjectQuotedFlag = transformOptions?.isProjectQuoted ?? false;
      const rateMap = transformOptions?.spRateMap ?? {};
      const ratesReady =
        transformOptions?.ratesReady ??
        (isProjectQuotedFlag ? true : spRatesReadyForPrecompute);
      const descriptionTasks = transformOptions?.tasksSource ?? tasks;
      const result = [];

      Object.entries(filteredQuotation || {}).forEach(
        ([projectName, typeServices]) => {
          Object.entries(typeServices).forEach(([typeService, items]) => {
            items.forEach((item) => {
              if (!item) return;

              const ProjectID = item?.ProjectID;
              const ProjectNotes = item?.ProjectNotes;
              const ServiceQuotedValue = item?.QuotedValue || 0;
              const servicewiseMargin = item?.ProjectMargin || 0;
              const isHardwareService = item?.TypeService?.toLowerCase().includes("hardware");
              const quotedProjectData = quotedproject?.find(
                (qp) => String(qp._id) === String(ProjectID)
              );
              const normalizedService = String(typeService || item?.TypeService || "")
                .trim()
                .toLowerCase();
              const safeNum = (v) => (v == null ? 0 : Number(v) || 0);
              const computeQuotedDetailRate = (rateRow) =>
                safeNum(rateRow?.hourlysalaray) + safeNum(rateRow?.overheadpercentage);
              const pickRateByQuotedFlag = (kind) => {
                const isManagerKind = kind === "manager";
                const isOpsKind = kind === "operations";
                if (isProjectQuotedFlag) {
                  if (isManagerKind) {
                    const v = safeNum(quotedProjectData?.managerHourlyRate);
                    if (v) return v;
                  }
                  if (isOpsKind) {
                    const v = safeNum(quotedProjectData?.operationHourlyRate);
                    if (v) return v;
                  }
                  const details = Array.isArray(item?.quotationDetails)
                    ? item.quotationDetails
                    : [];
                  const detailMatch = details.find((d) => {
                    const desig = String(d?.designation || "").toLowerCase();
                    if (!desig) return false;
                    if (normalizedService && !desig.includes(normalizedService)) return false;
                    if (isManagerKind) return desig.includes("manager") || desig.includes("pm");
                    if (isOpsKind) return desig.includes("operation");
                    return false;
                  });
                  return detailMatch ? computeQuotedDetailRate(detailMatch) : 0;
                }
                return 0;
              };
              const managerHourlyRate = pickRateByQuotedFlag("manager");
              const operationHourlyRate = pickRateByQuotedFlag("operations");

              // Step 1: Get all persons from Assignedperson array
              const allAssignedPersons = item?.Assignedperson || [];
              const assignedPersonMap = new Map();

              // First, map all assigned persons by email for easy lookup
              allAssignedPersons.forEach((person) => {
                if (person?.email) {
                  assignedPersonMap.set(person.email.toLowerCase(), {
                    name: person.name,
                    email: person.email,
                    personid: person.personid || person._id
                  });
                }
              });

              // Step 2: Get employees by matching emails
              const matchedEmployees = employees.filter(emp => {
                return assignedPersonMap.has(emp.EmpEmail?.toLowerCase());
              });

              // If no employees found by email, try to match by name as fallback
              if (matchedEmployees.length === 0) {
                allAssignedPersons.forEach((person) => {
                  const matchedEmployee = employees.find(emp => {
                    const fullName = `${emp.EmpFirstName} ${emp.EmpLastName}`.trim().toLowerCase();
                    return fullName === person.name?.trim().toLowerCase();
                  });

                  if (matchedEmployee) {
                    matchedEmployees.push(matchedEmployee);
                  }
                });
              }

              // Step 3: Group work entries by person
              const workEntriesByPerson = {};
              const personWorkEntryData = {};

              if (item?.WorkEntries?.length) {
                item.WorkEntries.forEach((entry) => {
                  const personName = entry?.createdBy?.name;
                  const personRoles = entry?.createdBy?.role || [];
                  const personId = entry?.taskownerid;
                  const personEmail = entry?.createdBy?.email;

                  if (personName) {
                    if (!workEntriesByPerson[personName]) {
                      workEntriesByPerson[personName] = { totalHours: 0, personId };
                      personWorkEntryData[personName] = {
                        roles: personRoles,
                        email: personEmail
                      };
                    }
                    workEntriesByPerson[personName].totalHours += entry.hoursassigned || 0;
                  }
                });
              }

              // Step 4: Combine data from assigned persons and work entries
              // We need to process ALL assigned persons, not just those with work entries
              const allPersonsToProcess = [];

              // Add persons with work entries first
              Object.entries(workEntriesByPerson).forEach(([name, data]) => {
                const fallbackEmp = employees.find((e) => String(e?._id ?? "") === String(data.personId ?? ""));
                const fallbackEmail = fallbackEmp?.EmpEmail || "";
                allPersonsToProcess.push({
                  name,
                  personId: data.personId,
                  totalHours: data.totalHours,
                  roles: personWorkEntryData[name]?.roles || [],
                  email: personWorkEntryData[name]?.email || fallbackEmail,
                  hasWorkEntries: true
                });
              });

              // Add assigned persons who don't have work entries (like some managers)
              allAssignedPersons.forEach((person) => {
                const personName = person.name;
                const personEmail = person.email;

                // Check if this person is already in the list from work entries
                const alreadyExists = allPersonsToProcess.some(
                  p => p.name === personName || p.email === personEmail
                );

                if (!alreadyExists && personName) {
                  // Find matching employee to get roles and ID
                  const matchedEmployee = employees.find(emp =>
                    emp.EmpEmail?.toLowerCase() === personEmail?.toLowerCase() ||
                    `${emp.EmpFirstName} ${emp.EmpLastName}`.trim().toLowerCase() === personName.toLowerCase()
                  );

                  allPersonsToProcess.push({
                    name: personName,
                    personId: matchedEmployee?._id || person.personid,
                    totalHours: 0, // No work entries
                    roles: matchedEmployee?.customRoles || [],
                    email: personEmail,
                    hasWorkEntries: false
                  });
                }
              });

              // HARD FIX: de-duplicate people (work entries + assigned persons) so managers/ops never appear twice.
              // Key priority: email -> personId -> normalized name.
              const dedupedPersonsMap = new Map();
              allPersonsToProcess.forEach((p) => {
                const key =
                  (p?.email ? String(p.email).trim().toLowerCase() : "") ||
                  (p?.personId ? String(p.personId).trim() : "") ||
                  (p?.name ? String(p.name).trim().toLowerCase() : "");
                if (!key) return;
                const existing = dedupedPersonsMap.get(key);
                if (!existing) {
                  dedupedPersonsMap.set(key, { ...p });
                  return;
                }
                existing.totalHours = (Number(existing.totalHours) || 0) + (Number(p.totalHours) || 0);
                const roleSet = new Set([...(existing.roles || []), ...(p.roles || [])].map((r) => String(r || "").trim()).filter(Boolean));
                existing.roles = Array.from(roleSet);
                existing.hasWorkEntries = Boolean(existing.hasWorkEntries || p.hasWorkEntries);
                if (!existing.personId && p.personId) existing.personId = p.personId;
                if (!existing.email && p.email) existing.email = p.email;
                if (!existing.name && p.name) existing.name = p.name;
              });
              const uniquePersons = Array.from(dedupedPersonsMap.values());

              // Step 5: Check if any person is a manager
              let hasManager = false;
              uniquePersons.forEach((person) => {
                const isManager = person.roles.some(role =>
                  role.toLowerCase().includes('manager') ||
                  role.toLowerCase().includes('pm')
                );
                if (isManager) hasManager = true;
              });

              // Step 6: Track hardware cost assignment
              let hardwareCostAssigned = false;

              // Step 7: Sort persons: managers first, then others
              const sortedPersons = [...uniquePersons].sort((a, b) => {
                const isManagerA = a.roles.some(role =>
                  role.toLowerCase().includes('manager') ||
                  role.toLowerCase().includes('pm')
                );
                const isManagerB = b.roles.some(role =>
                  role.toLowerCase().includes('manager') ||
                  role.toLowerCase().includes('pm')
                );

                if (isManagerA && !isManagerB) return -1;
                if (!isManagerA && isManagerB) return 1;
                return 0;
              });

              // Step 8: Process each person
              sortedPersons.forEach((person, index) => {
                const { name, personId, totalHours, roles, email } = person;
                const isManager = roles.some(role =>
                  role.toLowerCase().includes('manager') ||
                  role.toLowerCase().includes('pm')
                );
                const isOperations = roles.some(role =>
                  role.toLowerCase().includes('operations')
                );

                // Find matching quotation
                let matchedQuotation = null;
                if (item?.quotationDetails?.length) {
                  // Try to match by roles
                  for (const role of roles) {
                    matchedQuotation = item.quotationDetails.find(q =>
                      q.designation?.toLowerCase() === role.toLowerCase()
                    );
                    if (matchedQuotation) break;
                  }

                  // Try partial matching if no exact match
                  if (!matchedQuotation) {
                    for (const role of roles) {
                      matchedQuotation = item.quotationDetails.find(q =>
                        q.designation?.toLowerCase().includes(role.toLowerCase()) ||
                        role.toLowerCase().includes(q.designation?.toLowerCase())
                      );
                      if (matchedQuotation) break;
                    }
                  }
                }

                const hourlyRate = (() => {
                  if (!ratesReady) return 0;
                  if (isProjectQuotedFlag) {
                    if (isManager) return managerHourlyRate;
                    if (isOperations) return operationHourlyRate;
                    return 0;
                  }
                  const normalized = normalizeDesignationForPL(
                    `${item?.TypeService || ""} ${isManager ? "manager" : "employee"}`
                  );
                  const matchedKey = Object.keys(rateMap).find((key) => normalized.includes(key));
                  return matchedKey ? Number(rateMap[matchedKey] || 0) : 0;
                })();

                // Round Hours×Rate product only (not rate first) — shared with AllServiceTable itemized P&L.
                const totalCost = ratesReady
                  ? Math.round(parseFloat(totalHours) * parseFloat(hourlyRate))
                  : 0;

                // Get description and hardware totals
                const descriptionTotal = getTotalDescriptionValue(
                  ProjectID,
                  personId,
                  item.TypeService,
                  descriptionTasks
                );

                const hardwareTotal = getTotalHardwareCostValue(
                  ProjectID,
                  personId,
                  item.TypeService
                );

                // Calculate grand total based on service type and role
                let grandTotal = 0;

                if (isHardwareService) {
                  if (isManager) {
                    // Manager in hardware service: hardware + description + cost
                    grandTotal = hardwareTotal + descriptionTotal + totalCost;
                  } else if (isOperations) {
                    // Operations in hardware service without manager
                    if (!hasManager && !hardwareCostAssigned) {
                      // First operations employee gets hardware cost
                      grandTotal = hardwareTotal + descriptionTotal + totalCost;
                      hardwareCostAssigned = true;
                    } else {
                      // Other operations employees or when manager exists
                      grandTotal = descriptionTotal + totalCost;
                    }
                  } else {
                    // Other roles in hardware service
                    grandTotal = descriptionTotal + totalCost;
                  }
                } else {
                  // Non-hardware services: always description + cost
                  grandTotal = descriptionTotal + totalCost;
                }

                // HARD FIX: drop fake/duplicate rows that carry no data (prevents 0-hour duplicates)
                const isEmptyRow =
                  (Number(totalHours) || 0) === 0 &&
                  (Number(totalCost) || 0) === 0 &&
                  (Number(descriptionTotal) || 0) === 0 &&
                  (Number(hardwareTotal) || 0) === 0;
                if (isEmptyRow) return;

                result.push({
                  servicewiseMargin,
                  ServiceQuotedValue,
                  projectName,
                  quotationId: projectName,
                  typeService: item.TypeService,
                  isMarginupdated: item?.isMarginupdated ?? item?.isMarginUpdated ?? false,
                  resourceType: item.ResourceType,
                  personId,
                  ProjectID,
                  ProjectNotes,
                  personName: name,
                  roles: roles.map(role =>
                    role.charAt(0).toUpperCase() + role.slice(1).toLowerCase()
                  ),
                  // IMPORTANT: Total Cost Per Service must include efforts even for hardware services.
                  totalHours,
                  hourlyRate: ratesReady ? hourlyRate : 0,
                  totalCost: ratesReady ? totalCost : 0,
                  descriptionTotal,
                  hardwareTotal,
                  grandTotal,
                  matchedDesignation: matchedQuotation?.designation || "Not matched",
                  isManager,
                  isOperations,
                  email
                });
              });
            });
          });
        }
      );

      return result;
    },
    [getTotalDescriptionValue, getTotalHardwareCostValue, spRatesReadyForPrecompute, quotedproject, tasks]
  );

  // Pre-compute Itemized P&L totals for all projects so main table matches without requiring click
  const precomputedItemizedTotals = useMemo(() => {
    const result = {};
    if (!matchedQuotations || !filteredTableData?.length || !employees?.length) return result;
    filteredTableData.forEach((row) => {
      const projectKey = getRowKey(row);
      const rowQuoted = getRowIsProjectQuoted(row);
      // HARD FIX: never precompute non-quoted totals until SP rates are actually ready.
      // Otherwise hourlyRate=0 leads to "Associated Cost only" totals on first paint after refresh.
      if (!rowQuoted && !spRatesReadyForPrecompute) return;
      const normalizedProjectName = String(row?.ProjectName ?? "").trim();
      const selectedQuotationId =
        row?.quotationId != null && String(row.quotationId).trim() !== ""
          ? String(row.quotationId).trim()
          : null;

      let match = matchedQuotations[projectKey];
      if (!match && normalizedProjectName) {
        const candidate = matchedQuotations[normalizedProjectName];
        if (candidate && selectedQuotationId) {
          const hasSameQuotation = Object.values(candidate).some((items) =>
            (items || []).some((it) => String(it?.quotationId ?? "").trim() === selectedQuotationId)
          );
          if (hasSameQuotation) match = candidate;
        } else if (candidate && !selectedQuotationId) {
          match = candidate;
        }
      }
      if (!match || typeof match !== "object") return;
      const fq = { [projectKey]: match };
      const rowPersonMap = buildProjectPersonServiceMapFromQuotation(fq);
      const rowTasks = buildTasksForQuotationScope(fq, rowPersonMap);
      const processed = transformFilteredQuotation(fq, employees, {
        isProjectQuoted: rowQuoted,
        spRateMap,
        ratesReady: rowQuoted ? true : spRatesReadyForPrecompute,
        tasksSource: rowTasks,
      });
      if (!processed?.length) return;
      const grouped = processed.reduce((acc, curr) => {
        if (!acc[curr.typeService]) acc[curr.typeService] = [];
        acc[curr.typeService].push(curr);
        return acc;
      }, {});
      if (!grouped || Object.keys(grouped).length === 0) return;
      // Cost total (Itemized P&L "Total Cost Per Service") does NOT depend on quoted value.
      // Compute it for every project so Quoted Expenses can match even before clicking/opening Itemized P&L.
      let totalCostPerService = 0;
      Object.entries(grouped).forEach(([, rows]) => {
        const serviceGrandTotal = rows.reduce((acc, r) => acc + (Number(r.grandTotal) || 0), 0);
        totalCostPerService += serviceGrandTotal;
      });
      // Project-level totals: GP = totalQuoted − totalCost. This is mathematically equivalent
      // to summing per-service GP when margins are normalized to 100%, and stays correct when
      // margins are 0 (brand-new leads) — matching what Itemized P&L shows after a row click.
      const totalProjectQuotedFinal = Number(quotedValues[projectKey] ?? row?.QuotedValue ?? 0) || 0;
      const grossProfitSum = totalProjectQuotedFinal - totalCostPerService;
      const gaExpensesSum = Math.round(grossProfitSum * (GandATax / 100));
      // Tax on EBIT (Gross Profit − G&A), not on Gross Profit
      const taxSum = (grossProfitSum - gaExpensesSum) * (taxValue / 100);
      const netRevenueSum = grossProfitSum - gaExpensesSum - taxSum;
      const netRevenuePct = totalProjectQuotedFinal > 0 ? (netRevenueSum / totalProjectQuotedFinal) * 100 : 0;
      result[projectKey] = {
        totalCostPerService: Math.round(Number(totalCostPerService) || 0),
        grossProfit: grossProfitSum,
        gaExpenses: gaExpensesSum,
        tax: taxSum,
        netRevenue: netRevenueSum,
        netRevenuePct,
      };
    });
    return result;
  }, [
    matchedQuotations,
    filteredTableData,
    transformFilteredQuotation,
    employees,
    quotedValues,
    GandATax,
    taxValue,
    getRowKey,
    spRateMap,
    spRatesReadyForPrecompute,
    buildTasksForQuotationScope,
  ]);

  // Gross Profit tracker must not be affected by P&L filters (year/group/client/search).
  // Build an independent precomputed totals map from the P&L lead universe (acceptance + bucket rules),
  // not from the currently filtered P&L table rows.
  const precomputedItemizedTotalsForGrossProfit = useMemo(() => {
    const result = {};
    const rows = Array.isArray(profitAndLossLeadsSource) ? profitAndLossLeadsSource : [];
    if (!matchedQuotations || rows.length === 0 || !employees?.length) return result;

    rows.forEach((row) => {
      const projectKey = getRowKey(row);
      if (!projectKey) return;
      const rowQuoted = getRowIsProjectQuoted(row);
      if (!rowQuoted && !spRatesReadyForPrecompute) return;

      const normalizedProjectName = String(row?.ProjectName ?? "").trim();
      const selectedQuotationId =
        row?.quotationId != null && String(row.quotationId).trim() !== ""
          ? String(row.quotationId).trim()
          : null;

      let match = matchedQuotations[projectKey];
      if (!match && normalizedProjectName) {
        const candidate = matchedQuotations[normalizedProjectName];
        if (candidate && selectedQuotationId) {
          const hasSameQuotation = Object.values(candidate).some((items) =>
            (items || []).some(
              (it) => String(it?.quotationId ?? "").trim() === selectedQuotationId
            )
          );
          if (hasSameQuotation) match = candidate;
        } else if (candidate && !selectedQuotationId) {
          match = candidate;
        }
      }
      if (!match || typeof match !== "object") return;

      const fq = { [projectKey]: match };
      const rowPersonMap = buildProjectPersonServiceMapFromQuotation(fq);
      const rowTasks = buildTasksForQuotationScope(fq, rowPersonMap);
      const processed = transformFilteredQuotation(fq, employees, {
        isProjectQuoted: rowQuoted,
        spRateMap,
        ratesReady: rowQuoted ? true : spRatesReadyForPrecompute,
        tasksSource: rowTasks,
      });
      if (!processed?.length) return;

      const grouped = processed.reduce((acc, curr) => {
        if (!acc[curr.typeService]) acc[curr.typeService] = [];
        acc[curr.typeService].push(curr);
        return acc;
      }, {});
      if (!grouped || Object.keys(grouped).length === 0) return;

      let totalCostPerService = 0;
      Object.entries(grouped).forEach(([, rows]) => {
        const serviceGrandTotal = rows.reduce(
          (acc, r) => acc + (Number(r.grandTotal) || 0),
          0
        );
        totalCostPerService += serviceGrandTotal;
      });

      // Project-level totals: GP = totalQuoted − totalCost. Stays correct when servicewiseMargin
      // values are 0 (new leads), matching Itemized P&L's effective margin fallback.
      const totalProjectQuotedFinal =
        Number(quotedValues[projectKey] ?? row?.QuotedValue ?? 0) || 0;
      const grossProfitSum = totalProjectQuotedFinal - totalCostPerService;
      const gaExpensesSum = Math.round(grossProfitSum * (GandATax / 100));
      // Tax on EBIT (Gross Profit − G&A), not on Gross Profit
      const taxSum = (grossProfitSum - gaExpensesSum) * (taxValue / 100);
      const netRevenueSum = grossProfitSum - gaExpensesSum - taxSum;
      const netRevenuePct =
        totalProjectQuotedFinal > 0 ? (netRevenueSum / totalProjectQuotedFinal) * 100 : 0;

      result[projectKey] = {
        totalCostPerService: Math.round(Number(totalCostPerService) || 0),
        grossProfit: grossProfitSum,
        gaExpenses: gaExpensesSum,
        tax: taxSum,
        netRevenue: netRevenueSum,
        netRevenuePct,
      };
    });

    return result;
  }, [
    matchedQuotations,
    profitAndLossLeadsSource,
    transformFilteredQuotation,
    employees,
    quotedValues,
    GandATax,
    taxValue,
    getRowKey,
    spRateMap,
    spRatesReadyForPrecompute,
    buildTasksForQuotationScope,
  ]);

  const showExpensesForGrossProfit = useCallback(
    (projectKey) => {
      const fromLive = itemizedTotalsByProject?.[projectKey]?.totalCostPerService;
      const fromPre =
        precomputedItemizedTotalsForGrossProfit?.[projectKey]?.totalCostPerService;
      let itemizedCostNum = null;
      if (fromLive !== undefined && fromLive !== null) itemizedCostNum = Number(fromLive);
      else if (fromPre !== undefined && fromPre !== null) itemizedCostNum = Number(fromPre);

      const stableKey =
        rowKeyToStableKey?.[String(projectKey).trim()] ?? String(projectKey).trim();
      const qMap = quotedExpenses || {};
      const hasStored = Object.prototype.hasOwnProperty.call(qMap, stableKey);
      const storedNum = hasStored ? Number(qMap[stableKey]) : NaN;

      const legacyComputed =
        parseFloat(String(showExpensesop(projectKey) || "0").replace(/[,$]/g, "")) || 0;
      const isQuotedRow = rowKeyIsQuotedMap?.[String(projectKey).trim()] ?? false;

      let v;
      if (hasStored && Number.isFinite(storedNum)) v = storedNum;
      else if (itemizedCostNum !== null) v = itemizedCostNum;
      else v = isQuotedRow ? legacyComputed || 0 : 0;

      return `${USAComma(v)}`;
    },
    [
      itemizedTotalsByProject,
      precomputedItemizedTotalsForGrossProfit,
      rowKeyToStableKey,
      quotedExpenses,
      showExpensesop,
      rowKeyIsQuotedMap,
      USAComma,
    ]
  );

  // CRM Gross Profit must stay independent from P&L filter state.
  // Use only the persisted quoted-expense maps (user input / itemized totals backfill),
  // never the P&L-derived fallback computations.
  const showCrmQuotedExpenseForGrossProfit = useCallback(
    (projectKey) => {
      const key = String(projectKey ?? "").trim();
      if (!key) return "0";
      const stableKey = gpRowKeyToStableKeyCrm?.[key] ?? key;

      // IMPORTANT: for immediate UI reflection, prefer the live input snapshot
      // (user typing / just updated) over stored snapshot values.
      const inputRaw = crmGpQuotedExpenseInputsSnapshot?.[stableKey];
      const parsedInput =
        inputRaw !== undefined && inputRaw !== null && inputRaw !== ""
          ? parseFloat(String(inputRaw).replace(/[^\d.-]/g, ""))
          : NaN;
      if (Number.isFinite(parsedInput)) return `${USAComma(parsedInput)}`;

      const qMap = crmGpQuotedExpensesSnapshot || {};
      const hasStored = Object.prototype.hasOwnProperty.call(qMap, stableKey);
      const storedNum = hasStored ? Number(qMap[stableKey]) : NaN;
      if (hasStored && Number.isFinite(storedNum)) return `${USAComma(storedNum)}`;

      return "0";
    },
    [
      USAComma,
      crmGpQuotedExpensesSnapshot,
      crmGpQuotedExpenseInputsSnapshot,
      gpRowKeyToStableKeyCrm,
    ]
  );

  // When precomputed Itemized totals become available, sync NON-QUOTED rows so P&L matches
  // Itemized breakdown without requiring a row click first.
  // CRM: sync from the FULL-universe Gross Profit map (not filteredTableData-backed
  // precomputedItemizedTotals), and over the full lead universe — so P&L filters cannot
  // shrink/overwrite expense maps that Gross Profit Net Margin depends on.
  useEffect(() => {
    if (isCrmPackage) {
      const rows = Array.isArray(profitAndLossLeadsSource) ? profitAndLossLeadsSource : [];
      if (!rows.length) return;
      if (
        !precomputedItemizedTotalsForGrossProfit ||
        Object.keys(precomputedItemizedTotalsForGrossProfit).length === 0
      ) {
        return;
      }

      const syncFromPrecomputed = (lead) => {
        const rowKey = getRowKey(lead);
        if (!rowKey) return null;
        if (getRowIsProjectQuoted(lead)) return null;
        const pre =
          precomputedItemizedTotalsForGrossProfit?.[rowKey]?.totalCostPerService;
        if (pre === undefined || pre === null) return null;
        return {
          stableKey: getStableLeadKey(lead),
          total: Math.round(Number(pre) || 0),
        };
      };

      setQuotedExpenses((prev) => {
        const next = { ...(prev || {}) };
        let changed = false;
        rows.forEach((lead) => {
          const synced = syncFromPrecomputed(lead);
          if (!synced) return;
          if (next[synced.stableKey] !== synced.total) {
            next[synced.stableKey] = synced.total;
            changed = true;
          }
        });
        return changed ? next : prev;
      });

      setQuotedExpenseInputs((prev) => {
        const next = { ...(prev || {}) };
        let changed = false;
        rows.forEach((lead) => {
          const synced = syncFromPrecomputed(lead);
          if (!synced) return;
          if (next[synced.stableKey] !== synced.total) {
            next[synced.stableKey] = synced.total;
            changed = true;
          }
        });
        return changed ? next : prev;
      });
      return;
    }

    if (!searchedLeadReports?.length) return;
    if (!precomputedItemizedTotals || Object.keys(precomputedItemizedTotals).length === 0) return;

    const syncFromPrecomputed = (lead) => {
      const rowKey = getRowKey(lead);
      if (!rowKey) return null;
      if (getRowIsProjectQuoted(lead)) return null;
      const pre = precomputedItemizedTotals?.[rowKey]?.totalCostPerService;
      if (pre === undefined || pre === null) return null;
      return {
        stableKey: getStableLeadKey(lead),
        total: Math.round(Number(pre) || 0),
      };
    };

    setQuotedExpenses((prev) => {
      const next = { ...(prev || {}) };
      let changed = false;
      searchedLeadReports.forEach((lead) => {
        const synced = syncFromPrecomputed(lead);
        if (!synced) return;
        if (next[synced.stableKey] !== synced.total) {
          next[synced.stableKey] = synced.total;
          changed = true;
        }
      });
      return changed ? next : prev;
    });

    setQuotedExpenseInputs((prev) => {
      const next = { ...(prev || {}) };
      let changed = false;
      searchedLeadReports.forEach((lead) => {
        const synced = syncFromPrecomputed(lead);
        if (!synced) return;
        if (next[synced.stableKey] !== synced.total) {
          next[synced.stableKey] = synced.total;
          changed = true;
        }
      });
      return changed ? next : prev;
    });
  }, [
    isCrmPackage,
    profitAndLossLeadsSource,
    precomputedItemizedTotalsForGrossProfit,
    searchedLeadReports,
    getRowKey,
    getStableLeadKey,
    precomputedItemizedTotals,
  ]);

  const showExpenses = useCallback(
    (projectKey) => {
      // Prefer `quotedExpenses` state when set (lead.quotedExpense + itemized-driven totals for open projects).
      // Itemized snapshot must not override persisted lead expense once that state exists (fixes CRM quoted column).
      const fromLive = itemizedTotalsByProject?.[projectKey]?.totalCostPerService;
      const fromPre = precomputedItemizedTotals?.[projectKey]?.totalCostPerService;
      let itemizedCostNum = null;
      if (fromLive !== undefined && fromLive !== null) itemizedCostNum = Number(fromLive);
      else if (fromPre !== undefined && fromPre !== null) itemizedCostNum = Number(fromPre);

      const stableKey = rowKeyToStableKey?.[String(projectKey).trim()] ?? String(projectKey).trim();
      const qMap = quotedExpenses || {};
      const hasStored = Object.prototype.hasOwnProperty.call(qMap, stableKey);
      const storedNum = hasStored ? Number(qMap[stableKey]) : NaN;

      const legacyComputed = parseFloat(String(showExpensesop(projectKey) || "0").replace(/[,$]/g, "")) || 0;
      const isQuotedRow = rowKeyIsQuotedMap?.[String(projectKey).trim()] ?? false;

      let v;
      if (!isQuotedRow && itemizedCostNum !== null) {
        v = itemizedCostNum;
      } else if (hasStored && Number.isFinite(storedNum)) {
        v = storedNum;
      } else if (itemizedCostNum !== null) {
        v = itemizedCostNum;
      } else {
        v = isQuotedRow ? (legacyComputed || 0) : 0;
      }
      return `${USAComma(v)}`;
    },
    [
      itemizedTotalsByProject,
      precomputedItemizedTotals,
      rowKeyToStableKey,
      quotedExpenses,
      showExpensesop,
      rowKeyIsQuotedMap,
      USAComma,
    ]
  );

  const calculateGrossProfitForLeadTecker = useCallback(
    (projectKey) => {
      const keyStr = String(projectKey).trim();
      const fromState = quotedValues[projectKey];
      let quotedValue =
        Number(
          fromState !== undefined && fromState !== null
            ? fromState
            : quotedValueFallbackByRowKey[keyStr] ?? 0
        ) || 0;

      // CRM: if map still holds inflated QuotedValue aggregate, prefer lead.quotedPrice.
      if (isCrmPackage) {
        const lead =
          (Array.isArray(profitAndLossLeadsSource)
            ? profitAndLossLeadsSource
            : []
          ).find((r) => String(getRowKey(r) || "").trim() === keyStr) || null;
        if (lead) {
          const price = Number(
            lead?.quotedPrice ?? lead?.quoted_price ?? lead?.QuotedPrice
          );
          const aggregate = Number(lead?.QuotedValue);
          if (
            Number.isFinite(price) &&
            price !== 0 &&
            Number.isFinite(aggregate) &&
            quotedValue === aggregate &&
            aggregate !== price
          ) {
            quotedValue = price;
          } else if (
            Number.isFinite(price) &&
            price !== 0 &&
            (!Number.isFinite(quotedValue) || quotedValue === 0)
          ) {
            quotedValue = price;
          }
        }
      }

      const stableKey =
        rowKeyToStableKey?.[String(projectKey).trim()] ?? String(projectKey).trim();
      const inputRaw = quotedExpenseInputs[stableKey];
      let cost;
      if (inputRaw !== undefined && inputRaw !== null && inputRaw !== "") {
        cost = parseFloat(String(inputRaw).replace(/[^\d.-]/g, "")) || 0;
      } else {
        cost =
          parseFloat(String(showExpenses(projectKey) || "0").replace(/[^\d.-]/g, "")) ||
          0;
      }
      return quotedValue - cost;
    },
    [
      quotedValues,
      quotedValueFallbackByRowKey,
      rowKeyToStableKey,
      quotedExpenseInputs,
      showExpenses,
      isCrmPackage,
      profitAndLossLeadsSource,
      getRowKey,
    ]
  );

  /**
   * CRM Quoted Price for Gross Profit cards / Net Margin — same resolution as P&L
   * calculateGrossProfitForLeadTecker (quotedValues → fallback → quotedPrice repair).
   * Never return inflated lead.QuotedValue aggregate when quotedPrice differs.
   */
  const resolveCrmQuotedPriceForGrossProfit = useCallback(
    (row, key) => {
      const keyStr = String(key != null ? key : getRowKey(row)).trim();
      if (!keyStr) return 0;

      const fromState = quotedValues?.[keyStr];
      let quotedValue =
        Number(
          fromState !== undefined && fromState !== null
            ? fromState
            : quotedValueFallbackByRowKey[keyStr] ?? 0
        ) || 0;

      const price = Number(
        row?.quotedPrice ?? row?.quoted_price ?? row?.QuotedPrice
      );
      const aggregate = Number(row?.QuotedValue);

      if (
        Number.isFinite(price) &&
        price !== 0 &&
        Number.isFinite(aggregate) &&
        quotedValue === aggregate &&
        aggregate !== price
      ) {
        quotedValue = price;
      } else if (
        Number.isFinite(price) &&
        price !== 0 &&
        (!Number.isFinite(quotedValue) || quotedValue === 0)
      ) {
        quotedValue = price;
      }

      return quotedValue;
    },
    [quotedValues, quotedValueFallbackByRowKey, getRowKey]
  );

  /**
   * Gross Profit for CRM Net Margin / YTD Net Margin / Gross Profit cards.
   * Filter-independent: full-universe CRM expense snapshots + quotedPrice/map (never QuotedValue).
   */
  const calculateGrossProfitIndependentOfPlFilters = useCallback(
    (projectKey, leadRow) => {
      const keyStr = String(projectKey ?? "").trim();
      if (!keyStr) return 0;

      const lead =
        leadRow ||
        (Array.isArray(profitAndLossLeadsSource)
          ? profitAndLossLeadsSource.find(
              (r) => String(getRowKey(r) || "").trim() === keyStr
            )
          : null);

      const quotedValue = resolveCrmQuotedPriceForGrossProfit(lead || {}, keyStr);

      let cost =
        parseFloat(
          String(showCrmQuotedExpenseForGrossProfit(keyStr) || "0").replace(
            /[^\d.-]/g,
            ""
          )
        ) || 0;

      if (cost === 0) {
        const fromPre =
          precomputedItemizedTotalsForGrossProfit?.[projectKey]?.totalCostPerService ??
          precomputedItemizedTotalsForGrossProfit?.[keyStr]?.totalCostPerService;
        if (fromPre !== undefined && fromPre !== null && Number.isFinite(Number(fromPre))) {
          const isQuoted = lead != null ? getRowIsProjectQuoted(lead) : false;
          if (!isQuoted && Number(fromPre) !== 0) {
            cost = Number(fromPre);
          }
        }
      }

      return quotedValue - cost;
    },
    [
      profitAndLossLeadsSource,
      getRowKey,
      resolveCrmQuotedPriceForGrossProfit,
      showCrmQuotedExpenseForGrossProfit,
      precomputedItemizedTotalsForGrossProfit,
    ]
  );

  /**
   * CRM Gross Profit + Net Margin year totals (background, filter-independent).
   * Value = Σ Quoted Price (quotedPrice / quotedValues map — never QuotedValue aggregate).
   * Cost / GP / Tax / G&A / Net from same Value−Cost EBIT path as P&L cells.
   */
  const crmQuotedPlTaxNetByYearForGpCards = useMemo(() => {
    if (!isCrmPackage) return null;
    const rows = Array.isArray(profitAndLossLeadsSource) ? profitAndLossLeadsSource : [];
    if (rows.length === 0) return null;

    const gaRate = Number(GandATax) / 100;
    const taxRate = Number(taxValue) / 100;
    const byYear = {};

    const parseLeadYear = (lead) => {
      const raw =
        lead?.LeadDate ??
        lead?.leadDate ??
        lead?.lead_date ??
        lead?.created_at ??
        lead?.createdAt;
      if (!raw) return null;
      const normalized = ValidDate(raw);
      if (normalized) {
        const y = Number(String(normalized).slice(0, 4));
        return Number.isFinite(y) ? y : null;
      }
      const dt = new Date(raw);
      return Number.isNaN(dt.getTime()) ? null : dt.getFullYear();
    };

    rows.forEach((row) => {
      const year = parseLeadYear(row);
      if (year == null) return;
      const key = getRowKey(row);
      if (!key) return;

      const quotedValue = resolveCrmQuotedPriceForGrossProfit(row, key);
      const cost =
        parseFloat(
          String(showCrmQuotedExpenseForGrossProfit(key) || "0").replace(
            /[^\d.-]/g,
            ""
          )
        ) || 0;
      // Prefer Value−Cost so Value on GP cards matches Quoted Price sum; GP aligns with P&L.
      let gp = quotedValue - cost;
      if (cost === 0) {
        const indep = Number(calculateGrossProfitIndependentOfPlFilters(key, row));
        if (Number.isFinite(indep)) gp = indep;
      }
      const ga = gp * gaRate;
      const tax = (gp - ga) * taxRate;
      const net = gp - ga - tax;

      if (!byYear[year]) {
        byYear[year] = {
          tax: 0,
          net: 0,
          ga: 0,
          gp: 0,
          quotedValue: 0,
          cost: 0,
        };
      }
      byYear[year].tax += tax;
      byYear[year].net += net;
      byYear[year].ga += ga;
      byYear[year].gp += gp;
      byYear[year].quotedValue += quotedValue;
      byYear[year].cost += cost > 0 ? cost : quotedValue - gp;
    });

    Object.keys(byYear).forEach((y) => {
      const t = byYear[y];
      t.netMarginPct =
        t.quotedValue > 0 ? (t.net / t.quotedValue) * 100 : 0;
    });

    return byYear;
  }, [
    isCrmPackage,
    profitAndLossLeadsSource,
    GandATax,
    taxValue,
    getRowKey,
    resolveCrmQuotedPriceForGrossProfit,
    showCrmQuotedExpenseForGrossProfit,
    calculateGrossProfitIndependentOfPlFilters,
  ]);

  // Use Itemized P&L GP / G&A when available; always recompute Tax & Net Revenue from EBIT
  // so stale itemized.tax (e.g. accidentally storing EBIT) cannot desync the Tax column.
  const getRowTotals = useCallback(
    (row) => {
      const key = getRowKey(row);
      const itemized = itemizedTotalsByProject[key] ?? precomputedItemizedTotals[key];
      const gp =
        itemized != null && Number.isFinite(Number(itemized.grossProfit))
          ? Number(itemized.grossProfit)
          : calculateGrossProfit(key);
      const gaExpenses =
        itemized != null && Number.isFinite(Number(itemized.gaExpenses))
          ? Number(itemized.gaExpenses)
          : Math.round(gp * (GandATax / 100));
      const ebit = gp - gaExpenses;
      const taxRate = Number(taxValue) / 100;
      const tax = ebit * taxRate;
      const netRevenue = ebit - tax; // Gross Profit − G&A − Tax
      const quoted = Number(quotedValues[key] ?? row?.QuotedValue ?? 0) || 0;
      return {
        grossProfit: gp,
        gaExpenses,
        tax,
        netRevenue,
        netRevenuePct: quoted ? (netRevenue / quoted) * 100 : 0,
      };
    },
    [itemizedTotalsByProject, precomputedItemizedTotals, calculateGrossProfit, GandATax, taxValue, quotedValues, getRowKey]
  );

  /**
   * Totals for the Gross Profit card — must match the P&L table columns (same row set as the grid).
   * - Value: Σ Quoted Price column (quotedValues ?? QuotedValue)
   * - Cost: Σ Quoted Expenses column (same parsing as the cell: CRM uses expense inputs when set)
   * - Gross Profit: Σ same figure as the P&L "Gross Profit" column per row (CRM: calculateGrossProfitForLeadTecker;
   *   QuotedExpense: getRowTotals(row).grossProfit, including itemized when present). Not always equal to Value−Cost.
   *
   * Always return an object (never null): when P&L is on CRM, SearchSalesGrossProfit must not fall through
   * to FinanceGraph's allLeads sum (that inflated Value e.g. ~64L vs P&L ~41L).
   *
   */
  const groupByTypeService = (processedData) => {
    return processedData.reduce((acc, curr) => {
      if (!acc[curr.typeService]) {
        acc[curr.typeService] = [];
      }
      acc[curr.typeService].push(curr);
      return acc;
    }, {});
  };


  const processedData = useMemo(() => {
    const rowQuoted = getRowIsProjectQuoted(selectedProjectName);
    const plTasks = buildTasksForQuotationScope(
      filteredQuotation,
      projectPersonServiceMap
    );
    return transformFilteredQuotation(filteredQuotation, employees, {
      isProjectQuoted: rowQuoted,
      spRateMap,
      ratesReady: rowQuoted ? true : spRatesReadyForPrecompute,
      tasksSource: plTasks,
    });
  }, [
    filteredQuotation,
    employees,
    transformFilteredQuotation,
    selectedProjectName,
    spRateMap,
    spRatesReadyForPrecompute,
    buildTasksForQuotationScope,
    projectPersonServiceMap,
  ]);

  const groupedData = useMemo(() => {
    return groupByTypeService(processedData);
  }, [processedData]);



  const finalData = useMemo(() => {
    if (!groupedData) return [];

    return Object.entries(groupedData).map(([typeService, items]) => {
      const projectName = items[0]?.projectName || "";
      const quotationId = items[0]?.quotationId ?? null;
      const CostPerService = items.reduce(
        (sum, item) => sum + (item.grandTotal || 0),
        0
      );

      return {
        ProjectName: projectName,
        quotationId,
        CostPerService,
        TypeService: typeService,
      };
    });
  }, [groupedData]);



  const UpdateCostPerService = useCallback(async (selectedProject, finalData) => {
    try {
      const quotationId = selectedProject?.quotationId ?? selectedProject?.ProjectName ?? null;
      const updatePromises = finalData.map(item =>
        dispatch(updateCostPerService({
          quotationId: item.quotationId ?? quotationId,
          TypeService: item.TypeService,
          CostPerService: item.CostPerService
        }))
      );

      await Promise.all(updatePromises);
      dispatch(fetchLeads());
    } catch (error) {
      console.error("Error:", error);
      enqueueSnackbar("Failed to update some services", {
        variant: "error",
      });
    }
  }, [dispatch, enqueueSnackbar]);

  useEffect(() => {

    if (finalData.length > 0) {
      UpdateCostPerService(selectedProjectName, finalData)

    }


  }, [UpdateCostPerService, selectedProjectName, finalData]);

  const calculateServiceMargins = (row, groupedData) => {
    // 1️⃣ Calculate grand total across ALL services

    const projectname = row.ProjectName
    const Totalgrandtotal = Object.values(groupedData)
      .flat()
      .reduce((sum, item) => sum + (Number(item.grandTotal) || 0), 0);

    // 2️⃣ Build service-wise summary
    return Object.entries(groupedData).map(([typeService, items]) => {
      const grandTotalSum = items.reduce(
        (sum, item) => sum + (Number(item.grandTotal) || 0),
        0
      );

      const margin =
        Totalgrandtotal > 0
          ? (grandTotalSum / Totalgrandtotal) * 100
          : 0;

      const isMarginupdated = items[0]?.isMarginupdated === true || items[0]?.isMarginUpdated === true;

      return {
        projectname,
        typeService,
        grandTotalSum,
        Totalgrandtotal,
        margin: Number(margin.toFixed(2)), // ✅ finance-safe
        isMarginupdated,
      };
    });
  };

  const updatemargin = useCallback(async (row, groupedData) => {
   
    console.log("🚀 Payload for groupedData:asffsffas", groupedData);

    if (!groupedData) {
      return;
    }

    const serviceSummary = calculateServiceMargins(row, groupedData);
    const quotationId = row?.quotationId ?? null;

    const projectsDetails = serviceSummary.map(item => ({
      ProjectName: item.projectname,
      quotationId,
      TypeService: item.typeService,
      Salesmargin: Number(item.margin.toFixed(2)),
      isMarginupdated: item.isMarginupdated,
    }));

    const hasChange = projectsDetails.some(p => p.Salesmargin > 0);
    if (!hasChange || !projectsDetails.length) return;

    // Do not call API if all projects for this quotationId have isMarginupdated === true
    const allMarginUpdated = projectsDetails.every(p => p.isMarginupdated === true);
    if (allMarginUpdated) return;

    console.log("🚀 Payload for updateSalesMargin:", projectsDetails);

    try {

      await dispatch(updateSalesMarginforprojectThunk(projectsDetails)).unwrap();

      // setCalculationTable(true);
    } catch (error) {
      console.error("Error:", error);
      
    } 

  }, [dispatch]);

  useEffect(() => {
    if (!groupedData || !getRowKey(selectedProjectName)) return;
    updatemargin(selectedProjectName, groupedData);
  }, [groupedData, updatemargin, selectedProjectName, getRowKey]);


  const hasFeatureConfig = Array.isArray(currentEmployee?.featureAccess) && currentEmployee.featureAccess.length > 0;

  // Strict guard for the full P&L UI block (header, tabs, filters, search, table).
  const canSeeProfitAndLossSection = useMemo(() => {
    if (isL0Admin) return true;
    if (!currentEmployee) return false;
    if (!hasFeatureConfig) return true;

    return (
      hasViewOrFullAccess(currentEmployee, "PROFIT AND LOSS") ||
      hasViewOrFullAccess(currentEmployee, "PROFIT AND LOSS TRACKER") ||
      hasViewOrFullAccess(currentEmployee, "PROFIT AND LOSS TRACKER TABLE") ||
      hasViewOrFullAccess(currentEmployee, "PROFIT AND LOSS TRACKER ACTUAL") ||
      hasViewOrFullAccess(currentEmployee, "PROFIT AND LOSS TRACKER QUOTED")
    );
  }, [currentEmployee, hasFeatureConfig, isL0Admin]);

  // Gross Profit module: independent of P&L — show FinanceGraph when user has any Gross Profit Tracker permission.
  const canSeeGrossProfitSection = useMemo(() => {
    if (isL0Admin) return true;
    if (!currentEmployee) return false;
    if (!Array.isArray(currentEmployee?.featureAccess) || currentEmployee.featureAccess.length === 0) {
      return true;
    }
    return hasViewOrFullAccess(currentEmployee, "GROSS PROFIT TRACKER");
  }, [currentEmployee, isL0Admin]);

  const canShowPLFilter = useMemo(() => {
    if (isL0Admin) return true;
    if (!currentEmployee) return false;
    if (!hasFeatureConfig) return true;
    return (
      hasViewOrFullAccess(currentEmployee, "PROFIT AND LOSS") ||
      hasViewOrFullAccess(currentEmployee, "PROFIT AND LOSS TRACKER") ||
      hasViewOrFullAccess(currentEmployee, "PROFIT AND LOSS TRACKER TABLE") ||
      hasViewOrFullAccess(currentEmployee, "PROFIT AND LOSS TRACKER ACTUAL") ||
      hasViewOrFullAccess(currentEmployee, "PROFIT AND LOSS TRACKER QUOTED")
    );
  }, [currentEmployee, hasFeatureConfig, isL0Admin]);

  const canCreateQuotation = useMemo(() => {
    if (!currentEmployee) return true;
    if (isL0Admin) return true;
    if (!Array.isArray(currentEmployee?.featureAccess) || currentEmployee.featureAccess.length === 0) return true;
    const level = getFeatureAccessLevel(currentEmployee, "PROFIT AND LOSS TRACKER CREATE QUOTATION");
    if (!level) return true;
    return hasViewOrFullAccess(currentEmployee, "PROFIT AND LOSS TRACKER CREATE QUOTATION");
  }, [currentEmployee, isL0Admin]);

  const canDownloadQuotation = useMemo(() => {
    if (!currentEmployee) return true;
    if (isL0Admin) return true;
    if (!Array.isArray(currentEmployee?.featureAccess) || currentEmployee.featureAccess.length === 0) return true;
    const level = getFeatureAccessLevel(currentEmployee, "PROFIT AND LOSS TRACKER DOWNLOAD QUOTATION");
    if (!level) return true;
    return hasViewOrFullAccess(currentEmployee, "PROFIT AND LOSS TRACKER DOWNLOAD QUOTATION");
  }, [currentEmployee, isL0Admin]);

  const canSendQuotation = useMemo(() => {
    if (!currentEmployee) return true;
    if (isL0Admin) return true;
    if (!Array.isArray(currentEmployee?.featureAccess) || currentEmployee.featureAccess.length === 0) return true;
    const level = getFeatureAccessLevel(currentEmployee, "PROFIT AND LOSS TRACKER SEND QUOTATION");
    if (!level) return true;
    return hasViewOrFullAccess(currentEmployee, "PROFIT AND LOSS TRACKER SEND QUOTATION");
  }, [currentEmployee, isL0Admin]);

  const canSeePLTable = useMemo(() => {
    if (isL0Admin) return true;
    if (!currentEmployee) return false;
    if (!hasFeatureConfig) return true;
    return hasViewOrFullAccess(currentEmployee, "PROFIT AND LOSS TRACKER TABLE");
  }, [currentEmployee, hasFeatureConfig, isL0Admin]);

  const isViewOnlyPL = useMemo(() => {
    if (!currentEmployee) return false;
    if (isL0Admin) return false;
    if (!Array.isArray(currentEmployee?.featureAccess) || currentEmployee.featureAccess.length === 0) return false;
    const level = getFeatureAccessLevel(currentEmployee, "PROFIT AND LOSS TRACKER");
    if (!level) return false;
    return String(level).trim().toUpperCase() === "VIEW ONLY";
  }, [currentEmployee, isL0Admin]);

  const canSeeQuotedTab = useMemo(() => {
    if (currentEmployee?.EmpAuthLevel === "L1") {
      if (!hasFeatureConfig) return false;
      return hasViewOrFullAccess(currentEmployee, "PROFIT AND LOSS TRACKER QUOTED");
    }
    return canSeePLTable;
  }, [currentEmployee, canSeePLTable, hasFeatureConfig]);

  const canSeeActualTab = useMemo(() => {
    // CRM subscription package: Actual tab is not offered (admin/ERP only).
    if (isCrmPackage) return false;
    if (!currentEmployee) return false;
    if (!hasFeatureConfig) return true;
    if (currentEmployee?.EmpAuthLevel === "L1") return true;
    return hasViewOrFullAccess(currentEmployee, "PROFIT AND LOSS TRACKER ACTUAL");
  }, [currentEmployee, isCrmPackage, hasFeatureConfig]);

  useEffect(() => {
    if (currentEmployee?.EmpAuthLevel === "L1" && !canSeeQuotedTab && canSeeActualTab) {
      setbutton("Actual");
      setshowTable("Actual");
    }
  }, [currentEmployee, canSeeQuotedTab, canSeeActualTab]);

  useEffect(() => {
    if (!canSeeActualTab && (button === "Actual" || showTable === "Actual")) {
      setbutton("QuotedExpense");
      setshowTable("QuotedExpense");
    }
  }, [canSeeActualTab, button, showTable]);

  return (

    (canSeeProfitAndLossSection || canSeeGrossProfitSection) && (
      <>
        <div className="rounded-md">
          <div className="relative  scroll-visible justify-center top-0 pt-2">
          {canSeeProfitAndLossSection && (
          <>
            <div className="w-full relative pt-4 bg-white px-2 flex  align-middle items-center rounded-md">
              <div onClick={closeItemizedPL} className="cursor-pointer">
                <h1 className="text-xl font-semibold">Profit and Loss (P&L)</h1>
              </div>

              <div className="flex gap-2 text-sm font-medium px-3">
                {canSeeQuotedTab && (
                <button
                  onClick={() => {
                    closeItemizedPL();
                    handlebuttons("QuotedExpense")
                    setbutton("QuotedExpense")
                    setCalculationTable(false);
                    handleTabClickbuttons("Quotation")
                    setSearchQuery("")

                  }}
                  className={`py-1 px-3 ${button === "QuotedExpense" ? "bg-[#156082] text-white border-[#156082]" : "bg-gray-200 border-gray-300 hover:bg-gray-300"}  border  shadow-md rounded-lg transition-all duration-200`}
                >
                  Quoted
                </button>
                )}
                {canSeeActualTab && (
                <button
                  onClick={() => {
                    closeItemizedPL();
                    handlebuttons("Actual")
                    setbutton("Actual")
                    handleTabClickbuttons("Actual")
                    setSearchQuery("")
                  }}
                  className={`py-1 px-3 ${button === "Actual" ? "bg-[#156082] text-white border-[#156082]" : "bg-gray-200 border-gray-300 hover:bg-gray-300"} text-gray-800 border  shadow-md rounded-lg  transition-all duration-200`}
                >
                  Actual
                </button>
                )}
              </div>
            </div>

            <div className="flex justify-between gap-2 bg-white rounded-md p-1">
              {canShowPLFilter && (
              <div className="flex">
                <div className="flex gap-3 p-1">
                  <div
                    className="relative flex gap-2 justify-center align-middle items-center"
                    ref={dropdownRefGroup}
                  >
                    <label
                      htmlFor="selectedStatus"
                      className="block text-sm font-semibold text-gray-700 "
                    >
                      GROUP
                    </label>
                    <button
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        closeItemizedPL();
                        setIsGroupOpen(!isGroupOpen);
                      }}
                      className="w-24 relative outline-none date-picker-placeholder flex justify-start border border-[#e0e7ff] rounded-md p-2 text-xs"
                    >
                      <span className="truncate min-w-0 flex-1 text-left">
                        {AssignedGroup === "All" ? "All" : (groupNameById.get(AssignedGroup) || "All")}
                      </span>
                      <ExpandMoreIcon className="absolute cursor-pointer right-1 top-1 bg-white" />
                    </button>
                    {isGroupOpen && (
                      <div className="absolute left-0 top-full w-full text-xs border overflow-hidden text-wrap border-gray-400 bg-white shadow-md rounded-md z-50">
                        <div
                          className="p-2 hover:bg-gray-200 cursor-pointer"
                          onClick={() => {
                            closeItemizedPL();
                            setAssignedGroup("All");
                            setIsGroupOpen(false);
                            setShowAllLeadTable(true);
                            setCalculationTable(false);
                          }}
                        >
                          All
                        </div>
                        {GroupNamesL3.map((gItem) => {
                          const gid = String(gItem._id ?? gItem.id ?? "").trim();
                          if (!gid) return null;
                          return (
                            <div
                              key={gid}
                              className={`flex items-center p-2 hover:bg-gray-200 cursor-pointer ${AssignedGroup === gid ? "bg-gray-300" : ""}`}
                              onClick={() => {
                                closeItemizedPL();
                                setAssignedGroup(gid);
                                setIsGroupOpen(false);
                                setShowAllLeadTable(true);
                                setCalculationTable(false);
                                setClientFilter("");
                              }}
                            >
                              <label>{gItem.newGroupName}</label>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>

                <div className="relative z-[1000] flex gap-2 align-middle items-center scale-90">
                  <h1 className="font-semibold">CLIENT</h1>
                  <div className="relative z-[1000] overflow-visible">
                    <div className="flex  p-0 border rounded-md align-middle items-center">
                      <ExpandMoreIcon
                        className="absolute right-1 cursor-pointer bg-white"
                        onClick={() => { closeItemizedPL(); setShowClientDropdown(!showClientDropdown); }}
                      />

                      <button
                        type="button"
                        onClick={() => { closeItemizedPL(); setShowClientDropdown(!showClientDropdown); }}
                        className=" text-left text-sm outline-none p-2 text-nowrap truncate w-40"
                      >
                        {clientFilter ? clientFilter : <p>Select Client</p>}
                      </button>
                    </div>

                    {showClientDropdown && (
                      <div
                        ref={dropdownRefclient}
                        className="absolute top-full left-0 z-[9999] w-full max-h-64 cursor-pointer overflow-y-auto bg-white rounded-md text-sm border border-gray-400 shadow-md"
                      >
                        <p
                          className="p-2 hover:bg-gray-200 "
                          onClick={() => {
                            closeItemizedPL();
                            handleClientChange("All");
                            setShowAllLeadTable(true);
                            setCalculationTable(false);
                          }}
                        >
                          All
                        </p>
                        {uniqueClients.map((clientName, idx) => (
                          <p
                            key={idx}
                            className="p-2 hover:bg-gray-200"
                            onClick={() => {
                              closeItemizedPL();
                              handleClientChange(clientName);
                              setShowAllLeadTable(true);
                              setCalculationTable(false);
                            }}
                          >
                            {clientName}
                          </p>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                <div className="flex gap-3 p-1">
                  <div
                    className="relative flex gap-2 justify-center items-center"
                    ref={dropdownRefYear}
                  >
                    <label className="block text-sm font-semibold text-gray-700">
                      YEAR
                    </label>
                    <button
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        closeItemizedPL();
                        setIsYearOpen(!isYearOpen);
                      }}
                      className="w-24 relative outline-none date-picker-placeholder flex gap-1 justify-start border border-[#e0e7ff] rounded-md p-2 text-xs"
                    >
                      <span className="truncate min-w-0 flex-1 text-left">
                        {selectedYears?.length === 0
                          ? "All"
                          : selectedYears?.join(", ").length < 14 // Adjust length limit as needed
                            ? selectedYears?.join(", ")
                            : "Multiple"}
                      </span>
                      <ExpandMoreIcon className="absolute cursor-pointer right-1 top-1 bg-white" />
                    </button>

                    {isYearOpen && (
                      <div className="absolute left-0 top-full w-56 text-xs border overflow-hidden border-gray-400 bg-white shadow-md rounded-md z-50 max-h-64 overflow-y-auto">
                        {yearData?.map((item) => {
                          const isYearSelected = selectedYears?.includes(
                            item.Year.toString()
                          );

                          return (
                            <div
                              key={item.Year}
                              className="border-b border-gray-200"
                            >
                              <div className="flex align-middle items-center px-2">
                                <input
                                  type="checkbox"
                                  checked={selectedYears?.includes(item.Year) || isYearSelected}
                                  onChange={(e) => {
                                    closeItemizedPL();
                                    handleYearSelection(item.Year);
                                  }}
                                />
                                <button
                                  className={`w-full text-left px-3 py-2 font-medium cursor-pointer`}
                                  onClick={() => {
                                    closeItemizedPL();
                                    handleYearSelection(item.Year);
                                  }}
                                >
                                  {item.Year}
                                </button>
                              </div>

                              {/* {expandedYear === item.Year && (
                              <div className="px-4 pb-3 text-gray-600">
                                <div className="text-[10px] font-semibold">
                                  Months:
                                </div>
                                <div className="flex flex-wrap gap-1 mt-1 text-[11px]">
                                  {item.months.map((month) => {
                                    const value = `${item.Year} ${month}`;
                                    const isSelected =
                                      selectedYears?.includes(value);

                                    return (
                                      <span
                                        key={month}
                                        onClick={() => handleYearSelection(value)}
                                        className={`px-2 py-[2px] rounded cursor-pointer border text-[11px]
                            ${isSelected
                                            ? "bg-blue-600 text-white border-blue-600"
                                            : "bg-blue-50 text-blue-800 border-blue-100 hover:bg-blue-100"
                                          }`}
                                      >
                                        {month}
                                      </span>
                                    );
                                  })}
                                </div>

                                <div className="mt-2 text-[10px] font-semibold">
                                  Quarters:
                                </div>
                                <div className="flex flex-wrap gap-1 mt-1 text-[11px]">
                                  {item.quarter.map((qtr) => {
                                    const value = `${item.Year} ${qtr}`;
                                    const isSelected =
                                      selectedYears?.includes(value);

                                    return (
                                      <span
                                        key={qtr}
                                        onClick={() => handleYearSelection(value)}
                                        className={`px-2 py-[2px] rounded cursor-pointer border text-[11px]
                            ${isSelected
                                            ? "bg-green-600 text-white border-green-600"
                                            : "bg-green-50 text-green-800 border-green-100 hover:bg-green-100"
                                          }`}
                                      >
                                        {qtr}
                                      </span>
                                    );
                                  })}

                                </div>
                              </div>
                            )} */}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              )}

              <div className="flex gap-4 align-middle items-center pr-4">
                {/* {financeTab !== "graph" && ( */}
                <div className="flex gap-2 p-1 align-middle items-center bg-[#e0e7ff] rounded-full">
                  <MdSearch className="w-5 h-5 text-gray-500" />
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={handleSearchInputChange}
                    placeholder="Search"
                    className="bg-[#e0e7ff] outline-none w-[80%]"
                  />
                </div>



              </div>
            </div>

            {financeTab === "table" && showTable === "QuotedExpense" && canSeePLTable && (
              <>
                <div ref={QuotationRef}
                  className="">
                  {showAllLeadTable && (
                    <div>
                      <div className="w-full max-h-[80vh] overflow-auto">
                        <div className="w-full head sticky top-0 z-10 h-12 flex text-black bg-[#E8E8E8] font-semibold">
                          <div className="pl-sticky pl-sticky-sr pl-sticky-header flex-shrink-0 w-10 px-3 py-2 flex items-center justify-start text-center border text-xs   tracking-wider bg-[#E8E8E8]">
                            Sr. No
                          </div>
                          <div className="pl-sticky pl-sticky-group pl-sticky-header flex-shrink-0 w-40 px-3 py-2 flex gap-2  justify-between align-middle items-center text-center border text-xs tracking-wider capitalize bg-[#E8E8E8]">
                            Group Name
                            <div className="flex flex-col gap-y-1">
                              <div
                                className="cursor-pointer"
                                onClick={() =>
                                  sortAlphabetically("groupname", "az")
                                }
                              >
                                <ArrowDropUp
                                  color="white"
                                  sx={{ fontSize: "22px" }}
                                />
                              </div>

                              <div
                                className="cursor-pointer -mt-2"
                                onClick={() =>
                                  sortAlphabetically("groupname", "za")
                                }
                              >
                                <ArrowDropDown
                                  color="white"
                                  sx={{ fontSize: "22px" }}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="pl-sticky pl-sticky-client pl-sticky-header flex-shrink-0 w-40 px-3 py-2 flex gap-2  justify-between align-middle items-center text-center border text-xs tracking-wider capitalize bg-[#E8E8E8]">
                            Client Name
                            <div className="flex flex-col gap-y-1">
                              <div
                                className="cursor-pointer"
                                onClick={() =>
                                  sortAlphabetically("clientname", "az")
                                }
                              >
                                <ArrowDropUp
                                  color="white"
                                  sx={{ fontSize: "22px" }}
                                />
                              </div>

                              <div
                                className="cursor-pointer -mt-2"
                                onClick={() =>
                                  sortAlphabetically("clientname", "za")
                                }
                              >
                                <ArrowDropDown
                                  color="white"
                                  sx={{ fontSize: "22px" }}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="pl-sticky pl-sticky-project pl-sticky-header flex-shrink-0 w-40 px-3 py-2 flex gap-2  justify-between align-middle items-center text-center border text-xs tracking-wider capitalize bg-[#E8E8E8]">
                            Project Name
                            <div className="flex flex-col gap-y-1">
                              <div
                                className="cursor-pointer"
                                onClick={() =>
                                  sortAlphabetically("projectname", "az")
                                }
                              >
                                <ArrowDropUp
                                  color="white"
                                  sx={{ fontSize: "22px" }}
                                />
                              </div>

                              <div
                                className="cursor-pointer -mt-2"
                                onClick={() =>
                                  sortAlphabetically("projectname", "za")
                                }
                              >
                                <ArrowDropDown
                                  color="white"
                                  sx={{ fontSize: "22px" }}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="flex-shrink-0 w-40 px-3 py-2 gap-2 flex justify-center align-middle items-center text-center border text-xs tracking-wider capitalize bg-[#E8E8E8]">
                            Quoted Price({currency})
                            <div className="flex flex-col gap-y-1">
                              <div
                                className="cursor-pointer"
                                onClick={() => numericSort("za")}
                              >
                                <ArrowDropUp
                                  color="white"
                                  sx={{ fontSize: "22px" }}
                                />
                              </div>

                              <div
                                className="cursor-pointer -mt-2"
                                onClick={() => numericSort("az")}
                              >
                                <ArrowDropDown
                                  color="white"
                                  sx={{ fontSize: "22px" }}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="flex-shrink-0 w-40 px-3 py-2 flex justify-center align-middle items-center text-center border text-xs tracking-wider capitalize bg-[#E8E8E8]">
                            {selectedServiceTypes === "ERP" ? `Actual Expenses(${currency})` : `Quoted Expenses(${currency})`}
                          </div>
                          <div className="flex-shrink-0 w-40 px-3 py-2 flex justify-center align-middle items-center text-center border text-xs tracking-wider capitalize bg-[#E8E8E8]">
                            Gross Profit({currency})
                          </div>
                          <div className="flex-shrink-0 w-40 px-3 py-2 flex justify-center align-middle items-center text-center border text-xs tracking-wider capitalize bg-[#E8E8E8]">
                            G&A Expenses({currency})
                          </div>
                          {/* <div className="flex-shrink-0 w-24 px-3 py-3 flex justify-center align-middle items-center text-center border text-xs font-medium  tracking-wider capitalize bg-black">
                      EBIT ({currency})
                    </div> */}
                          <div className="flex-shrink-0 w-24 px-3 py-2 flex justify-center align-middle items-center text-center border text-xs tracking-wider capitalize bg-[#E8E8E8]">
                            Tax({currency})
                          </div>
                          <div className="flex-shrink-0 w-44 flex flex-col justify-center align-middle items-center text-center border text-xs tracking-wider capitalize bg-[#E8E8E8]">
                            <div className="h-[50%] w-full flex justify-center align-middle items-center"> Net Revenue</div>
                            <div className="h-[50%] flex w-full">
                              <div className="w-[50%] border flex justify-center align-middle items-center">({currency})</div>
                              <div className="w-[50%] border flex justify-center align-middle items-center">(%)</div>
                            </div>
                          </div>
                          <div className="flex-shrink-0 w-28 px-3 py-2 flex justify-center align-middle items-center text-center border text-xs tracking-wider capitalize bg-[#E8E8E8]">
                            Notes
                          </div>
                          <div className="flex-shrink-0 w-24 px-3 py-3 flex justify-center align-middle items-center text-center border text-xs tracking-wider capitalize bg-[#E8E8E8]">
                            Quotation

                          </div>
                        </div>
                        {/* for Only lead tracker */}
                        {selectedServiceTypes === "CRM" && (
                          <div className="w-full">
                            {
                              currentItems.length > 0 ? (
                                currentItems.map((row, index) => {
                                  const rowKey = getRowKey(row);
                                  return (
                                    <div
                                      key={rowKey || `${startIdx + index}`}
                                      className={`pl-pl-subrow w-full flex min-h-0 border-b items-stretch`}
                                    >
                                      <div className={`pl-sticky pl-sticky-sr pl-sticky-cell flex-shrink-0 w-10 px-3 py-3 flex items-center justify-start text-center border-b text-xs bg-white tracking-wider `}>
                                        {startIdx + index + 1}
                                      </div>
                                      <div
                                        title={getPlDisplayGroupName(row) || "Click To View Finance Details"}
                                        className={`pl-sticky pl-sticky-group pl-sticky-cell flex-shrink-0 w-40 px-3 py-3 flex justify-start align-middle items-center text-left border-b text-xs tracking-wider capitalize overflow-hidden whitespace-nowrap text-ellipsis`}
                                      >
                                        {getPlDisplayGroupName(row)}
                                      </div>
                                      <div
                                        title={row.ClientName || "Click To View Finance Details"}
                                        className={`pl-sticky pl-sticky-client pl-sticky-cell flex-shrink-0 w-40 px-3 py-2 flex justify-start align-middle items-center text-left bg-white border-b text-xs tracking-wider capitalize whitespace-normal break-words leading-4`}
                                      >
                                        {row.ClientName}
                                      </div>
                                      {/* Project Name */}
                                      <div
                                        title={row.ProjectName || "Click To View Finance Details"}
                                        className={`pl-sticky pl-sticky-project pl-sticky-cell flex-shrink-0 w-40 px-3 py-2 flex justify-start align-middle items-center text-left bg-white border-b text-xs tracking-wider capitalize whitespace-normal break-words leading-4`}
                                      >
                                        {row.ProjectName}
                                      </div>

                                      {/* Quoted Value Input - always editable */}
                                      <div className={`flex-shrink-0 w-40 p-2 gap-2 flex justify-center align-middle items-center text-center bg-white border-b text-xs tracking-wider capitalize `}>
                                        <input
                                            type="text"
                                            title="Enter Quoted Value"
                                            disabled={isViewOnlyPL}
                                            maxLength={14}
                                            className={`text-center h-full w-[70%] pl-2 outline-none rounded-md border ${isViewOnlyPL ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : "bg-[#cfecf7]"} border-black`}
                                            value={
                                              quotedValues[getRowKey(row)] !== undefined &&
                                                quotedValues[getRowKey(row)] !== null
                                                ? `${USAComma(quotedValues[getRowKey(row)])}`
                                                : `${USAComma(row.QuotedValue) || 0}`
                                            }
                                            onChange={(e) => {
                                              let rawValue = e.target.value.replace(/[^\d.]/g, "");
                                              const decimalParts = rawValue.split('.');
                                              if (decimalParts.length > 2) {
                                                rawValue = decimalParts[0] + '.' + decimalParts.slice(1).join('');
                                              }
                                              handleQuotedValueChange(row, rawValue);
                                            }}
                                            onFocus={(e) => {
                                              const val = e.target.value;
                                              if (val) {
                                                const numericValue = val.replace(/,/g, "").replace('$', '');
                                                e.target.value = `${currency}${numericValue}`;
                                              }
                                            }}
                                            onKeyDown={(e) => {
                                              if (e.key === 'Enter') {
                                                e.preventDefault();
                                                const val = e.target.value;
                                                const numericValue = val.replace(/,/g, "").replace('$', '');
                                                Submit(row, parseFloat(numericValue));
                                                e.target.blur();
                                              }
                                            }}
                                            onBlur={(e) => {
                                              const val = e.target.value;
                                              const numericValue = val ? parseFloat(val.replace(/,/g, "").replace('$', '')) : 0;
                                              if (!isNaN(numericValue)) {
                                                e.target.value = `${USAComma(numericValue)}`;
                                                setQuotedValues(prev => ({
                                                  ...prev,
                                                  [getRowKey(row)]: numericValue
                                                }));
                                                Submit(row, numericValue);
                                              }
                                            }}
                                          />
                                      </div>

                                      {/* Quoted Expenses Input */}
                                      <div className={`flex-shrink-0 w-40 p-2 flex justify-center align-middle items-center text-center bg-white border-b text-xs tracking-wider capitalize `}>
                                        <input
                                          type="text"
                                          title="Enter Quoted Expenses"
                                          disabled={isViewOnlyPL}
                                          maxLength={14}
                                          className={`text-center pl-2 h-full w-[70%] outline-none rounded-md border ${isViewOnlyPL ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : "bg-[#cfecf7]"} border-black`}
                                          value={
                                            quotedExpenseInputs[getStableLeadKey(row)] !== undefined &&
                                              quotedExpenseInputs[getStableLeadKey(row)] !== null
                                              ? // Show formatted value with commas by default
                                              `${USAComma(quotedExpenseInputs[getStableLeadKey(row)])}`
                                              : // For initial display, show without $ but with commas
                                              showExpenses(getRowKey(row)).replace("$", "")
                                          }
                                          onChange={(e) => {
                                            // Allow only numbers and decimal point, remove commas for processing
                                            const rawValue = e.target.value.replace(/[^0-9.]/g, "");
                                            handleQuotedExpensesChange(row, rawValue);
                                          }}
                                          onFocus={(e) => {
                                            // Remove commas when focused for editing
                                            const val = e.target.value;
                                            if (val) {
                                              e.target.value = val.replace(/,/g, "");
                                            }
                                          }}
                                          onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                              e.preventDefault();

                                              const val = e.target.value;
                                              const numericValue = val.replace(/,/g, "");

                                              SubmitQuotedExpenses(row, parseFloat(numericValue));
                                              e.target.blur();
                                            }
                                          }}
                                          onBlur={(e) => {
                                            // Add commas back when focus is lost and persist to API
                                            const val = e.target.value;
                                            const numericValue = val ? parseFloat(val.replace(/,/g, "")) : 0;
                                            if (!isNaN(numericValue)) {
                                              e.target.value = USAComma(numericValue);
                                              setQuotedExpenseInputs(prev => ({
                                                ...prev,
                                                [getStableLeadKey(row)]: numericValue
                                              }));
                                              SubmitQuotedExpenses(row, numericValue);
                                            }
                                          }}
                                        />
                                      </div>

                                      {/* Gross Profit */}
                                      <div
                                        className={`GrossProfit flex-shrink-0 w-40 px-3 py-3 flex justify-center align-middle items-center bg-white text-center border-b text-xs  tracking-wider capitalize text-wrap break-all
        ${calculateGrossProfitForLeadTecker(getRowKey(row)) < 0
                                            ? "text-red-500"
                                            : "text-green-500"
                                          }`}
                                      >
                                        {USAComma(calculateGrossProfitForLeadTecker(getRowKey(row)))}
                                      </div>

                                      {/* G&A Expenses */}
                                      <div
                                        className={`G&AExpenses flex-shrink-0 w-40 px-3 py-3 flex justify-center align-middle items-center bg-white text-center border-b text-xs  tracking-wider capitalize text-wrap break-all
        ${calculateGrossProfitForLeadTecker(getRowKey(row)) * (GandATax / 100) <
                                            0
                                            ? "text-red-500"
                                            : "text-black"
                                          } `}
                                      >

                                        {USAComma(
                                          calculateGrossProfitForLeadTecker(getRowKey(row)) * (GandATax / 100)
                                        )}
                                      </div>

                                      {/* EBIT */}
                                      {/* <div
                              className={`EBIT flex-shrink-0 w-24 px-3 py-3 flex justify-center align-middle items-center text-center border-b text-xs font-medium tracking-wider capitalize text-wrap break-all
        ${calculateGrossProfitForLeadTecker(getRowKey(row)) -
                                  calculateGrossProfitForLeadTecker(getRowKey(row)) *
                                  (GandATax / 100) <
                                  0
                                  ? "text-red-500"
                                  : "text-black"
                                }`}
                            >
                              $
                              {USAComma(
                                calculateGrossProfitForLeadTecker(getRowKey(row)) -
                                calculateGrossProfitForLeadTecker(getRowKey(row)) * (GandATax / 100)
                              )}
                            </div> */}

                                      {/* Tax — on EBIT (Gross Profit − G&A), not Gross Profit */}
                                      <div
                                        className={`Tax flex-shrink-0 w-24 px-3 py-3 flex justify-center align-middle items-center bg-white text-center border-b text-xs  tracking-wider capitalize text-wrap break-all 
        ${(calculateGrossProfitForLeadTecker(getRowKey(row)) -
                                            calculateGrossProfitForLeadTecker(getRowKey(row)) * (GandATax / 100)) *
                                            (taxValue / 100) <
                                            0
                                            ? "text-red-500"
                                            : "text-black"
                                          } `}
                                      >

                                        {USAComma(
                                          (calculateGrossProfitForLeadTecker(getRowKey(row)) -
                                            calculateGrossProfitForLeadTecker(getRowKey(row)) * (GandATax / 100)) *
                                          (taxValue / 100),
                                          { decimals: true }
                                        )}
                                      </div>

                                      {/* Net Revenue + Net Revenue Percentage */}
                                      <div
                                        className={`  flex-shrink-0 w-44 flex justify-center align-middle items-center text-center bg-white border-b text-xs  tracking-wider capitalize text-wrap break-all`}
                                      >
                                        {/* Net Revenue */}
                                        <div
                                          className={`NetRevenue w-[50%]  flex justify-center align-middle items-center text-wrap break-all
          ${(() => {
                                              const gp = calculateGrossProfitForLeadTecker(getRowKey(row));
                                              const ga = gp * (GandATax / 100);
                                              const tax = (gp - ga) * (taxValue / 100);
                                              return (gp - ga - tax) < 0 ? "text-red-500" : "text-black";
                                            })()
                                            }`}
                                        >

                                          {USAComma(
                                            (() => {
                                              const gp = calculateGrossProfitForLeadTecker(getRowKey(row));
                                              const ga = gp * (GandATax / 100);
                                              const tax = (gp - ga) * (taxValue / 100);
                                              return gp - ga - tax;
                                            })(),
                                            { decimals: true }
                                          )}
                                        </div>

                                        {/* Net Revenue % */}
                                        <div className={`NetRevenuePercentage w-[50%] flex justify-center align-middle items-center bg-white text-wrap break-all
  ${(() => {
                                            const gp = calculateGrossProfitForLeadTecker(getRowKey(row));
                                            const ga = gp * (GandATax / 100);
                                            const tax = (gp - ga) * (taxValue / 100);
                                            const netRev = gp - ga - tax;
                                            const denom = quotedValues[getRowKey(row)] || row.QuotedValue || 1;
                                            const pct = (netRev / denom) * 100;
                                            return pct < 0 ? "text-red-500" : pct < 10 ? "text-orange-600" : "text-black";
                                          })()
                                          }`}
                                        >
                                          {(() => {
                                            const denom = quotedValues[getRowKey(row)] ?? row.QuotedValue ?? 0;
                                            if (denom === 0) return "0.00";
                                            const gp = calculateGrossProfitForLeadTecker(getRowKey(row));
                                            const ga = gp * (GandATax / 100);
                                            const tax = (gp - ga) * (taxValue / 100);
                                            const netRev = gp - ga - tax;
                                            return ((netRev / denom) * 100).toFixed(2);
                                          })()}{" "}

                                        </div>
                                        {/* <div
                                className={`NetRevenuePercentage w-[50%] flex justify-center align-middle items-center text-wrap break-all
                                 ${(((calculateGrossProfitForLeadTecker(getRowKey(row)) -
                                    calculateGrossProfitForLeadTecker(getRowKey(row)) *
                                    (GandATax / 100) -
                                    calculateGrossProfitForLeadTecker(getRowKey(row)) *
                                    (taxValue / 100)) /
                                    calculateGrossProfitForLeadTecker(getRowKey(row))) *
                                    100) < 0
                                    ? "text-red-500"
                                    : "text-black"
                                  }`}
                              >
                                {(
                                  ((calculateGrossProfitForLeadTecker(getRowKey(row)) -
                                    calculateGrossProfitForLeadTecker(getRowKey(row)) *
                                    (GandATax / 100) -
                                    calculateGrossProfitForLeadTecker(getRowKey(row)) *
                                    (taxValue / 100)) /
                                    calculateGrossProfitForLeadTecker(getRowKey(row))) *
                                  100
                                ).toFixed(2)}{" "}
                                %
                              </div> */}
                                      </div>

                                      {/* Empty cell */}
                                      <div className={` flex-shrink-0 w-28 px-1 py-3 brack-all text-wrap flex justify-center bg-white align-middle items-center text-center border-b text-xs  tracking-wider capitalize`}>
                                        {/* <textarea
                                    className={`leadComments w-28 h-full outline-none text-center break-words whitespace-normal resize-none overflow-x-hidden bg-white`}
                                    value={comments[getRowKey(row)] || ""}
                                    onChange={(e) => handleCommentsChange(row, e.target.value)}
                                    placeholder="Enter Notes"
                                  /> */}
                                        <textarea
                                          placeholder="Enter Notes"
                                          disabled={isViewOnlyPL}
                                          value={comments[getRowKey(row)] || ""}
                                          className={`leadComments w-28 h-full outline-none text-center break-words whitespace-normal resize-none overflow-x-hidden bg-white ${isViewOnlyPL ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                                          onChange={(e) => handleCommentsChange(row, e.target.value)}
                                          onKeyDown={(e) => {
                                            if (e.key === 'Enter' && !e.shiftKey) {
                                              handleCommentsChange(row, e.target.value, e);
                                            }
                                          }}
                                        />
                                      </div>

                                      {/* Quotation button */}
                                      <div
                                        title={(row?.Status !== "Won" && row?.Status !== "Won Recurring") ? "Generate Quotation" : "Contract Executed"}
                                        onClick={() => {
                                          if (isViewOnlyPL) return;
                                          if (row?.Status !== "Won" && row?.Status !== "Won Recurring") {
                                            setShowQuoteModal(true);
                                            setSelectedProject(row);
                                          }
                                        }}
                                        disabled={row?.Status === "Won" || row?.Status === "Won Recurring"}
                                        className={` flex-shrink-0 ${(row?.Status === "Won" || row?.Status === "Won Recurring") ? "text-gray-400" : "cursor-pointer"} cursor-pointer w-24 px-3 py-3 flex justify-center align-middle items-center text-center bg-white border-b text-xs  tracking-wider capitalize ${isViewOnlyPL ? "opacity-50 cursor-not-allowed pointer-events-none" : ""}`}
                                      >
                                        <TextSnippetIcon className="w-5 h-5 " />
                                      </div>
                                    </div>
                                  );
                                })) : (
                                <div className="w-full bg-white flex h-10 border-b">
                                  <div className="w-full px-3 py-3 flex items-center justify-center text-center text-gray-500 text-sm font-semibold">
                                    No data found
                                  </div>
                                </div>
                              )}
                          </div>
                        )}

                        {/* for Both CRM and ERP */}
                        {selectedServiceTypes === "QuotedExpense" && (
                          <div className="w-full">
                            {currentItems?.length === 0 ? (
                              <div className="bg-white w-full flex justify-center items-center py-5">
                                <div className="text-red-500 text-lg font-semibold">
                                  No data available
                                </div>
                              </div>
                            ) : (
                              currentItems?.map((row, index) => {
                                const rowKey = getRowKey(row);
                                return (
                                  <div key={rowKey || `${startIdx + index}`} className={`CRMandERPtableone pl-pl-subrow w-full flex min-h-0 items-stretch`}>
                                    <div
                                      onClick={() => {
                                        if (isViewOnlyPL) return;
                                        setSelectedProjectName(row);
                                        setCalculationTable(true);
                                        handleTabClick("AllServiceTable")
                                      }}
                                      className={`pl-sticky pl-sticky-sr pl-sticky-cell flex-shrink-0 w-10 bg-white cursor-pointer px-3 py-3 flex items-center justify-start text-center border-b text-xs tracking-wider ${isViewOnlyPL ? "cursor-not-allowed pointer-events-none" : ""}`}>
                                      {startIdx + index + 1}
                                    </div>
                                    <div
                                      onClick={() => {
                                        if (isViewOnlyPL) return;
                                        setSelectedProjectName(row);
                                        setCalculationTable(true);
                                        handleTabClick("AllServiceTable")
                                      }} title={getPlDisplayGroupName(row) || "Click To View Finance Details"}
                                      className={`pl-sticky pl-sticky-group pl-sticky-cell flex-shrink-0 w-40 ${showExpensesop(getRowKey(row)) !== "0" ? "cursor-pointer" : ""} px-3 py-3 flex justify-start align-middle items-center text-left border-b text-xs tracking-wider capitalize overflow-hidden whitespace-nowrap text-ellipsis ${isViewOnlyPL ? "cursor-not-allowed pointer-events-none" : ""}`}
                                    >
                                      {getPlDisplayGroupName(row)}

                                    </div>
                                    <div
                                      onClick={() => {
                                        if (isViewOnlyPL) return;
                                        setSelectedProjectName(row);
                                        setCalculationTable(true);
                                        handleTabClick("AllServiceTable")
                                      }} title={row.ClientName || "Click To View Finance Details"}
                                      className={`pl-sticky pl-sticky-client pl-sticky-cell flex-shrink-0 w-40  bg-white cursor-pointer px-3 py-2 flex justify-start align-middle items-center text-left border-b text-xs tracking-wider capitalize whitespace-normal break-words leading-4 ${isViewOnlyPL ? "cursor-not-allowed pointer-events-none" : ""}`}
                                    >
                                      {row.ClientName}

                                    </div>
                                    <div
                                      onClick={() => {
                                        if (isViewOnlyPL) return;
                                        setSelectedProjectName(row);
                                        setCalculationTable(true);
                                        handleTabClick("AllServiceTable")
                                      }} title={row.ProjectName || "Click To View Finance Details"}
                                      className={`pl-sticky pl-sticky-project pl-sticky-cell flex-shrink-0 w-40 bg-white cursor-pointer px-3 py-2 flex justify-start align-middle items-center text-left border-b text-xs tracking-wider capitalize whitespace-normal break-words leading-4 ${isViewOnlyPL ? "cursor-not-allowed pointer-events-none" : ""}`}
                                    >
                                      {row.ProjectName}

                                    </div>
                                    <div className={` flex-shrink-0 w-40 p-2 gap-2 bg-white flex justify-center align-middle items-center text-start border-b text-xs tracking-wider capitalize `}>
                                      <input
                                        type="text"
                                        title="Enter Quoted Value"
                                        disabled={isViewOnlyPL}
                                        className={`text-center h-full w-[70%] pl-2 outline-none rounded-md border ${isViewOnlyPL ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : "bg-[#cfecf7]"} border-black`}
                                        maxLength={14}
                                          value={
                                            quotedValues[getRowKey(row)] !== undefined &&
                                              quotedValues[getRowKey(row)] !== null
                                              ? `${USAComma(quotedValues[getRowKey(row)])}`
                                              : `${USAComma(row.QuotedValue) || 0}`
                                          }
                                          onChange={(e) => {
                                            let rawValue = e.target.value.replace(/[^\d.]/g, "");
                                            const decimalParts = rawValue.split('.');
                                            if (decimalParts.length > 2) {
                                              rawValue = decimalParts[0] + '.' + decimalParts.slice(1).join('');
                                            }
                                            handleQuotedValueInputChange(row, rawValue);
                                          }}
                                          onFocus={(e) => {
                                            const val = e.target.value;
                                            if (val) {
                                              const numericValue = val.replace(/,/g, "").replace('$', '');
                                              e.target.value = `${currency}${numericValue}`;
                                            }
                                          }}
                                          onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                              e.preventDefault();
                                              const val = e.target.value;
                                              const numericValue = val.replace(/,/g, "").replace('$', '');
                                              Submit(row, parseFloat(numericValue));
                                              e.target.blur();
                                            }
                                          }}
                                          onBlur={(e) => {
                                            const val = e.target.value;
                                            const numericValue = val ? parseFloat(val.replace(/,/g, "").replace('$', '')) : 0;
                                            if (!isNaN(numericValue)) {
                                              e.target.value = `${USAComma(numericValue)}`;
                                              setQuotedValues(prev => ({
                                                ...prev,
                                                [getRowKey(row)]: numericValue
                                              }));
                                              Submit(row, numericValue);
                                            }
                                          }}
                                        />
                                    </div>

                                    <div
                                      onClick={() => {
                                        if (isViewOnlyPL) return;
                                        setSelectedProjectName(row);
                                        setCalculationTable(true);
                                        handleTabClick("AllServiceTable")
                                      }}
                                      className={`quotedExpense bg-white cursor-pointer relative group flex-shrink-0 w-40 px-3 py-3 flex justify-center align-middle items-center text-center border-b text-xs tracking-wider capitalize ${isViewOnlyPL ? "cursor-not-allowed pointer-events-none" : ""}`}>

                                      {showExpenses(getRowKey(row))}

                                    </div>
                                    <div
                                      onClick={() => {
                                        if (isViewOnlyPL) return;
                                        setSelectedProjectName(row);
                                        setCalculationTable(true);
                                        handleTabClick("AllServiceTable")
                                      }} className={`GrossProfit flex-shrink-0 w-40 bg-white cursor-pointer px-3 py-3 flex justify-center align-middle items-center text-center border-b text-xs tracking-wider capitalize text-wrap break-all 
    ${getRowTotals(row).grossProfit < 0 ? "text-red-500" : "text-green-500"} ${isViewOnlyPL ? "cursor-not-allowed pointer-events-none" : ""}`}
                                    >
                                      {USAComma(getRowTotals(row).grossProfit)}
                                    </div>
                                    <div
                                      onClick={() => {
                                        if (isViewOnlyPL) return;
                                        setSelectedProjectName(row);
                                        setCalculationTable(true);
                                        handleTabClick("AllServiceTable")
                                      }} className={`G&AExpenses flex-shrink-0 w-40 bg-white cursor-pointer px-3 py-3 flex justify-center align-middle items-center text-center border-b text-xs tracking-wider capitalize text-wrap break-all 
    ${getRowTotals(row).gaExpenses < 0 ? "text-red-500" : "text-black"} ${isViewOnlyPL ? "cursor-not-allowed pointer-events-none" : ""}`}
                                    >
                                      {USAComma(getRowTotals(row).gaExpenses)}
                                    </div>

                                    {/* <div
                              className={`EBIT flex-shrink-0 w-24 px-3 py-3 flex justify-center align-middle items-center text-center border text-xs font-medium tracking-wider capitalize text-wrap break-all

    ${calculateGrossProfit(getRowKey(row)) - (calculateGrossProfit(getRowKey(row)) * (GandATax / 100)) < 0 ? "text-red-500" : "text-black"}`}
                            >
                              ${USAComma(
                                calculateGrossProfit(getRowKey(row)) -
                                calculateGrossProfit(getRowKey(row)) * (GandATax / 100)
                              )}
                            </div> */}

                                    <div
                                      onClick={() => {
                                        if (isViewOnlyPL) return;
                                        setSelectedProjectName(row);
                                        setCalculationTable(true);
                                        handleTabClick("AllServiceTable")
                                      }}
                                      className={`Tax flex-shrink-0 w-24 bg-white cursor-pointer px-3 py-3 flex justify-center align-middle items-center text-center border-b text-xs tracking-wider capitalize text-wrap break-all
    
    ${getRowTotals(row).tax < 0 ? "text-red-500" : "text-black"} ${isViewOnlyPL ? "cursor-not-allowed pointer-events-none" : ""}`}
                                    >
                                      {USAComma(getRowTotals(row).tax, { decimals: true })}
                                    </div>

                                    <div
                                      onClick={() => {
                                        if (isViewOnlyPL) return;
                                        setSelectedProjectName(row);
                                        setCalculationTable(true);
                                        handleTabClick("AllServiceTable")
                                      }} className={`flex-shrink-0 w-44 flex bg-white cursor-pointer justify-center align-middle items-center text-center border-b text-xs tracking-wider capitalize text-wrap break-all ${isViewOnlyPL ? "cursor-not-allowed pointer-events-none" : ""}`}>
                                      <div
                                        className={`NetRevenue w-[50%]  flex justify-center align-middle items-center text-wrap break-all
    ${getRowTotals(row).netRevenue < 0 ? "text-red-500" : "text-black"}`}
                                      >
                                        {USAComma(getRowTotals(row).netRevenue, { decimals: true })}
                                      </div>

                                      <div
                                        className={`NetRevenuePercentage w-[50%] flex justify-center align-middle items-center text-wrap break-all
    ${getRowTotals(row).netRevenuePct < 0 ? "text-red-500" :
                                            getRowTotals(row).netRevenuePct < 10 ? "text-orange-600" :
                                              "text-black"}`}
                                      >
                                        {isFinite(getRowTotals(row).netRevenuePct) && !isNaN(getRowTotals(row).netRevenuePct)
                                          ? getRowTotals(row).netRevenuePct.toFixed(2)
                                          : "0"}
                                      </div>

                                    </div>
                                    <div
                                      className={`  flex-shrink-0 w-28 p-3 break-words text-wrap flex justify-center items-center text-center border-b text-xs tracking-wider bg-white capitalize`}
                                    >
                                      <textarea
                                        className={`leadComments w-28 h-full outline-none text-center break-words whitespace-normal resize-none overflow-x-hidden bg-white ${isViewOnlyPL ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                                        disabled={isViewOnlyPL}
                                        value={comments[getRowKey(row)] || ""}
                                        onChange={(e) => handleCommentsChange(row, e.target.value)}
                                        onKeyDown={(e) => {
                                          if (e.key === 'Enter' && !e.shiftKey) {
                                            handleCommentsChange(row, e.target.value, e);
                                          }
                                        }}
                                        placeholder="Enter Notes"
                                      />

                                    </div>

                                    <div
                                      title={(row?.Status !== "Won" && row?.Status !== "Won Recurring") ? "Generate Quotation" : "Contract Executed"}
                                      onClick={() => {
                                        if (isViewOnlyPL) return;
                                        if (row?.Status !== "Won" && row?.Status !== "Won Recurring") {
                                          setShowQuoteModal(true);
                                          setSelectedProject(row);
                                          setSelectedProjectName(row);
                                        }
                                      }}
                                      disabled={row?.Status === "Won" || row?.Status === "Won Recurring"}
                                      className={`flex-shrink-0 bg-white ${(row?.Status === "Won" || row?.Status === "Won Recurring") ? "text-gray-400" : "cursor-pointer"} w-24 px-3 py-3 flex justify-center align-middle items-center text-center border-b text-xs tracking-wider capitalize ${isViewOnlyPL ? "opacity-50 cursor-not-allowed pointer-events-none" : ""}`}>
                                      <TextSnippetIcon className="w-5 h-5 "
                                      />
                                    </div>
                                  </div>
                                );
                              }))}
                          </div>
                        )}
                      </div>


                    </div>
                  )}

                  <div className="pagination border flex justify-between items-center bg-white mb-2 pt-2 pb-2 p-1 rounded-b-md">
                    <div>
                      {totalItems > 0 ? (
                        <>
                          Showing {startIdx + 1} to {Math.min(endIdx, totalItems)}{" "}
                          of {totalItems} Entries
                        </>
                      ) : (
                        <>Showing 0 Entries</>
                      )}
                    </div>
                    {totalPages > 1 && (
                      <div>
                        <button
                          onClick={() => setCurrentPage(1)}
                          className="px-2 py-2 mx-1 border rounded"
                          disabled={currentPage === 1}
                          title="First Page"
                        >
                          <KeyboardDoubleArrowLeftIcon className="w-5 h-5" />
                        </button>
                        <button
                          onClick={() =>
                            setCurrentPage((prev) => Math.max(prev - 1, 1))
                          }
                          className="px-2 py-2 mx-2 border rounded"
                          disabled={currentPage === 1}
                        >
                          <ChevronRightIcon className="w-5 h-5 rotate-180" />

                          {/* Previous */}
                        </button>

                        {Array.from({ length: 3 }, (_, index) => {
                          // Calculate the page number for the current range
                          const pageNumber = currentPage - 1 + index;

                          // Ensure the pageNumber stays within bounds
                          if (pageNumber >= 1 && pageNumber <= totalPages) {
                            return (
                              <button
                                key={pageNumber}
                                onClick={() => setCurrentPage(pageNumber)}
                                className={`px-4 py-2 mx-2 border rounded ${currentPage === pageNumber ? "bg-gray-300" : ""
                                  }`}
                              >
                                {pageNumber}
                              </button>
                            );
                          }

                          // Return null for out-of-bounds values
                          return null;
                        })}

                        <button
                          onClick={() =>
                            setCurrentPage((prev) =>
                              Math.min(prev + 1, totalPages)
                            )
                          }
                          className="px-2 py-2 mx-2 border rounded"
                          disabled={currentPage === totalPages}
                        >
                          <ChevronRightIcon className="w-5 h-5" />

                          {/* Next */}
                        </button>

                        <button
                          onClick={() => setCurrentPage(totalPages)}
                          className="px-2 py-2 mx-1 border rounded"
                          disabled={currentPage === totalPages}
                          title="Last Page"
                        >
                          <KeyboardDoubleArrowRightIcon className="w-5 h-5" />
                        </button>
                      </div>
                    )}
                  </div>


                  {calculationTable && (
                    (selectedTab === "AllServiceTable" && selectedServiceTypes === "QuotedExpense") && (
                      <div className="mb-2" ref={AllServiceTableScrollRef}>
                        <div className="bg-white rounded-md">
                          <AllServiceTable
                            ref={AllServiceTableRef}
                            handlerefresh={handlerefresh}
                            filteredQuotation={filteredQuotation}
                            selectedProject={selectedProjectName}
                            projects={projects}
                            calculatedProjects={calculatedProjects}
                            handleAccociatedTabClick={handleAccociatedTabClick}
                            setinstallationPersons={setinstallationPersons}
                            setSoftwarePersons={setSoftwarePersons}
                            setCloudPersons={setCloudPersons}
                            setHardwarePersons={setHardwarePersons}
                            tasks={tasksForPlTables}
                            items={items}
                            onTableServiceTotalsChange={setTableServiceTotals}
                            onTotalCostPerServiceTotalChange={handleTotalCostPerServiceTotalChange}
                            onItemizedTotalsChange={handleItemizedTotalsChange}
                            projectLevelTotals={projectLevelTotals}
                          />
                        </div>

                        {/* For Hardware */}
                        {HardwarePersons.length ? (
                          <div className="bg-white mt-2 rounded-md">
                            <HardwareTypeServiceTable items={items} AssociatedRef={AssociatedRef} currentPerson={HardwarePersons} filteredQuotation={filteredQuotation} matchedProjects={matchedProjects} tasks={tasksForPlTables} selectedProject={selectedProjectName} />
                          </div>
                        ) : (
                          <> </>
                        )}
                        {/* For Installation */}
                        {(installtionPersons.length) ? (
                          <div className="bg-white mt-2 rounded-md">
                            <SalesFinanceEfforts
                              tasks={tasksForPlTables}
                              AssociatedRef={AssociatedRef}
                              currentPerson={installtionPersons}
                              filteredQuotation={filteredQuotation}
                              matchedProjects={matchedProjects}
                              perdiemRate={perdiem}
                              averageCostRate={averagecost}
                            />
                          </div>
                        ) : (
                          <> </>
                        )}
                        {/* For software */}
                        {SoftwarePersons.length ? (
                          <div className="bg-white mt-2 rounded-md">
                            <SoftwareTypeServiceTable AssociatedRef={AssociatedRef} currentPerson={SoftwarePersons} filteredQuotation={filteredQuotation} matchedProjects={matchedProjects} tasks={tasksForPlTables} />
                          </div>
                        ) : (
                          <> </>
                        )}
                        {/* for  Cloud  */}
                        {CloudPersons.length ? (
                          <div className="bg-white mt-2 rounded-md">

                            <SoftwareTypeServiceTable AssociatedRef={AssociatedRef} currentPerson={CloudPersons} filteredQuotation={filteredQuotation} matchedProjects={matchedProjects} tasks={tasksForPlTables} />
                          </div>
                        ) : (
                          <> </>
                        )}
                      </div>
                    )
                  )}
                </div>
              </>
            )}

            <div ref={ActualRef} style={{ display: (financeTab === "table" && showTable === "Actual") ? undefined : "none" }}>
              <ActualFinaceTable searchedLeadReportswithoutyears={searchedLeadReportswithoutyears} showTable={showTable} searchedLeadReports={searchedLeadReports} onActualDataReady={handleActualDataReady} onActualExpenseByRowKeyReady={handleActualExpenseByRowKeyReady} isViewOnly={isViewOnlyPL} parentQuotedValues={quotedValues} rowMetricsSyncLeads={isErpPackage ? profitAndLossLeadsSource : null} />
            </div>
              </>
            )}

            {canSeeGrossProfitSection && (
              <FinanceGraph
                currentEmployee={currentEmployee}
                perdiem={perdiem}
                averagecost={averagecost}
                actualPlCardTotals={actualPlCardTotals}
                gpLeadsUniverse={isCrmPackage ? profitAndLossLeadsSource : undefined}
                crmQuotedPlTaxNetByYearForGpCards={crmQuotedPlTaxNetByYearForGpCards}
                plGetRowGrossProfit={
                  isCrmPackage
                    ? (row) =>
                        Number(
                          calculateGrossProfitIndependentOfPlFilters(
                            getRowKey(row),
                            row
                          )
                        ) || 0
                    : undefined
                }
                plGandATax={isCrmPackage || isErpPackage ? GandATax : undefined}
                plTaxPct={isCrmPackage || isErpPackage ? taxValue : undefined}
                erpPlShowActualExpenseForRow={
                  isErpPackage ? erpPlShowActualExpenseForRow : undefined
                }
                erpPlHasActualExpenseForRow={
                  isErpPackage ? erpPlHasActualExpenseForRow : undefined
                }
                erpPlShowActualQuotedValueForRow={
                  isErpPackage ? erpPlShowActualQuotedValueForRow : undefined
                }
                // Gross Profit tracker filters must be independent from P&L tracker filters.
                // We only pass the per-row P&L expense accessor (source of truth for quoted expenses),
                // not the P&L-filtered aggregate totals.
                // ERP only: Gross Profit Cost comes from the P&L quoted-expense accessor.
                // CRM must remain fully independent from P&L filter state.
                // ERP: use full accessor (includes itemized fallbacks).
                // CRM: use stable map-based accessor so P&L filters can’t affect Gross Profit.
                erpPlShowQuotedExpenseForRow={
                  isErpPackage ? showExpensesForGrossProfit : showCrmQuotedExpenseForGrossProfit
                }
                // ERP Quoted GP: same universe as Quoted P&L, excluding direct-won (Actual-only) leads.
                plLeadsUniverse={
                  isErpPackage
                    ? (Array.isArray(profitAndLossLeadsSource)
                        ? profitAndLossLeadsSource.filter((lead) => {
                            if (!routeDirectWonToActualTab) return true;
                            const key = getRowKey(lead);
                            const expenseAccessor =
                              typeof showExpensesForGrossProfit === "function"
                                ? showExpensesForGrossProfit
                                : showExpensesop;
                            const parsedDisplayed = parseFloat(
                              String(expenseAccessor(key) ?? "0").replace(/[,$]/g, "")
                            );
                            const displayedExpense = Number.isFinite(parsedDisplayed)
                              ? parsedDisplayed
                              : getLeadQuotedExpenseNum(lead);
                            return !isDirectWonLead(lead, projects, {
                              quotedExpenseNum: displayedExpense,
                            });
                          })
                        : undefined)
                    : undefined
                }
                // ERP Actual GP: full P&L universe — direct-won leads must appear (same as Actual P&L table).
                plActualLeadsUniverse={
                  isErpPackage ? profitAndLossLeadsSource : undefined
                }
                // CRM: Quoted Price for Gross Profit — quotedPrice, then quotedValues map.
                // Never fall back to lead.QuotedValue (API aggregate inflates Value ~₹1.15Cr).
                plGetQuotedValueForRow={selectedServiceTypes === "CRM" ? ((row) => {
                  return resolveCrmQuotedPriceForGrossProfit(row, getRowKey(row));
                }) : undefined}
                plGetQuotedExpenseForRow={selectedServiceTypes === "CRM" ? ((row) => {
                  const key = getRowKey(row);
                  const s = String(showCrmQuotedExpenseForGrossProfit(key) ?? "0");
                  const num = parseFloat(s.replace(/,/g, "").replace(/[^\d.-]/g, "")) || 0;
                  return num;
                }) : undefined}
              />
            )}


            {/* {financeTab === "totalgraph" && ( */}

            {/* )} */}
            {/* {financeTab === "graph" && <SalesPiechart />} */}

            {canSeeProfitAndLossSection && showQuoteModal && (
              <Quotation financeDataProject={financeDataProject} tasks={tasks} selectedServiceTypes={selectedServiceTypes} selectedlead={selectedProject} items={items} filteredQuotation={filteredQuotation} selectedGroup={selectedProject ? (getPlDisplayGroupName(selectedProject) || selectedProject.AssignedGroup || "") : ""} selectedProject={selectedProject.ProjectName} setShowQuoteModal={setShowQuoteModal} tableServiceTotals={tableServiceTotals} canCreateQuotation={canCreateQuotation} canDownloadQuotation={canDownloadQuotation} canSendQuotation={canSendQuotation} />
            )}
            <div></div>
          </div>
        </div>
      </>
    )
  );
};

export default SalesFinaceFilter;